// Auto-generated comprehensive i18n catalog. 14 idiomas, ~190 claves cada uno.
// Si una clave falta, fallback a español.

export type Locale = 'es' | 'en' | 'pt' | 'fr' | 'it' | 'de' | 'nl' | 'pl' | 'cs' | 'hu' | 'ro' | 'el' | 'ru' | 'uk';

export const LOCALES: Array<{ code: Locale; native: string; flag: string }> = [
  { code: 'es', native: "Español", flag: "🇪🇸" },
  { code: 'en', native: "English", flag: "🇬🇧" },
  { code: 'pt', native: "Português", flag: "🇵🇹" },
  { code: 'fr', native: "Français", flag: "🇫🇷" },
  { code: 'it', native: "Italiano", flag: "🇮🇹" },
  { code: 'de', native: "Deutsch", flag: "🇩🇪" },
  { code: 'nl', native: "Nederlands", flag: "🇳🇱" },
  { code: 'pl', native: "Polski", flag: "🇵🇱" },
  { code: 'cs', native: "Čeština", flag: "🇨🇿" },
  { code: 'hu', native: "Magyar", flag: "🇭🇺" },
  { code: 'ro', native: "Română", flag: "🇷🇴" },
  { code: 'el', native: "Ελληνικά", flag: "🇬🇷" },
  { code: 'ru', native: "Русский", flag: "🇷🇺" },
  { code: 'uk', native: "Українська", flag: "🇺🇦" },
];

type Catalog = Record<string, string>;

const es: Catalog = {
  "common.cancel": "Cancelar",
  "common.save": "Guardar",
  "common.confirm": "Confirmar",
  "common.close": "Cerrar",
  "common.add": "Añadir",
  "common.back": "Volver",
  "common.tagline": "Si no conoces la frecuencia, la conversación no existe.",
  "auth.tagline": "Mensajería privada por frecuencia",
  "auth.loading": "Cargando…",
  "auth.savedSession": "Hay una sesión guardada en este dispositivo.",
  "auth.tab.login": "Entrar",
  "auth.tab.register": "Crear cuenta",
  "auth.field.devicePin": "PIN del dispositivo",
  "auth.field.username": "Usuario",
  "auth.field.password": "Contraseña",
  "auth.btn.unlock": "Desbloquear",
  "auth.btn.unlocking": "Desbloqueando…",
  "auth.btn.processing": "Procesando…",
  "auth.btn.useOther": "Usar otra cuenta",
  "auth.btn.forget": "Olvidar este dispositivo",
  "auth.btn.backToUnlock": "Volver al desbloqueo",
  "auth.confirmForget": "¿Olvidar este dispositivo? Se borrará la sesión guardada y los mensajes en caché.",
  "auth.error.userExists": "Ese usuario ya existe. Elige otro.",
  "auth.error.badCreds": "Usuario o contraseña incorrectos.",
  "auth.error.userNotFound": "Usuario no encontrado.",
  "auth.error.cantConnect": "No se pudo conectar al servidor.",
  "auth.error.badPin": "PIN incorrecto.",
  "auth.footnote": "Cifrado E2E con NaCl box. Frecuencias: Argon2id + HMAC determinista.",
  "sidebar.general": "Frecuencia general",
  "sidebar.freq": "Frecuencia {0}",
  "sidebar.tune": "Sintonizar frecuencia",
  "sidebar.exitFreq": "Salir de {0}",
  "sidebar.notifications": "Notificaciones",
  "sidebar.remember": "Recordar dispositivo",
  "sidebar.forget": "Olvidar dispositivo",
  "sidebar.addContact": "Añadir contacto por syphrax id",
  "sidebar.newGroup": "Nuevo grupo",
  "sidebar.settings": "Ajustes",
  "sidebar.logout": "Salir",
  "sidebar.tooltip.logout": "Cerrar sesión y borrar todo lo local",
  "sidebar.savedFreq.tooltip": "Sintonizar {0}",
  "chat.empty": "Selecciona o añade un contacto",
  "welcome.title": "Bienvenido a Syphrax",
  "welcome.concept": "Syphrax es mensajería privada basada en frecuencias. Una frecuencia es una clave secreta que tú y la persona con la que hablas conocéis. Sin esa clave, la conversación no existe — ni siquiera la plataforma puede reconstruirla.",
  "welcome.step1": "Sintoniza una frecuencia compartida con la persona o el grupo con quien quieras hablar.",
  "welcome.step2": "Añade su syphrax_id como contacto, o pídele que añada el tuyo.",
  "welcome.step3": "Empieza a escribir. Solo quien tenga la misma frecuencia podrá leer los mensajes.",
  "welcome.multidevice": "Cada dispositivo mantiene sus frecuencias y mensajes de forma independiente. Si entras desde otro dispositivo tendrás que sintonizar las frecuencias de nuevo.",
  "welcome.btnFreq": "Sintonizar frecuencia",
  "welcome.btnContacts": "Añadir contacto",
  "push.btnOn": "Notificaciones ON",
  "push.btnOff": "Notificaciones OFF",
  "push.btnEnable": "Notificaciones desactivadas. Pulsar para activar.",
  "push.btnDisable": "Notificaciones activadas. Pulsar para desactivar.",
  "push.introTitle": "Antes de activar las notificaciones",
  "push.introBody": "Por privacidad, las notificaciones de Syphrax son distintas a las de otras apps de mensajería:",
  "push.introBullet1": "No se incluye el contenido del mensaje.",
  "push.introBullet2": "No se muestra el nombre ni el syphrax_id del emisor.",
  "push.introBullet3": "Solo recibirás un aviso de \"mensaje nuevo\" para abrir la app y leerlo cifrado en tu dispositivo.",
  "push.introConfirm": "Activar notificaciones",
  "chat.placeholder": "Escribe un mensaje…",
  "chat.editPlaceholder": "Edita tu mensaje…",
  "chat.replyingTo": "Respondiendo a {0}",
  "chat.editing": "Editando mensaje",
  "chat.confirmContact": "Añadir a contactos",
  "chat.unconfirmedBanner": "Este usuario te ha escrito pero no está en tus contactos. Hasta que lo añadas, tu foto e info no le serán visibles según tus ajustes de privacidad.",
  "chat.online": "en línea",
  "chat.lastSeen": "última vez aquí {0}",
  "chat.tooltip.attach": "Adjuntar archivo",
  "chat.tooltip.shareContact": "Compartir contacto",
  "chat.tooltip.paste": "Pegar imagen del portapapeles",
  "chat.tooltip.stickers": "Stickers",
  "chat.tooltip.callAudio": "Llamada de voz",
  "chat.tooltip.callVideo": "Videollamada",
  "chat.btn.send": "Enviar",
  "chat.uploading": "…",
  "preview.image": "📷 Imagen",
  "preview.video": "🎬 Vídeo",
  "preview.audio": "🎙 Audio",
  "bubble.reply": "Responder",
  "bubble.edit": "Editar",
  "bubble.edited": "editado",
  "bubble.contact.label": "Contacto Syphrax",
  "bubble.media.decrypting": "Descifrando…",
  "bubble.media.failed": "No se pudo descifrar el archivo.",
  "call.calling": "Llamando…",
  "call.incoming.audio": "Llamada entrante",
  "call.incoming.video": "Videollamada entrante",
  "call.connecting": "Conectando…",
  "call.ending": "Finalizando…",
  "call.accept": "Aceptar",
  "call.reject": "Rechazar",
  "call.hangup": "Colgar",
  "call.mic": "Micrófono",
  "call.camera": "Cámara",
  "call.audioOut": "Salida de audio",
  "call.audioOut.auto": "Auto",
  "call.error.notInFreq": "Para llamar debes estar sintonizado en una frecuencia.",
  "error.notFound": "No se encontró el recurso.",
  "error.notInFreq": "{0} no ha sintonizado aún esta frecuencia. Pídele por otro canal que la sintonice.",
  "error.push.iosTooOld": "Tu iOS es anterior a 16.4. Actualízalo para recibir notificaciones.",
  "error.push.iosNotStandalone": "Para recibir notificaciones en iPhone instala Syphrax en la pantalla de inicio: pulsa Compartir → Añadir a pantalla de inicio.",
  "error.expired": "Sesión caducada. Vuelve a entrar.",
  "error.gone": "El archivo ha caducado.",
  "error.invalid": "Datos no válidos.",
  "error.server": "Error del servidor. Inténtalo de nuevo.",
  "error.network": "Sin conexión con el servidor.",
  "error.cantStartCall": "No se pudo iniciar la llamada: {0}",
  "error.cantAcceptCall": "No se pudo aceptar la llamada: {0}",
  "error.cantPaste": "No se pudo acceder al portapapeles. Prueba a usar el botón de adjuntar.",
  "error.noImageInClipboard": "No hay ninguna imagen en el portapapeles.",
  "error.clipboardUnsupported": "Tu navegador no permite leer el portapapeles. Pega con Ctrl+V o usa el botón de adjuntar.",
  "error.selfContact": "No puedes añadirte a ti mismo.",
  "error.blocked": "Has bloqueado a este usuario. Desbloquéalo en Ajustes para volver a hablarle.",
  "settings.title": "Ajustes",
  "settings.close": "Cerrar",
  "settings.tab.profile": "👤 Perfil",
  "settings.tab.privacy": "🔒 Privacidad",
  "settings.tab.messages": "✉ Mensajes",
  "settings.tab.blocked": "🚫 Bloqueados",
  "settings.tab.notifications": "🔔 Notificaciones",
  "settings.tab.session": "⏱ Sesión",
  "settings.tab.account": "🆔 Cuenta",
  "settings.tab.language": "🌐 Idioma",
  "settings.tab.about": "ℹ Acerca de",
  "settings.scope.global": "Global (frecuencia general)",
  "settings.scope.freq": "Solo en {0}",
  "settings.profile.title": "Perfil",
  "settings.profile.hintGlobal": "Estos valores se usan por defecto y se heredan en todas las frecuencias.",
  "settings.profile.hintFreq": "Sobreescriben el perfil global cuando estás en {0}. Si no defines algo aquí, se hereda del global.",
  "settings.profile.displayName": "Nombre mostrado",
  "settings.profile.displayNamePh.global": "(sin nombre — se mostrará tu syphrax id)",
  "settings.profile.displayNamePh.freq": "(hereda del global)",
  "settings.profile.photo": "Foto de perfil",
  "settings.profile.changePhoto": "Cambiar foto",
  "settings.profile.removePhoto": "Quitar foto",
  "settings.profile.info": "Info / Estado",
  "settings.profile.infoPh": "Hola, uso Syphrax",
  "settings.profile.removeOverride": "Eliminar override de {0}",
  "settings.profile.warn": "Los cambios se enviarán al resto de tus contactos automáticamente cuando interactúes con ellos en esta frecuencia.",
  "settings.privacy.title": "Privacidad",
  "settings.privacy.hintGlobal": "Configura quién puede ver cada información tuya por defecto.",
  "settings.privacy.hintFreq": "Sobreescribe estas reglas solo cuando estás en {0}.",
  "settings.privacy.showPhoto": "Quién ve mi foto",
  "settings.privacy.showInfo": "Quién ve mi info / estado",
  "settings.privacy.showLastSeen": "Quién ve mi última conexión",
  "settings.privacy.showOnline": "Quién ve si estoy en línea",
  "settings.privacy.whoAdds": "Quién puede añadirme a grupos",
  "settings.privacy.readReceipts": "Confirmaciones de lectura",
  "settings.privacy.readReceiptsHint": "Si lo desactivas, no se envían tics azules cuando lees mensajes. Tampoco verás los de los demás.",
  "settings.vis.all": "Todos",
  "settings.vis.contacts": "Mis contactos",
  "settings.vis.none": "Nadie",
  "settings.messages.title": "Mensajes",
  "settings.messages.ttl": "Caducidad por defecto",
  "settings.messages.ttlHint": "Los mensajes que envíes se borrarán del servidor pasado este tiempo. Puedes elegir un valor distinto al adjuntar un archivo.",
  "settings.blocked.title": "Bloqueados",
  "settings.blocked.hint": "Los usuarios bloqueados no pueden enviarte mensajes. Tampoco se les pueden enviar.",
  "settings.blocked.placeholder": "syphrax id a bloquear",
  "settings.blocked.btn": "Bloquear",
  "settings.blocked.unblock": "Desbloquear",
  "settings.blocked.empty": "No tienes a nadie bloqueado.",
  "settings.notif.title": "Notificaciones",
  "settings.notif.sound": "Sonido",
  "settings.notif.preview": "Mostrar preview del mensaje",
  "settings.notif.vibration": "Vibración (móvil)",
  "settings.notif.hint": "Las notificaciones push del navegador solo se emiten para mensajes en frecuencia general, sin contenido ni nombre del emisor (por diseño).",
  "settings.session.title": "Sesión",
  "settings.session.timeout": "Cerrar la frecuencia tras inactividad",
  "settings.session.timeoutHint": "Si pasas este tiempo sin tocar la app, la frecuencia activa se desactiva automáticamente y vuelves a la frecuencia general. \"Nunca\" mantiene la frecuencia hasta que cierres la app.",
  "settings.session.remember": "Recordar frecuencias usadas",
  "settings.session.rememberHint": "Si lo activas, las frecuencias que sintonizas aparecen como atajos en la barra lateral. Cualquiera que vea tu pantalla podrá saber en qué frecuencias has entrado, así que está desactivado por defecto. Al apagarlo se borran las que ya estaban guardadas.",
  "settings.account.title": "Cuenta",
  "settings.account.idLabel": "Tu syphrax id",
  "settings.account.email": "Email opcional (solo se usa para recuperación, nunca se publica)",
  "settings.account.emailPh": "email@ejemplo.com",
  "settings.account.changePassword": "Cambiar contraseña",
  "settings.account.currentPw": "Contraseña actual",
  "settings.account.newPw": "Nueva contraseña (mín. 8)",
  "settings.account.confirmPw": "Repite la nueva",
  "settings.account.saving": "Guardando…",
  "settings.account.success": "Contraseña actualizada.",
  "settings.account.errPwBad": "La contraseña actual no es correcta.",
  "settings.account.errPwShort": "La nueva contraseña debe tener al menos 8 caracteres.",
  "settings.account.errPwMismatch": "Las contraseñas no coinciden.",
  "settings.language.title": "Idioma",
  "settings.language.hint": "Elige el idioma de la interfaz. Tu preferencia se guarda en este dispositivo y, si tienes el vault activado, también en tu sesión.",
  "settings.about.title": "Acerca de Syphrax",
  "settings.about.version": "Versión MVP en desarrollo.",
  "settings.about.tech": "Cifrado E2E con NaCl box (X25519). Frecuencias: derivación Argon2id + HMAC determinista. Persistencia local cifrada con Argon2id sobre PIN.",
  "modal.freq.title": "Sintonizar frecuencia",
  "modal.freq.hint": "Introduce la cadena secreta de la frecuencia. Solo verás y podrás hablar con quien también la tenga activa.",
  "modal.freq.placeholder": "ALFA2025",
  "modal.freq.activate": "Activar",
  "modal.freq.deriving": "Derivando clave…",
  "modal.freq.warn": "Si olvidas esta cadena, perderás acceso a las conversaciones de esta frecuencia. No se almacena en ningún sitio.",
  "modal.freq.errShort": "La frecuencia debe tener al menos 8 caracteres.",
  "modal.freq.errCommon": "Esa cadena es demasiado común. Elige algo único.",
  "modal.freq.errRepeat": "No uses un solo carácter repetido.",
  "modal.freq.errSeqNum": "Evita secuencias numéricas obvias.",
  "modal.freq.errSeqAlpha": "Evita secuencias del alfabeto.",
  "modal.share.title": "Compartir contacto",
  "modal.share.hint": "Elige un contacto de la lista o introduce un syphrax id manualmente.",
  "modal.share.filter": "Filtrar contactos…",
  "modal.share.empty": "Sin contactos en esta frecuencia",
  "modal.share.manual": "O un syphrax id manual",
  "modal.share.btn": "Compartir",
  "modal.group.title": "Nuevo grupo",
  "modal.group.hint": "Elige un nombre y selecciona miembros entre tus contactos en esta frecuencia.",
  "modal.group.namePh": "Nombre del grupo",
  "modal.group.selected": "{0} seleccionados",
  "modal.group.create": "Crear grupo",
  "modal.remember.title": "Recordar este dispositivo",
  "modal.remember.hint": "Se guardarán tu sesión, contactos, grupos y mensajes en este dispositivo, cifrados con un PIN que solo tú conoces. Al reabrir la app introducirás el PIN para desbloquear.",
  "modal.remember.pin": "PIN",
  "modal.remember.confirm": "Repite el PIN",
  "modal.remember.warn": "Si olvidas el PIN, los datos guardados no se podrán recuperar. Tendrás que entrar de nuevo con tu usuario y contraseña.",
  "modal.remember.errShort": "El PIN debe tener al menos 4 caracteres.",
  "modal.remember.errMismatch": "Los PINs no coinciden.",
  "stickers.faces": "Caras",
  "stickers.gestures": "Gestos",
  "stickers.hearts": "Corazones",
  "stickers.symbols": "Símbolos",
  "stickers.animals": "Animales",
  "stickers.food": "Comida",
  "ttl.1h": "1 hora",
  "ttl.1d": "1 día",
  "ttl.1w": "1 semana",
  "ttl.1m": "1 mes",
  "ttl.6m": "6 meses",
  "ttl.12m": "12 meses",
  "timeout.5min": "5 min",
  "timeout.15min": "15 min",
  "timeout.30min": "30 min",
  "timeout.never": "Nunca",
  "toast.newMessage": "Mensaje nuevo",
  "toast.group": "{0} (grupo)",
};

const en: Catalog = {
  "common.cancel": "Cancel",
  "common.save": "Save",
  "common.confirm": "Confirm",
  "common.close": "Close",
  "common.add": "Add",
  "common.back": "Back",
  "common.tagline": "If you don't know the frequency, the conversation does not exist.",
  "auth.tagline": "Private messaging by frequency",
  "auth.loading": "Loading…",
  "auth.savedSession": "There is a saved session on this device.",
  "auth.tab.login": "Sign in",
  "auth.tab.register": "Create account",
  "auth.field.devicePin": "Device PIN",
  "auth.field.username": "Username",
  "auth.field.password": "Password",
  "auth.btn.unlock": "Unlock",
  "auth.btn.unlocking": "Unlocking…",
  "auth.btn.processing": "Processing…",
  "auth.btn.useOther": "Use another account",
  "auth.btn.forget": "Forget this device",
  "auth.btn.backToUnlock": "Back to unlock",
  "auth.confirmForget": "Forget this device? The saved session and cached messages will be deleted.",
  "auth.error.userExists": "That user already exists. Choose another.",
  "auth.error.badCreds": "Wrong username or password.",
  "auth.error.userNotFound": "User not found.",
  "auth.error.cantConnect": "Could not connect to the server.",
  "auth.error.badPin": "Wrong PIN.",
  "auth.footnote": "E2E encryption with NaCl box. Frequencies: Argon2id + deterministic HMAC.",
  "sidebar.general": "General frequency",
  "sidebar.freq": "Frequency {0}",
  "sidebar.tune": "Tune frequency",
  "sidebar.exitFreq": "Leave {0}",
  "sidebar.notifications": "Notifications",
  "sidebar.remember": "Remember device",
  "sidebar.forget": "Forget device",
  "sidebar.addContact": "Add contact by Syphrax ID",
  "sidebar.newGroup": "New group",
  "sidebar.settings": "Settings",
  "sidebar.logout": "Sign out",
  "sidebar.tooltip.logout": "Sign out and erase local data",
  "sidebar.savedFreq.tooltip": "Tune {0}",
  "chat.empty": "Select or add a contact",
  "welcome.title": "Welcome to Syphrax",
  "welcome.concept": "Syphrax is private messaging based on frequencies. A frequency is a secret key that you and the person you talk to both know. Without that key, the conversation does not exist — not even the platform can rebuild it.",
  "welcome.step1": "Tune in to a frequency shared with the person or group you want to talk to.",
  "welcome.step2": "Add their syphrax_id as a contact, or ask them to add yours.",
  "welcome.step3": "Start writing. Only those who share the same frequency can read the messages.",
  "welcome.multidevice": "Each device keeps its own frequencies and messages independently. If you sign in from another device, you'll need to tune in to the frequencies again.",
  "welcome.btnFreq": "Tune in to a frequency",
  "welcome.btnContacts": "Add contact",
  "push.btnOn": "Notifications ON",
  "push.btnOff": "Notifications OFF",
  "push.btnEnable": "Notifications disabled. Click to enable.",
  "push.btnDisable": "Notifications enabled. Click to disable.",
  "push.introTitle": "Before enabling notifications",
  "push.introBody": "For privacy, Syphrax notifications work differently from other messaging apps:",
  "push.introBullet1": "The message content is not included.",
  "push.introBullet2": "The sender's name and syphrax_id are not shown.",
  "push.introBullet3": "You'll only get a \"new message\" alert to open the app and read it encrypted on your device.",
  "push.introConfirm": "Enable notifications",
  "chat.placeholder": "Write a message…",
  "chat.editPlaceholder": "Edit your message…",
  "chat.replyingTo": "Replying to {0}",
  "chat.editing": "Editing message",
  "chat.confirmContact": "Add to contacts",
  "chat.unconfirmedBanner": "This user wrote to you but is not in your contacts. Until you add them, your photo and info will not be visible according to your privacy settings.",
  "chat.online": "online",
  "chat.lastSeen": "last seen here {0}",
  "chat.tooltip.attach": "Attach file",
  "chat.tooltip.shareContact": "Share contact",
  "chat.tooltip.paste": "Paste image from clipboard",
  "chat.tooltip.stickers": "Stickers",
  "chat.tooltip.callAudio": "Voice call",
  "chat.tooltip.callVideo": "Video call",
  "chat.btn.send": "Send",
  "chat.uploading": "…",
  "preview.image": "📷 Image",
  "preview.video": "🎬 Video",
  "preview.audio": "🎙 Audio",
  "bubble.reply": "Reply",
  "bubble.edit": "Edit",
  "bubble.edited": "edited",
  "bubble.contact.label": "Syphrax contact",
  "bubble.media.decrypting": "Decrypting…",
  "bubble.media.failed": "Could not decrypt file.",
  "call.calling": "Calling…",
  "call.incoming.audio": "Incoming call",
  "call.incoming.video": "Incoming video call",
  "call.connecting": "Connecting…",
  "call.ending": "Ending…",
  "call.accept": "Accept",
  "call.reject": "Decline",
  "call.hangup": "Hang up",
  "call.mic": "Microphone",
  "call.camera": "Camera",
  "call.audioOut": "Audio output",
  "call.audioOut.auto": "Auto",
  "call.error.notInFreq": "You must be tuned to a frequency to call.",
  "error.notFound": "Resource not found.",
  "error.notInFreq": "{0} hasn't tuned to this frequency yet. Ask them through another channel to tune in.",
  "error.push.iosTooOld": "Your iOS is older than 16.4. Update it to receive notifications.",
  "error.push.iosNotStandalone": "To receive notifications on iPhone, install Syphrax on the home screen: tap Share → Add to Home Screen.",
  "error.expired": "Session expired. Please sign in again.",
  "error.gone": "The file has expired.",
  "error.invalid": "Invalid data.",
  "error.server": "Server error. Try again.",
  "error.network": "No connection to the server.",
  "error.cantStartCall": "Could not start call: {0}",
  "error.cantAcceptCall": "Could not accept call: {0}",
  "error.cantPaste": "Could not access the clipboard. Try the attach button.",
  "error.noImageInClipboard": "No image in clipboard.",
  "error.clipboardUnsupported": "Your browser does not allow clipboard reading. Use Ctrl+V or the attach button.",
  "error.selfContact": "You can't add yourself.",
  "error.blocked": "You have blocked this user. Unblock them in Settings to talk again.",
  "settings.title": "Settings",
  "settings.close": "Close",
  "settings.tab.profile": "👤 Profile",
  "settings.tab.privacy": "🔒 Privacy",
  "settings.tab.messages": "✉ Messages",
  "settings.tab.blocked": "🚫 Blocked",
  "settings.tab.notifications": "🔔 Notifications",
  "settings.tab.session": "⏱ Session",
  "settings.tab.account": "🆔 Account",
  "settings.tab.language": "🌐 Language",
  "settings.tab.about": "ℹ About",
  "settings.scope.global": "Global (general frequency)",
  "settings.scope.freq": "Only on {0}",
  "settings.profile.title": "Profile",
  "settings.profile.hintGlobal": "These values are used by default and inherited across all frequencies.",
  "settings.profile.hintFreq": "They override the global profile when you are on {0}. If you don't set something here, it's inherited from the global.",
  "settings.profile.displayName": "Display name",
  "settings.profile.displayNamePh.global": "(no name — your syphrax id will be shown)",
  "settings.profile.displayNamePh.freq": "(inherits from global)",
  "settings.profile.photo": "Profile photo",
  "settings.profile.changePhoto": "Change photo",
  "settings.profile.removePhoto": "Remove photo",
  "settings.profile.info": "Info / Status",
  "settings.profile.infoPh": "Hi, I use Syphrax",
  "settings.profile.removeOverride": "Remove override of {0}",
  "settings.profile.warn": "Changes will be sent to your contacts automatically when you interact with them on this frequency.",
  "settings.privacy.title": "Privacy",
  "settings.privacy.hintGlobal": "Set who can see each piece of your information by default.",
  "settings.privacy.hintFreq": "Override these rules only when you are on {0}.",
  "settings.privacy.showPhoto": "Who sees my photo",
  "settings.privacy.showInfo": "Who sees my info / status",
  "settings.privacy.showLastSeen": "Who sees my last seen",
  "settings.privacy.showOnline": "Who sees if I am online",
  "settings.privacy.whoAdds": "Who can add me to groups",
  "settings.privacy.readReceipts": "Read receipts",
  "settings.privacy.readReceiptsHint": "If you disable it, no blue ticks are sent when you read messages. You also won't see others'.",
  "settings.vis.all": "Everyone",
  "settings.vis.contacts": "My contacts",
  "settings.vis.none": "Nobody",
  "settings.messages.title": "Messages",
  "settings.messages.ttl": "Default expiration",
  "settings.messages.ttlHint": "Messages you send will be deleted from the server after this time. You can choose a different value when attaching a file.",
  "settings.blocked.title": "Blocked",
  "settings.blocked.hint": "Blocked users can't send you messages. You also can't send messages to them.",
  "settings.blocked.placeholder": "Syphrax ID to block",
  "settings.blocked.btn": "Block",
  "settings.blocked.unblock": "Unblock",
  "settings.blocked.empty": "You have no one blocked.",
  "settings.notif.title": "Notifications",
  "settings.notif.sound": "Sound",
  "settings.notif.preview": "Show message preview",
  "settings.notif.vibration": "Vibration (mobile)",
  "settings.notif.hint": "Browser push notifications are only emitted for messages on the general frequency, without content or sender name (by design).",
  "settings.session.title": "Session",
  "settings.session.timeout": "Close frequency after inactivity",
  "settings.session.timeoutHint": "If you spend this much time without using the app, the active frequency is automatically disabled and you return to the general frequency. \"Never\" keeps the frequency until you close the app.",
  "settings.session.remember": "Remember used frequencies",
  "settings.session.rememberHint": "If enabled, the frequencies you tune to appear as shortcuts in the sidebar. Anyone who sees your screen can know which frequencies you have entered, so it is disabled by default.",
  "settings.account.title": "Account",
  "settings.account.idLabel": "Your syphrax id",
  "settings.account.email": "Optional email (only used for recovery, never published)",
  "settings.account.emailPh": "email@example.com",
  "settings.account.changePassword": "Change password",
  "settings.account.currentPw": "Current password",
  "settings.account.newPw": "New password (min. 8)",
  "settings.account.confirmPw": "Repeat the new one",
  "settings.account.saving": "Saving…",
  "settings.account.success": "Password updated.",
  "settings.account.errPwBad": "The current password is incorrect.",
  "settings.account.errPwShort": "The new password must be at least 8 characters.",
  "settings.account.errPwMismatch": "Passwords do not match.",
  "settings.language.title": "Language",
  "settings.language.hint": "Choose the interface language. Your preference is saved on this device and, if the vault is enabled, in your session too.",
  "settings.about.title": "About Syphrax",
  "settings.about.version": "MVP version in development.",
  "settings.about.tech": "E2E encryption with NaCl box (X25519). Frequencies: Argon2id derivation + deterministic HMAC. Local encrypted persistence with Argon2id over PIN.",
  "modal.freq.title": "Tune frequency",
  "modal.freq.hint": "Enter the secret string of the frequency. You will only see and be able to talk to those who also have it active.",
  "modal.freq.placeholder": "ALFA2025",
  "modal.freq.activate": "Activate",
  "modal.freq.deriving": "Deriving key…",
  "modal.freq.warn": "If you forget this string, you will lose access to the conversations on this frequency. It is not stored anywhere.",
  "modal.freq.errShort": "The frequency must be at least 8 characters.",
  "modal.freq.errCommon": "That string is too common. Choose something unique.",
  "modal.freq.errRepeat": "Don't use a single repeated character.",
  "modal.freq.errSeqNum": "Avoid obvious numeric sequences.",
  "modal.freq.errSeqAlpha": "Avoid alphabet sequences.",
  "modal.share.title": "Share contact",
  "modal.share.hint": "Pick a contact from the list or enter a syphrax id manually.",
  "modal.share.filter": "Filter contacts…",
  "modal.share.empty": "No contacts on this frequency",
  "modal.share.manual": "Or a manual syphrax id",
  "modal.share.btn": "Share",
  "modal.group.title": "New group",
  "modal.group.hint": "Choose a name and select members from your contacts on this frequency.",
  "modal.group.namePh": "Group name",
  "modal.group.selected": "{0} selected",
  "modal.group.create": "Create group",
  "modal.remember.title": "Remember this device",
  "modal.remember.hint": "Your session, contacts, groups and messages will be saved on this device, encrypted with a PIN only you know. When you reopen the app you will enter the PIN to unlock.",
  "modal.remember.pin": "PIN",
  "modal.remember.confirm": "Repeat the PIN",
  "modal.remember.warn": "If you forget the PIN, the saved data cannot be recovered. You will have to sign in again with your username and password.",
  "modal.remember.errShort": "The PIN must be at least 4 characters.",
  "modal.remember.errMismatch": "The PINs do not match.",
  "stickers.faces": "Faces",
  "stickers.gestures": "Gestures",
  "stickers.hearts": "Hearts",
  "stickers.symbols": "Symbols",
  "stickers.animals": "Animals",
  "stickers.food": "Food",
  "ttl.1h": "1 hour",
  "ttl.1d": "1 day",
  "ttl.1w": "1 week",
  "ttl.1m": "1 month",
  "ttl.6m": "6 months",
  "ttl.12m": "12 months",
  "timeout.5min": "5 min",
  "timeout.15min": "15 min",
  "timeout.30min": "30 min",
  "timeout.never": "Never",
  "toast.newMessage": "New message",
  "toast.group": "{0} (group)",
};

const pt: Catalog = {
  "common.cancel": "Cancelar",
  "common.save": "Guardar",
  "common.confirm": "Confirmar",
  "common.close": "Fechar",
  "common.add": "Adicionar",
  "common.back": "Voltar",
  "common.tagline": "Se não conheces a frequência, a conversa não existe.",
  "auth.tagline": "Mensagens privadas por frequência",
  "auth.loading": "A carregar…",
  "auth.savedSession": "Há uma sessão guardada neste dispositivo.",
  "auth.tab.login": "Entrar",
  "auth.tab.register": "Criar conta",
  "auth.field.devicePin": "PIN do dispositivo",
  "auth.field.username": "Utilizador",
  "auth.field.password": "Palavra-passe",
  "auth.btn.unlock": "Desbloquear",
  "auth.btn.unlocking": "A desbloquear…",
  "auth.btn.processing": "A processar…",
  "auth.btn.useOther": "Usar outra conta",
  "auth.btn.forget": "Esquecer este dispositivo",
  "auth.btn.backToUnlock": "Voltar ao desbloqueio",
  "auth.confirmForget": "Esquecer este dispositivo? A sessão guardada e as mensagens em cache serão apagadas.",
  "auth.error.userExists": "Esse utilizador já existe. Escolhe outro.",
  "auth.error.badCreds": "Utilizador ou palavra-passe incorretos.",
  "auth.error.userNotFound": "Utilizador não encontrado.",
  "auth.error.cantConnect": "Não foi possível ligar ao servidor.",
  "auth.error.badPin": "PIN incorreto.",
  "auth.footnote": "Cifragem E2E com NaCl box. Frequências: Argon2id + HMAC determinista.",
  "sidebar.general": "Frequência geral",
  "sidebar.freq": "Frequência {0}",
  "sidebar.tune": "Sintonizar frequência",
  "sidebar.exitFreq": "Sair de {0}",
  "sidebar.notifications": "Notificações",
  "sidebar.remember": "Memorizar dispositivo",
  "sidebar.forget": "Esquecer dispositivo",
  "sidebar.addContact": "Adicionar contacto por Syphrax ID",
  "sidebar.newGroup": "Novo grupo",
  "sidebar.settings": "Definições",
  "sidebar.logout": "Sair",
  "sidebar.tooltip.logout": "Terminar sessão e apagar tudo localmente",
  "sidebar.savedFreq.tooltip": "Sintonizar {0}",
  "chat.empty": "Seleciona ou adiciona um contacto",
  "welcome.title": "Bem-vindo ao Syphrax",
  "welcome.concept": "Syphrax é mensagens privadas baseadas em frequências. Uma frequência é uma chave secreta que tu e a pessoa com quem falas conhecem. Sem essa chave, a conversa não existe — nem mesmo a plataforma a pode reconstruir.",
  "welcome.step1": "Sintoniza uma frequência partilhada com a pessoa ou grupo com quem queres falar.",
  "welcome.step2": "Adiciona o syphrax_id dela como contacto, ou pede-lhe que adicione o teu.",
  "welcome.step3": "Começa a escrever. Apenas quem partilhe a mesma frequência poderá ler as mensagens.",
  "welcome.multidevice": "Cada dispositivo mantém as suas frequências e mensagens de forma independente. Se entrares noutro dispositivo terás de sintonizar as frequências novamente.",
  "welcome.btnFreq": "Sintonizar frequência",
  "welcome.btnContacts": "Adicionar contacto",
  "push.btnOn": "Notificações ON",
  "push.btnOff": "Notificações OFF",
  "push.btnEnable": "Notificações desativadas. Clica para ativar.",
  "push.btnDisable": "Notificações ativadas. Clica para desativar.",
  "push.introTitle": "Antes de ativar as notificações",
  "push.introBody": "Por privacidade, as notificações do Syphrax funcionam de forma diferente de outras apps de mensagens:",
  "push.introBullet1": "O conteúdo da mensagem não é incluído.",
  "push.introBullet2": "Nem o nome nem o syphrax_id do remetente são mostrados.",
  "push.introBullet3": "Só receberás um aviso de \"nova mensagem\" para abrir a app e lê-la cifrada no teu dispositivo.",
  "push.introConfirm": "Ativar notificações",
  "chat.placeholder": "Escreve uma mensagem…",
  "chat.editPlaceholder": "Edita a tua mensagem…",
  "chat.replyingTo": "A responder a {0}",
  "chat.editing": "A editar mensagem",
  "chat.confirmContact": "Adicionar aos contactos",
  "chat.unconfirmedBanner": "Este utilizador escreveu-te mas não está nos teus contactos. Até o adicionares, a tua foto e info não lhe serão visíveis segundo as definições de privacidade.",
  "chat.online": "em linha",
  "chat.lastSeen": "última vez aqui {0}",
  "chat.tooltip.attach": "Anexar ficheiro",
  "chat.tooltip.shareContact": "Partilhar contacto",
  "chat.tooltip.paste": "Colar imagem da área de transferência",
  "chat.tooltip.stickers": "Stickers",
  "chat.tooltip.callAudio": "Chamada de voz",
  "chat.tooltip.callVideo": "Videochamada",
  "chat.btn.send": "Enviar",
  "chat.uploading": "…",
  "preview.image": "📷 Imagem",
  "preview.video": "🎬 Vídeo",
  "preview.audio": "🎙 Áudio",
  "bubble.reply": "Responder",
  "bubble.edit": "Editar",
  "bubble.edited": "editada",
  "bubble.contact.label": "Contacto Syphrax",
  "bubble.media.decrypting": "A decifrar…",
  "bubble.media.failed": "Não foi possível decifrar o ficheiro.",
  "call.calling": "A chamar…",
  "call.incoming.audio": "Chamada a entrar",
  "call.incoming.video": "Videochamada a entrar",
  "call.connecting": "A ligar…",
  "call.ending": "A terminar…",
  "call.accept": "Atender",
  "call.reject": "Recusar",
  "call.hangup": "Desligar",
  "call.mic": "Microfone",
  "call.camera": "Câmara",
  "call.audioOut": "Saída de áudio",
  "call.audioOut.auto": "Auto",
  "call.error.notInFreq": "Para chamar tens de estar sintonizado numa frequência.",
  "error.notFound": "Recurso não encontrado.",
  "error.notInFreq": "{0} ainda não sintonizou esta frequência. Pede-lhe por outro canal que a sintonize.",
  "error.push.iosTooOld": "O teu iOS é anterior a 16.4. Atualiza-o para receber notificações.",
  "error.push.iosNotStandalone": "Para receber notificações no iPhone instala o Syphrax no ecrã principal: toca em Partilhar → Adicionar ao ecrã principal.",
  "error.expired": "Sessão expirada. Volte a entrar.",
  "error.gone": "O ficheiro expirou.",
  "error.invalid": "Dados inválidos.",
  "error.server": "Erro do servidor. Tenta novamente.",
  "error.network": "Sem ligação ao servidor.",
  "error.cantStartCall": "Não foi possível iniciar a chamada: {0}",
  "error.cantAcceptCall": "Não foi possível aceitar a chamada: {0}",
  "error.cantPaste": "Não foi possível aceder à área de transferência. Usa o botão de anexar.",
  "error.noImageInClipboard": "Não há nenhuma imagem na área de transferência.",
  "error.clipboardUnsupported": "O teu navegador não permite ler a área de transferência. Usa Ctrl+V ou o botão de anexar.",
  "error.selfContact": "Não te podes adicionar a ti mesmo.",
  "error.blocked": "Bloqueaste este utilizador. Desbloqueia-o em Definições para voltar a falar.",
  "settings.title": "Definições",
  "settings.close": "Fechar",
  "settings.tab.profile": "👤 Perfil",
  "settings.tab.privacy": "🔒 Privacidade",
  "settings.tab.messages": "✉ Mensagens",
  "settings.tab.blocked": "🚫 Bloqueados",
  "settings.tab.notifications": "🔔 Notificações",
  "settings.tab.session": "⏱ Sessão",
  "settings.tab.account": "🆔 Conta",
  "settings.tab.language": "🌐 Idioma",
  "settings.tab.about": "ℹ Sobre",
  "settings.scope.global": "Global (frequência geral)",
  "settings.scope.freq": "Apenas em {0}",
  "settings.profile.title": "Perfil",
  "settings.profile.hintGlobal": "Estes valores são usados por defeito e herdados em todas as frequências.",
  "settings.profile.hintFreq": "Sobrepõem o perfil global quando estás em {0}. Se não definires algo aqui, é herdado do global.",
  "settings.profile.displayName": "Nome a mostrar",
  "settings.profile.displayNamePh.global": "(sem nome — será mostrado o teu syphrax id)",
  "settings.profile.displayNamePh.freq": "(herda do global)",
  "settings.profile.photo": "Foto de perfil",
  "settings.profile.changePhoto": "Mudar foto",
  "settings.profile.removePhoto": "Remover foto",
  "settings.profile.info": "Info / Estado",
  "settings.profile.infoPh": "Olá, uso Syphrax",
  "settings.profile.removeOverride": "Eliminar override de {0}",
  "settings.profile.warn": "As alterações serão enviadas aos teus contactos automaticamente quando interagires com eles nesta frequência.",
  "settings.privacy.title": "Privacidade",
  "settings.privacy.hintGlobal": "Configura quem pode ver cada informação tua por defeito.",
  "settings.privacy.hintFreq": "Sobrescreve estas regras apenas quando estás em {0}.",
  "settings.privacy.showPhoto": "Quem vê a minha foto",
  "settings.privacy.showInfo": "Quem vê a minha info / estado",
  "settings.privacy.showLastSeen": "Quem vê a minha última ligação",
  "settings.privacy.showOnline": "Quem vê se estou online",
  "settings.privacy.whoAdds": "Quem me pode adicionar a grupos",
  "settings.privacy.readReceipts": "Confirmações de leitura",
  "settings.privacy.readReceiptsHint": "Se o desativares, não são enviados tics azuis quando lês mensagens. Também não verás os dos outros.",
  "settings.vis.all": "Todos",
  "settings.vis.contacts": "Os meus contactos",
  "settings.vis.none": "Ninguém",
  "settings.messages.title": "Mensagens",
  "settings.messages.ttl": "Caducidade por defeito",
  "settings.messages.ttlHint": "As mensagens que enviares serão apagadas do servidor após este tempo.",
  "settings.blocked.title": "Bloqueados",
  "settings.blocked.hint": "Os utilizadores bloqueados não te podem enviar mensagens. Também não lhes podes enviar.",
  "settings.blocked.placeholder": "syphrax id a bloquear",
  "settings.blocked.btn": "Bloquear",
  "settings.blocked.unblock": "Desbloquear",
  "settings.blocked.empty": "Não tens ninguém bloqueado.",
  "settings.notif.title": "Notificações",
  "settings.notif.sound": "Som",
  "settings.notif.preview": "Mostrar preview da mensagem",
  "settings.notif.vibration": "Vibração (móvel)",
  "settings.notif.hint": "As notificações push do navegador são emitidas apenas para mensagens na frequência geral.",
  "settings.session.title": "Sessão",
  "settings.session.timeout": "Fechar a frequência após inatividade",
  "settings.session.timeoutHint": "Se passares este tempo sem tocar na app, a frequência ativa desativa-se automaticamente.",
  "settings.session.remember": "Memorizar frequências usadas",
  "settings.session.rememberHint": "Se ativares, as frequências que sintonizas aparecem como atalhos na barra lateral.",
  "settings.account.title": "Conta",
  "settings.account.idLabel": "O teu syphrax id",
  "settings.account.email": "Email opcional (apenas para recuperação, nunca publicado)",
  "settings.account.emailPh": "email@exemplo.com",
  "settings.account.changePassword": "Mudar palavra-passe",
  "settings.account.currentPw": "Palavra-passe atual",
  "settings.account.newPw": "Nova palavra-passe (mín. 8)",
  "settings.account.confirmPw": "Repete a nova",
  "settings.account.saving": "A guardar…",
  "settings.account.success": "Palavra-passe atualizada.",
  "settings.account.errPwBad": "A palavra-passe atual não está correta.",
  "settings.account.errPwShort": "A nova palavra-passe deve ter pelo menos 8 caracteres.",
  "settings.account.errPwMismatch": "As palavras-passe não coincidem.",
  "settings.language.title": "Idioma",
  "settings.language.hint": "Escolhe o idioma da interface. A tua preferência é guardada neste dispositivo.",
  "settings.about.title": "Sobre o Syphrax",
  "settings.about.version": "Versão MVP em desenvolvimento.",
  "settings.about.tech": "Cifragem E2E com NaCl box (X25519). Frequências: derivação Argon2id + HMAC determinista.",
  "modal.freq.title": "Sintonizar frequência",
  "modal.freq.hint": "Introduz a cadeia secreta da frequência.",
  "modal.freq.placeholder": "ALFA2025",
  "modal.freq.activate": "Ativar",
  "modal.freq.deriving": "A derivar chave…",
  "modal.freq.warn": "Se esqueceres esta cadeia, perderás o acesso às conversas desta frequência.",
  "modal.freq.errShort": "A frequência deve ter pelo menos 8 caracteres.",
  "modal.freq.errCommon": "Essa cadeia é demasiado comum.",
  "modal.freq.errRepeat": "Não uses um único carácter repetido.",
  "modal.freq.errSeqNum": "Evita sequências numéricas óbvias.",
  "modal.freq.errSeqAlpha": "Evita sequências do alfabeto.",
  "modal.share.title": "Partilhar contacto",
  "modal.share.hint": "Escolhe um contacto da lista ou introduz um syphrax id manualmente.",
  "modal.share.filter": "Filtrar contactos…",
  "modal.share.empty": "Sem contactos nesta frequência",
  "modal.share.manual": "Ou um syphrax id manual",
  "modal.share.btn": "Partilhar",
  "modal.group.title": "Novo grupo",
  "modal.group.hint": "Escolhe um nome e seleciona membros dos teus contactos nesta frequência.",
  "modal.group.namePh": "Nome do grupo",
  "modal.group.selected": "{0} selecionados",
  "modal.group.create": "Criar grupo",
  "modal.remember.title": "Memorizar este dispositivo",
  "modal.remember.hint": "A tua sessão, contactos, grupos e mensagens serão guardados neste dispositivo, cifrados com um PIN que só tu conheces.",
  "modal.remember.pin": "PIN",
  "modal.remember.confirm": "Repete o PIN",
  "modal.remember.warn": "Se esqueceres o PIN, os dados guardados não poderão ser recuperados.",
  "modal.remember.errShort": "O PIN deve ter pelo menos 4 caracteres.",
  "modal.remember.errMismatch": "Os PINs não coincidem.",
  "stickers.faces": "Rostos",
  "stickers.gestures": "Gestos",
  "stickers.hearts": "Corações",
  "stickers.symbols": "Símbolos",
  "stickers.animals": "Animais",
  "stickers.food": "Comida",
  "ttl.1h": "1 hora",
  "ttl.1d": "1 dia",
  "ttl.1w": "1 semana",
  "ttl.1m": "1 mês",
  "ttl.6m": "6 meses",
  "ttl.12m": "12 meses",
  "timeout.5min": "5 min",
  "timeout.15min": "15 min",
  "timeout.30min": "30 min",
  "timeout.never": "Nunca",
  "toast.newMessage": "Mensagem nova",
  "toast.group": "{0} (grupo)",
};

const fr: Catalog = {
  "common.cancel": "Annuler",
  "common.save": "Enregistrer",
  "common.confirm": "Confirmer",
  "common.close": "Fermer",
  "common.add": "Ajouter",
  "common.back": "Retour",
  "common.tagline": "Si tu ne connais pas la fréquence, la conversation n'existe pas.",
  "auth.tagline": "Messagerie privée par fréquence",
  "auth.loading": "Chargement…",
  "auth.savedSession": "Une session est enregistrée sur cet appareil.",
  "auth.tab.login": "Connexion",
  "auth.tab.register": "Créer un compte",
  "auth.field.devicePin": "PIN de l'appareil",
  "auth.field.username": "Utilisateur",
  "auth.field.password": "Mot de passe",
  "auth.btn.unlock": "Déverrouiller",
  "auth.btn.unlocking": "Déverrouillage…",
  "auth.btn.processing": "Traitement…",
  "auth.btn.useOther": "Utiliser un autre compte",
  "auth.btn.forget": "Oublier cet appareil",
  "auth.btn.backToUnlock": "Retour au déverrouillage",
  "auth.confirmForget": "Oublier cet appareil ? La session enregistrée et les messages en cache seront supprimés.",
  "auth.error.userExists": "Cet utilisateur existe déjà. Choisis un autre.",
  "auth.error.badCreds": "Nom d'utilisateur ou mot de passe incorrects.",
  "auth.error.userNotFound": "Utilisateur introuvable.",
  "auth.error.cantConnect": "Impossible de se connecter au serveur.",
  "auth.error.badPin": "PIN incorrect.",
  "auth.footnote": "Chiffrement E2E avec NaCl box. Fréquences : Argon2id + HMAC déterministe.",
  "sidebar.general": "Fréquence générale",
  "sidebar.freq": "Fréquence {0}",
  "sidebar.tune": "Syntoniser une fréquence",
  "sidebar.exitFreq": "Quitter {0}",
  "sidebar.notifications": "Notifications",
  "sidebar.remember": "Mémoriser cet appareil",
  "sidebar.forget": "Oublier cet appareil",
  "sidebar.addContact": "Ajouter un contact par Syphrax ID",
  "sidebar.newGroup": "Nouveau groupe",
  "sidebar.settings": "Paramètres",
  "sidebar.logout": "Quitter",
  "sidebar.tooltip.logout": "Se déconnecter et tout effacer localement",
  "sidebar.savedFreq.tooltip": "Syntoniser {0}",
  "chat.empty": "Sélectionnez ou ajoutez un contact",
  "welcome.title": "Bienvenue sur Syphrax",
  "welcome.concept": "Syphrax est une messagerie privée basée sur des fréquences. Une fréquence est une clé secrète que vous et la personne à qui vous parlez connaissez tous les deux. Sans cette clé, la conversation n'existe pas — même la plateforme ne peut pas la reconstruire.",
  "welcome.step1": "Réglez-vous sur une fréquence partagée avec la personne ou le groupe à qui vous voulez parler.",
  "welcome.step2": "Ajoutez son syphrax_id comme contact, ou demandez-lui d'ajouter le vôtre.",
  "welcome.step3": "Commencez à écrire. Seuls ceux qui partagent la même fréquence peuvent lire les messages.",
  "welcome.multidevice": "Chaque appareil conserve ses fréquences et messages indépendamment. Si vous vous connectez depuis un autre appareil, vous devrez régler à nouveau les fréquences.",
  "welcome.btnFreq": "Régler une fréquence",
  "welcome.btnContacts": "Ajouter un contact",
  "push.btnOn": "Notifications ON",
  "push.btnOff": "Notifications OFF",
  "push.btnEnable": "Notifications désactivées. Cliquer pour activer.",
  "push.btnDisable": "Notifications activées. Cliquer pour désactiver.",
  "push.introTitle": "Avant d'activer les notifications",
  "push.introBody": "Pour préserver la confidentialité, les notifications Syphrax fonctionnent différemment des autres applis de messagerie :",
  "push.introBullet1": "Le contenu du message n'est pas inclus.",
  "push.introBullet2": "Ni le nom ni le syphrax_id de l'expéditeur ne sont affichés.",
  "push.introBullet3": "Vous recevrez seulement une alerte « nouveau message » pour ouvrir l'appli et le lire chiffré sur votre appareil.",
  "push.introConfirm": "Activer les notifications",
  "chat.placeholder": "Écris un message…",
  "chat.editPlaceholder": "Modifie ton message…",
  "chat.replyingTo": "Réponse à {0}",
  "chat.editing": "Modification du message",
  "chat.confirmContact": "Ajouter aux contacts",
  "chat.unconfirmedBanner": "Cet utilisateur t'a écrit mais n'est pas dans tes contacts. Tant que tu ne l'auras pas ajouté, ta photo et tes infos ne lui seront pas visibles selon tes paramètres de confidentialité.",
  "chat.online": "en ligne",
  "chat.lastSeen": "vu pour la dernière fois ici {0}",
  "chat.tooltip.attach": "Joindre un fichier",
  "chat.tooltip.shareContact": "Partager un contact",
  "chat.tooltip.paste": "Coller une image du presse-papiers",
  "chat.tooltip.stickers": "Stickers",
  "chat.tooltip.callAudio": "Appel vocal",
  "chat.tooltip.callVideo": "Appel vidéo",
  "chat.btn.send": "Envoyer",
  "chat.uploading": "…",
  "preview.image": "📷 Image",
  "preview.video": "🎬 Vidéo",
  "preview.audio": "🎙 Audio",
  "bubble.reply": "Répondre",
  "bubble.edit": "Modifier",
  "bubble.edited": "modifié",
  "bubble.contact.label": "Contact Syphrax",
  "bubble.media.decrypting": "Déchiffrement…",
  "bubble.media.failed": "Impossible de déchiffrer le fichier.",
  "call.calling": "Appel en cours…",
  "call.incoming.audio": "Appel entrant",
  "call.incoming.video": "Appel vidéo entrant",
  "call.connecting": "Connexion…",
  "call.ending": "Fin…",
  "call.accept": "Accepter",
  "call.reject": "Refuser",
  "call.hangup": "Raccrocher",
  "call.mic": "Microphone",
  "call.camera": "Caméra",
  "call.audioOut": "Sortie audio",
  "call.audioOut.auto": "Auto",
  "call.error.notInFreq": "Vous devez être syntonisé sur une fréquence pour appeler.",
  "error.notFound": "Ressource introuvable.",
  "error.notInFreq": "{0} n'a pas encore syntonisé cette fréquence. Demande-lui par un autre canal de la syntoniser.",
  "error.push.iosTooOld": "Ton iOS est antérieur à 16.4. Mets-le à jour pour recevoir les notifications.",
  "error.push.iosNotStandalone": "Pour recevoir des notifications sur iPhone, installe Syphrax sur l'écran d'accueil : appuie sur Partager → Ajouter à l'écran d'accueil.",
  "error.expired": "Session expirée. Reconnectez-vous.",
  "error.gone": "Le fichier a expiré.",
  "error.invalid": "Données invalides.",
  "error.server": "Erreur du serveur. Réessayez.",
  "error.network": "Aucune connexion au serveur.",
  "error.cantStartCall": "Impossible de démarrer l'appel : {0}",
  "error.cantAcceptCall": "Impossible d'accepter l'appel : {0}",
  "error.cantPaste": "Impossible d'accéder au presse-papiers. Utilise le bouton de pièce jointe.",
  "error.noImageInClipboard": "Aucune image dans le presse-papiers.",
  "error.clipboardUnsupported": "Ton navigateur ne permet pas la lecture du presse-papiers. Utilise Ctrl+V ou le bouton de pièce jointe.",
  "error.selfContact": "Tu ne peux pas t'ajouter toi-même.",
  "error.blocked": "Tu as bloqué cet utilisateur. Débloque-le dans Paramètres pour lui parler de nouveau.",
  "settings.title": "Paramètres",
  "settings.close": "Fermer",
  "settings.tab.profile": "👤 Profil",
  "settings.tab.privacy": "🔒 Confidentialité",
  "settings.tab.messages": "✉ Messages",
  "settings.tab.blocked": "🚫 Bloqués",
  "settings.tab.notifications": "🔔 Notifications",
  "settings.tab.session": "⏱ Session",
  "settings.tab.account": "🆔 Compte",
  "settings.tab.language": "🌐 Langue",
  "settings.tab.about": "ℹ À propos",
  "settings.scope.global": "Global (fréquence générale)",
  "settings.scope.freq": "Seulement sur {0}",
  "settings.profile.title": "Profil",
  "settings.profile.hintGlobal": "Ces valeurs sont utilisées par défaut et héritées sur toutes les fréquences.",
  "settings.profile.hintFreq": "Ils écrasent le profil global quand tu es sur {0}. Si tu ne définis pas quelque chose ici, c'est hérité du global.",
  "settings.profile.displayName": "Nom affiché",
  "settings.profile.displayNamePh.global": "(sans nom — ton syphrax id sera affiché)",
  "settings.profile.displayNamePh.freq": "(hérite du global)",
  "settings.profile.photo": "Photo de profil",
  "settings.profile.changePhoto": "Changer la photo",
  "settings.profile.removePhoto": "Supprimer la photo",
  "settings.profile.info": "Info / Statut",
  "settings.profile.infoPh": "Salut, j'utilise Syphrax",
  "settings.profile.removeOverride": "Supprimer l'override de {0}",
  "settings.profile.warn": "Les modifications seront envoyées à tes contacts automatiquement quand tu interagiras avec eux sur cette fréquence.",
  "settings.privacy.title": "Confidentialité",
  "settings.privacy.hintGlobal": "Configure qui peut voir chacune de tes informations par défaut.",
  "settings.privacy.hintFreq": "Remplace ces règles uniquement quand tu es sur {0}.",
  "settings.privacy.showPhoto": "Qui voit ma photo",
  "settings.privacy.showInfo": "Qui voit mon info / statut",
  "settings.privacy.showLastSeen": "Qui voit ma dernière connexion",
  "settings.privacy.showOnline": "Qui voit si je suis en ligne",
  "settings.privacy.whoAdds": "Qui peut m'ajouter à des groupes",
  "settings.privacy.readReceipts": "Accusés de lecture",
  "settings.privacy.readReceiptsHint": "Si tu le désactives, aucun double tick bleu n'est envoyé quand tu lis des messages. Tu ne verras pas non plus ceux des autres.",
  "settings.vis.all": "Tout le monde",
  "settings.vis.contacts": "Mes contacts",
  "settings.vis.none": "Personne",
  "settings.messages.title": "Messages",
  "settings.messages.ttl": "Expiration par défaut",
  "settings.messages.ttlHint": "Les messages que tu envoies seront supprimés du serveur après ce délai.",
  "settings.blocked.title": "Bloqués",
  "settings.blocked.hint": "Les utilisateurs bloqués ne peuvent pas t'envoyer de messages. Tu ne peux pas non plus leur en envoyer.",
  "settings.blocked.placeholder": "syphrax id à bloquer",
  "settings.blocked.btn": "Bloquer",
  "settings.blocked.unblock": "Débloquer",
  "settings.blocked.empty": "Tu n'as bloqué personne.",
  "settings.notif.title": "Notifications",
  "settings.notif.sound": "Son",
  "settings.notif.preview": "Afficher l'aperçu du message",
  "settings.notif.vibration": "Vibration (mobile)",
  "settings.notif.hint": "Les notifications push du navigateur ne sont émises que pour les messages sur la fréquence générale.",
  "settings.session.title": "Session",
  "settings.session.timeout": "Fermer la fréquence après inactivité",
  "settings.session.timeoutHint": "Si tu passes ce temps sans utiliser l'app, la fréquence active se désactive automatiquement.",
  "settings.session.remember": "Mémoriser les fréquences utilisées",
  "settings.session.rememberHint": "Si activé, les fréquences que tu syntonises apparaissent comme raccourcis dans la barre latérale.",
  "settings.account.title": "Compte",
  "settings.account.idLabel": "Ton syphrax id",
  "settings.account.email": "Email facultatif (uniquement pour la récupération, jamais publié)",
  "settings.account.emailPh": "email@exemple.com",
  "settings.account.changePassword": "Changer le mot de passe",
  "settings.account.currentPw": "Mot de passe actuel",
  "settings.account.newPw": "Nouveau mot de passe (min. 8)",
  "settings.account.confirmPw": "Répète le nouveau",
  "settings.account.saving": "Enregistrement…",
  "settings.account.success": "Mot de passe mis à jour.",
  "settings.account.errPwBad": "Le mot de passe actuel n'est pas correct.",
  "settings.account.errPwShort": "Le nouveau mot de passe doit comporter au moins 8 caractères.",
  "settings.account.errPwMismatch": "Les mots de passe ne correspondent pas.",
  "settings.language.title": "Langue",
  "settings.language.hint": "Choisis la langue de l'interface. Ta préférence est enregistrée sur cet appareil.",
  "settings.about.title": "À propos de Syphrax",
  "settings.about.version": "Version MVP en développement.",
  "settings.about.tech": "Chiffrement E2E avec NaCl box (X25519). Fréquences : dérivation Argon2id + HMAC déterministe.",
  "modal.freq.title": "Syntoniser une fréquence",
  "modal.freq.hint": "Saisis la chaîne secrète de la fréquence.",
  "modal.freq.placeholder": "ALFA2025",
  "modal.freq.activate": "Activer",
  "modal.freq.deriving": "Dérivation de la clé…",
  "modal.freq.warn": "Si tu oublies cette chaîne, tu perdras l'accès aux conversations de cette fréquence.",
  "modal.freq.errShort": "La fréquence doit comporter au moins 8 caractères.",
  "modal.freq.errCommon": "Cette chaîne est trop commune.",
  "modal.freq.errRepeat": "N'utilise pas un seul caractère répété.",
  "modal.freq.errSeqNum": "Évite les séquences numériques évidentes.",
  "modal.freq.errSeqAlpha": "Évite les séquences alphabétiques.",
  "modal.share.title": "Partager un contact",
  "modal.share.hint": "Choisis un contact dans la liste ou saisis un syphrax id manuellement.",
  "modal.share.filter": "Filtrer les contacts…",
  "modal.share.empty": "Aucun contact sur cette fréquence",
  "modal.share.manual": "Ou un syphrax id manuel",
  "modal.share.btn": "Partager",
  "modal.group.title": "Nouveau groupe",
  "modal.group.hint": "Choisis un nom et sélectionne des membres parmi tes contacts sur cette fréquence.",
  "modal.group.namePh": "Nom du groupe",
  "modal.group.selected": "{0} sélectionnés",
  "modal.group.create": "Créer le groupe",
  "modal.remember.title": "Mémoriser cet appareil",
  "modal.remember.hint": "Ta session, contacts, groupes et messages seront enregistrés sur cet appareil, chiffrés avec un PIN que toi seul connais.",
  "modal.remember.pin": "PIN",
  "modal.remember.confirm": "Répète le PIN",
  "modal.remember.warn": "Si tu oublies le PIN, les données enregistrées ne pourront pas être récupérées.",
  "modal.remember.errShort": "Le PIN doit comporter au moins 4 caractères.",
  "modal.remember.errMismatch": "Les PINs ne correspondent pas.",
  "stickers.faces": "Visages",
  "stickers.gestures": "Gestes",
  "stickers.hearts": "Cœurs",
  "stickers.symbols": "Symboles",
  "stickers.animals": "Animaux",
  "stickers.food": "Nourriture",
  "ttl.1h": "1 heure",
  "ttl.1d": "1 jour",
  "ttl.1w": "1 semaine",
  "ttl.1m": "1 mois",
  "ttl.6m": "6 mois",
  "ttl.12m": "12 mois",
  "timeout.5min": "5 min",
  "timeout.15min": "15 min",
  "timeout.30min": "30 min",
  "timeout.never": "Jamais",
  "toast.newMessage": "Nouveau message",
  "toast.group": "{0} (groupe)",
};

const it: Catalog = {
  "common.cancel": "Annulla",
  "common.save": "Salva",
  "common.confirm": "Conferma",
  "common.close": "Chiudi",
  "common.add": "Aggiungi",
  "common.back": "Indietro",
  "common.tagline": "Se non conosci la frequenza, la conversazione non esiste.",
  "auth.tagline": "Messaggistica privata per frequenza",
  "auth.loading": "Caricamento…",
  "auth.savedSession": "C'è una sessione salvata su questo dispositivo.",
  "auth.tab.login": "Accedi",
  "auth.tab.register": "Crea account",
  "auth.field.devicePin": "PIN del dispositivo",
  "auth.field.username": "Utente",
  "auth.field.password": "Password",
  "auth.btn.unlock": "Sblocca",
  "auth.btn.unlocking": "Sblocco…",
  "auth.btn.processing": "Elaborazione…",
  "auth.btn.useOther": "Usa un altro account",
  "auth.btn.forget": "Dimentica questo dispositivo",
  "auth.btn.backToUnlock": "Torna allo sblocco",
  "auth.confirmForget": "Dimenticare questo dispositivo? La sessione salvata e i messaggi in cache saranno eliminati.",
  "auth.error.userExists": "Questo utente esiste già. Scegline un altro.",
  "auth.error.badCreds": "Nome utente o password errati.",
  "auth.error.userNotFound": "Utente non trovato.",
  "auth.error.cantConnect": "Impossibile connettersi al server.",
  "auth.error.badPin": "PIN errato.",
  "auth.footnote": "Cifratura E2E con NaCl box. Frequenze: Argon2id + HMAC deterministico.",
  "sidebar.general": "Frequenza generale",
  "sidebar.freq": "Frequenza {0}",
  "sidebar.tune": "Sintonizza frequenza",
  "sidebar.exitFreq": "Esci da {0}",
  "sidebar.notifications": "Notifiche",
  "sidebar.remember": "Ricorda dispositivo",
  "sidebar.forget": "Dimentica dispositivo",
  "sidebar.addContact": "Aggiungi contatto per Syphrax ID",
  "sidebar.newGroup": "Nuovo gruppo",
  "sidebar.settings": "Impostazioni",
  "sidebar.logout": "Esci",
  "sidebar.tooltip.logout": "Disconnettiti e cancella tutto localmente",
  "sidebar.savedFreq.tooltip": "Sintonizza {0}",
  "chat.empty": "Seleziona o aggiungi un contatto",
  "welcome.title": "Benvenuto in Syphrax",
  "welcome.concept": "Syphrax è una messaggistica privata basata su frequenze. Una frequenza è una chiave segreta che tu e la persona con cui parli conoscete entrambi. Senza quella chiave, la conversazione non esiste — nemmeno la piattaforma può ricostruirla.",
  "welcome.step1": "Sintonizzati su una frequenza condivisa con la persona o il gruppo con cui vuoi parlare.",
  "welcome.step2": "Aggiungi il suo syphrax_id come contatto, o chiedigli di aggiungere il tuo.",
  "welcome.step3": "Inizia a scrivere. Solo chi condivide la stessa frequenza può leggere i messaggi.",
  "welcome.multidevice": "Ogni dispositivo mantiene le proprie frequenze e i propri messaggi in modo indipendente. Se accedi da un altro dispositivo dovrai sintonizzare di nuovo le frequenze.",
  "welcome.btnFreq": "Sintonizza frequenza",
  "welcome.btnContacts": "Aggiungi contatto",
  "push.btnOn": "Notifiche ON",
  "push.btnOff": "Notifiche OFF",
  "push.btnEnable": "Notifiche disattivate. Clicca per attivare.",
  "push.btnDisable": "Notifiche attivate. Clicca per disattivare.",
  "push.introTitle": "Prima di attivare le notifiche",
  "push.introBody": "Per privacy, le notifiche di Syphrax funzionano in modo diverso rispetto ad altre app di messaggistica:",
  "push.introBullet1": "Il contenuto del messaggio non è incluso.",
  "push.introBullet2": "Né il nome né il syphrax_id del mittente vengono mostrati.",
  "push.introBullet3": "Riceverai solo un avviso di \"nuovo messaggio\" per aprire l'app e leggerlo cifrato sul tuo dispositivo.",
  "push.introConfirm": "Attiva notifiche",
  "chat.placeholder": "Scrivi un messaggio…",
  "chat.editPlaceholder": "Modifica il messaggio…",
  "chat.replyingTo": "Risposta a {0}",
  "chat.editing": "Modifica messaggio",
  "chat.confirmContact": "Aggiungi ai contatti",
  "chat.unconfirmedBanner": "Questo utente ti ha scritto ma non è nei tuoi contatti. Finché non lo aggiungi, la tua foto e info non gli saranno visibili secondo le tue impostazioni di privacy.",
  "chat.online": "online",
  "chat.lastSeen": "ultima volta qui {0}",
  "chat.tooltip.attach": "Allega file",
  "chat.tooltip.shareContact": "Condividi contatto",
  "chat.tooltip.paste": "Incolla immagine dagli appunti",
  "chat.tooltip.stickers": "Sticker",
  "chat.tooltip.callAudio": "Chiamata vocale",
  "chat.tooltip.callVideo": "Videochiamata",
  "chat.btn.send": "Invia",
  "chat.uploading": "…",
  "preview.image": "📷 Immagine",
  "preview.video": "🎬 Video",
  "preview.audio": "🎙 Audio",
  "bubble.reply": "Rispondi",
  "bubble.edit": "Modifica",
  "bubble.edited": "modificato",
  "bubble.contact.label": "Contatto Syphrax",
  "bubble.media.decrypting": "Decifratura…",
  "bubble.media.failed": "Impossibile decifrare il file.",
  "call.calling": "Chiamata…",
  "call.incoming.audio": "Chiamata in arrivo",
  "call.incoming.video": "Videochiamata in arrivo",
  "call.connecting": "Connessione…",
  "call.ending": "Termine…",
  "call.accept": "Accetta",
  "call.reject": "Rifiuta",
  "call.hangup": "Riaggancia",
  "call.mic": "Microfono",
  "call.camera": "Fotocamera",
  "call.audioOut": "Uscita audio",
  "call.audioOut.auto": "Auto",
  "call.error.notInFreq": "Per chiamare devi essere sintonizzato su una frequenza.",
  "error.notFound": "Risorsa non trovata.",
  "error.notInFreq": "{0} non ha ancora sintonizzato questa frequenza. Chiedigli su un altro canale di sintonizzarla.",
  "error.push.iosTooOld": "Il tuo iOS è precedente a 16.4. Aggiornalo per ricevere notifiche.",
  "error.push.iosNotStandalone": "Per ricevere notifiche su iPhone installa Syphrax nella schermata Home: tocca Condividi → Aggiungi alla schermata Home.",
  "error.expired": "Sessione scaduta. Accedi di nuovo.",
  "error.gone": "Il file è scaduto.",
  "error.invalid": "Dati non validi.",
  "error.server": "Errore del server. Riprova.",
  "error.network": "Nessuna connessione al server.",
  "error.cantStartCall": "Impossibile avviare la chiamata: {0}",
  "error.cantAcceptCall": "Impossibile accettare la chiamata: {0}",
  "error.cantPaste": "Impossibile accedere agli appunti. Usa il pulsante di allegato.",
  "error.noImageInClipboard": "Nessuna immagine negli appunti.",
  "error.clipboardUnsupported": "Il tuo browser non permette di leggere gli appunti. Usa Ctrl+V o il pulsante di allegato.",
  "error.selfContact": "Non puoi aggiungere te stesso.",
  "error.blocked": "Hai bloccato questo utente. Sbloccalo in Impostazioni per parlargli di nuovo.",
  "settings.title": "Impostazioni",
  "settings.close": "Chiudi",
  "settings.tab.profile": "👤 Profilo",
  "settings.tab.privacy": "🔒 Privacy",
  "settings.tab.messages": "✉ Messaggi",
  "settings.tab.blocked": "🚫 Bloccati",
  "settings.tab.notifications": "🔔 Notifiche",
  "settings.tab.session": "⏱ Sessione",
  "settings.tab.account": "🆔 Account",
  "settings.tab.language": "🌐 Lingua",
  "settings.tab.about": "ℹ Info",
  "settings.scope.global": "Globale (frequenza generale)",
  "settings.scope.freq": "Solo su {0}",
  "settings.profile.title": "Profilo",
  "settings.profile.hintGlobal": "Questi valori sono usati per impostazione predefinita e ereditati in tutte le frequenze.",
  "settings.profile.hintFreq": "Sovrascrivono il profilo globale quando sei su {0}. Se non definisci qualcosa qui, è ereditato dal globale.",
  "settings.profile.displayName": "Nome visualizzato",
  "settings.profile.displayNamePh.global": "(senza nome — verrà mostrato il tuo syphrax id)",
  "settings.profile.displayNamePh.freq": "(eredita dal globale)",
  "settings.profile.photo": "Foto profilo",
  "settings.profile.changePhoto": "Cambia foto",
  "settings.profile.removePhoto": "Rimuovi foto",
  "settings.profile.info": "Info / Stato",
  "settings.profile.infoPh": "Ciao, uso Syphrax",
  "settings.profile.removeOverride": "Elimina override di {0}",
  "settings.profile.warn": "Le modifiche saranno inviate ai tuoi contatti automaticamente quando interagisci con loro su questa frequenza.",
  "settings.privacy.title": "Privacy",
  "settings.privacy.hintGlobal": "Configura chi può vedere ogni tua informazione per impostazione predefinita.",
  "settings.privacy.hintFreq": "Sovrascrive queste regole solo quando sei su {0}.",
  "settings.privacy.showPhoto": "Chi vede la mia foto",
  "settings.privacy.showInfo": "Chi vede la mia info / stato",
  "settings.privacy.showLastSeen": "Chi vede il mio ultimo accesso",
  "settings.privacy.showOnline": "Chi vede se sono online",
  "settings.privacy.whoAdds": "Chi può aggiungermi ai gruppi",
  "settings.privacy.readReceipts": "Conferme di lettura",
  "settings.privacy.readReceiptsHint": "Se lo disattivi, non vengono inviati tic blu quando leggi i messaggi. Non vedrai nemmeno quelli degli altri.",
  "settings.vis.all": "Tutti",
  "settings.vis.contacts": "I miei contatti",
  "settings.vis.none": "Nessuno",
  "settings.messages.title": "Messaggi",
  "settings.messages.ttl": "Scadenza predefinita",
  "settings.messages.ttlHint": "I messaggi che invii saranno eliminati dal server dopo questo tempo.",
  "settings.blocked.title": "Bloccati",
  "settings.blocked.hint": "Gli utenti bloccati non possono inviarti messaggi. Non puoi nemmeno inviare loro messaggi.",
  "settings.blocked.placeholder": "syphrax id da bloccare",
  "settings.blocked.btn": "Blocca",
  "settings.blocked.unblock": "Sblocca",
  "settings.blocked.empty": "Non hai nessuno bloccato.",
  "settings.notif.title": "Notifiche",
  "settings.notif.sound": "Suono",
  "settings.notif.preview": "Mostra anteprima del messaggio",
  "settings.notif.vibration": "Vibrazione (mobile)",
  "settings.notif.hint": "Le notifiche push del browser vengono emesse solo per messaggi sulla frequenza generale.",
  "settings.session.title": "Sessione",
  "settings.session.timeout": "Chiudi la frequenza dopo inattività",
  "settings.session.timeoutHint": "Se passi questo tempo senza usare l'app, la frequenza attiva si disattiva automaticamente.",
  "settings.session.remember": "Ricorda le frequenze usate",
  "settings.session.rememberHint": "Se attivato, le frequenze che sintonizzi appaiono come scorciatoie nella barra laterale.",
  "settings.account.title": "Account",
  "settings.account.idLabel": "Il tuo syphrax id",
  "settings.account.email": "Email facoltativa (solo per recupero, mai pubblicata)",
  "settings.account.emailPh": "email@esempio.com",
  "settings.account.changePassword": "Cambia password",
  "settings.account.currentPw": "Password attuale",
  "settings.account.newPw": "Nuova password (min. 8)",
  "settings.account.confirmPw": "Ripeti la nuova",
  "settings.account.saving": "Salvataggio…",
  "settings.account.success": "Password aggiornata.",
  "settings.account.errPwBad": "La password attuale non è corretta.",
  "settings.account.errPwShort": "La nuova password deve avere almeno 8 caratteri.",
  "settings.account.errPwMismatch": "Le password non coincidono.",
  "settings.language.title": "Lingua",
  "settings.language.hint": "Scegli la lingua dell'interfaccia. La tua preferenza è salvata su questo dispositivo.",
  "settings.about.title": "Informazioni su Syphrax",
  "settings.about.version": "Versione MVP in sviluppo.",
  "settings.about.tech": "Cifratura E2E con NaCl box (X25519). Frequenze: derivazione Argon2id + HMAC deterministico.",
  "modal.freq.title": "Sintonizza frequenza",
  "modal.freq.hint": "Inserisci la stringa segreta della frequenza.",
  "modal.freq.placeholder": "ALFA2025",
  "modal.freq.activate": "Attiva",
  "modal.freq.deriving": "Derivazione chiave…",
  "modal.freq.warn": "Se dimentichi questa stringa, perderai l'accesso alle conversazioni di questa frequenza.",
  "modal.freq.errShort": "La frequenza deve avere almeno 8 caratteri.",
  "modal.freq.errCommon": "Questa stringa è troppo comune.",
  "modal.freq.errRepeat": "Non usare un solo carattere ripetuto.",
  "modal.freq.errSeqNum": "Evita sequenze numeriche ovvie.",
  "modal.freq.errSeqAlpha": "Evita sequenze alfabetiche.",
  "modal.share.title": "Condividi contatto",
  "modal.share.hint": "Scegli un contatto dalla lista o inserisci un syphrax id manualmente.",
  "modal.share.filter": "Filtra contatti…",
  "modal.share.empty": "Nessun contatto su questa frequenza",
  "modal.share.manual": "O un syphrax id manuale",
  "modal.share.btn": "Condividi",
  "modal.group.title": "Nuovo gruppo",
  "modal.group.hint": "Scegli un nome e seleziona membri tra i tuoi contatti su questa frequenza.",
  "modal.group.namePh": "Nome del gruppo",
  "modal.group.selected": "{0} selezionati",
  "modal.group.create": "Crea gruppo",
  "modal.remember.title": "Ricorda questo dispositivo",
  "modal.remember.hint": "La tua sessione, contatti, gruppi e messaggi saranno salvati su questo dispositivo, cifrati con un PIN che conosci solo tu.",
  "modal.remember.pin": "PIN",
  "modal.remember.confirm": "Ripeti il PIN",
  "modal.remember.warn": "Se dimentichi il PIN, i dati salvati non potranno essere recuperati.",
  "modal.remember.errShort": "Il PIN deve avere almeno 4 caratteri.",
  "modal.remember.errMismatch": "I PIN non coincidono.",
  "stickers.faces": "Volti",
  "stickers.gestures": "Gesti",
  "stickers.hearts": "Cuori",
  "stickers.symbols": "Simboli",
  "stickers.animals": "Animali",
  "stickers.food": "Cibo",
  "ttl.1h": "1 ora",
  "ttl.1d": "1 giorno",
  "ttl.1w": "1 settimana",
  "ttl.1m": "1 mese",
  "ttl.6m": "6 mesi",
  "ttl.12m": "12 mesi",
  "timeout.5min": "5 min",
  "timeout.15min": "15 min",
  "timeout.30min": "30 min",
  "timeout.never": "Mai",
  "toast.newMessage": "Nuovo messaggio",
  "toast.group": "{0} (gruppo)",
};

const de: Catalog = {
  "common.cancel": "Abbrechen",
  "common.save": "Speichern",
  "common.confirm": "Bestätigen",
  "common.close": "Schließen",
  "common.add": "Hinzufügen",
  "common.back": "Zurück",
  "common.tagline": "Ohne die Frequenz existiert die Konversation nicht.",
  "auth.tagline": "Private Nachrichten nach Frequenz",
  "auth.loading": "Lade…",
  "auth.savedSession": "Auf diesem Gerät ist eine Sitzung gespeichert.",
  "auth.tab.login": "Anmelden",
  "auth.tab.register": "Konto erstellen",
  "auth.field.devicePin": "Geräte-PIN",
  "auth.field.username": "Benutzer",
  "auth.field.password": "Passwort",
  "auth.btn.unlock": "Entsperren",
  "auth.btn.unlocking": "Entsperre…",
  "auth.btn.processing": "Verarbeitung…",
  "auth.btn.useOther": "Anderes Konto verwenden",
  "auth.btn.forget": "Dieses Gerät vergessen",
  "auth.btn.backToUnlock": "Zurück zum Entsperren",
  "auth.confirmForget": "Dieses Gerät vergessen? Die gespeicherte Sitzung und zwischengespeicherte Nachrichten werden gelöscht.",
  "auth.error.userExists": "Dieser Benutzer existiert bereits. Wähle einen anderen.",
  "auth.error.badCreds": "Falscher Benutzername oder Passwort.",
  "auth.error.userNotFound": "Benutzer nicht gefunden.",
  "auth.error.cantConnect": "Verbindung zum Server nicht möglich.",
  "auth.error.badPin": "Falsche PIN.",
  "auth.footnote": "E2E-Verschlüsselung mit NaCl box. Frequenzen: Argon2id + deterministisches HMAC.",
  "sidebar.general": "Allgemeine Frequenz",
  "sidebar.freq": "Frequenz {0}",
  "sidebar.tune": "Frequenz einstellen",
  "sidebar.exitFreq": "{0} verlassen",
  "sidebar.notifications": "Benachrichtigungen",
  "sidebar.remember": "Gerät merken",
  "sidebar.forget": "Gerät vergessen",
  "sidebar.addContact": "Kontakt per Syphrax-ID hinzufügen",
  "sidebar.newGroup": "Neue Gruppe",
  "sidebar.settings": "Einstellungen",
  "sidebar.logout": "Abmelden",
  "sidebar.tooltip.logout": "Abmelden und alles lokal löschen",
  "sidebar.savedFreq.tooltip": "{0} einstellen",
  "chat.empty": "Wähle oder füge einen Kontakt hinzu",
  "welcome.title": "Willkommen bei Syphrax",
  "welcome.concept": "Syphrax ist private Nachrichtenübermittlung auf Basis von Frequenzen. Eine Frequenz ist ein geheimer Schlüssel, den du und die Person, mit der du sprichst, beide kennen. Ohne diesen Schlüssel existiert die Konversation nicht — selbst die Plattform kann sie nicht rekonstruieren.",
  "welcome.step1": "Stelle dich auf eine Frequenz ein, die du mit der Person oder Gruppe teilst, mit der du sprechen möchtest.",
  "welcome.step2": "Füge ihre syphrax_id als Kontakt hinzu, oder bitte sie, deine hinzuzufügen.",
  "welcome.step3": "Beginne zu schreiben. Nur wer dieselbe Frequenz teilt, kann die Nachrichten lesen.",
  "welcome.multidevice": "Jedes Gerät behält seine Frequenzen und Nachrichten unabhängig. Wenn du dich von einem anderen Gerät anmeldest, musst du dich erneut auf die Frequenzen einstellen.",
  "welcome.btnFreq": "Frequenz einstellen",
  "welcome.btnContacts": "Kontakt hinzufügen",
  "push.btnOn": "Benachrichtigungen AN",
  "push.btnOff": "Benachrichtigungen AUS",
  "push.btnEnable": "Benachrichtigungen deaktiviert. Zum Aktivieren klicken.",
  "push.btnDisable": "Benachrichtigungen aktiviert. Zum Deaktivieren klicken.",
  "push.introTitle": "Bevor du Benachrichtigungen aktivierst",
  "push.introBody": "Aus Datenschutzgründen funktionieren Syphrax-Benachrichtigungen anders als bei anderen Messaging-Apps:",
  "push.introBullet1": "Der Nachrichteninhalt wird nicht eingeschlossen.",
  "push.introBullet2": "Weder der Name noch die syphrax_id des Absenders werden angezeigt.",
  "push.introBullet3": "Du erhältst nur einen Hinweis „neue Nachricht\", um die App zu öffnen und sie verschlüsselt auf deinem Gerät zu lesen.",
  "push.introConfirm": "Benachrichtigungen aktivieren",
  "chat.placeholder": "Schreibe eine Nachricht…",
  "chat.editPlaceholder": "Bearbeite deine Nachricht…",
  "chat.replyingTo": "Antwort an {0}",
  "chat.editing": "Nachricht bearbeiten",
  "chat.confirmContact": "Zu Kontakten hinzufügen",
  "chat.unconfirmedBanner": "Dieser Nutzer hat dir geschrieben, ist aber nicht in deinen Kontakten. Solange du ihn nicht hinzufügst, sind dein Foto und deine Infos für ihn nicht sichtbar.",
  "chat.online": "online",
  "chat.lastSeen": "zuletzt hier {0}",
  "chat.tooltip.attach": "Datei anhängen",
  "chat.tooltip.shareContact": "Kontakt teilen",
  "chat.tooltip.paste": "Bild aus der Zwischenablage einfügen",
  "chat.tooltip.stickers": "Sticker",
  "chat.tooltip.callAudio": "Sprachanruf",
  "chat.tooltip.callVideo": "Videoanruf",
  "chat.btn.send": "Senden",
  "chat.uploading": "…",
  "preview.image": "📷 Bild",
  "preview.video": "🎬 Video",
  "preview.audio": "🎙 Audio",
  "bubble.reply": "Antworten",
  "bubble.edit": "Bearbeiten",
  "bubble.edited": "bearbeitet",
  "bubble.contact.label": "Syphrax-Kontakt",
  "bubble.media.decrypting": "Entschlüssele…",
  "bubble.media.failed": "Datei konnte nicht entschlüsselt werden.",
  "call.calling": "Anruf…",
  "call.incoming.audio": "Eingehender Anruf",
  "call.incoming.video": "Eingehender Videoanruf",
  "call.connecting": "Verbinde…",
  "call.ending": "Beenden…",
  "call.accept": "Annehmen",
  "call.reject": "Ablehnen",
  "call.hangup": "Auflegen",
  "call.mic": "Mikrofon",
  "call.camera": "Kamera",
  "call.audioOut": "Audioausgabe",
  "call.audioOut.auto": "Auto",
  "call.error.notInFreq": "Um anzurufen, musst du auf eine Frequenz eingestellt sein.",
  "error.notFound": "Ressource nicht gefunden.",
  "error.notInFreq": "{0} hat sich noch nicht auf diese Frequenz eingestellt. Bitte ihn über einen anderen Kanal, sich darauf einzustellen.",
  "error.push.iosTooOld": "Dein iOS ist älter als 16.4. Aktualisiere es, um Benachrichtigungen zu erhalten.",
  "error.push.iosNotStandalone": "Um auf dem iPhone Benachrichtigungen zu erhalten, installiere Syphrax auf dem Home-Bildschirm: tippe auf Teilen → Zum Home-Bildschirm.",
  "error.expired": "Sitzung abgelaufen. Melde dich erneut an.",
  "error.gone": "Die Datei ist abgelaufen.",
  "error.invalid": "Ungültige Daten.",
  "error.server": "Serverfehler. Versuch es erneut.",
  "error.network": "Keine Verbindung zum Server.",
  "error.cantStartCall": "Anruf konnte nicht gestartet werden: {0}",
  "error.cantAcceptCall": "Anruf konnte nicht angenommen werden: {0}",
  "error.cantPaste": "Zugriff auf die Zwischenablage nicht möglich. Verwende den Anhang-Button.",
  "error.noImageInClipboard": "Kein Bild in der Zwischenablage.",
  "error.clipboardUnsupported": "Dein Browser erlaubt das Lesen der Zwischenablage nicht. Verwende Strg+V oder den Anhang-Button.",
  "error.selfContact": "Du kannst dich nicht selbst hinzufügen.",
  "error.blocked": "Du hast diesen Nutzer blockiert. Entsperre ihn in den Einstellungen, um wieder zu schreiben.",
  "settings.title": "Einstellungen",
  "settings.close": "Schließen",
  "settings.tab.profile": "👤 Profil",
  "settings.tab.privacy": "🔒 Privatsphäre",
  "settings.tab.messages": "✉ Nachrichten",
  "settings.tab.blocked": "🚫 Blockiert",
  "settings.tab.notifications": "🔔 Benachrichtigungen",
  "settings.tab.session": "⏱ Sitzung",
  "settings.tab.account": "🆔 Konto",
  "settings.tab.language": "🌐 Sprache",
  "settings.tab.about": "ℹ Über",
  "settings.scope.global": "Global (allgemeine Frequenz)",
  "settings.scope.freq": "Nur auf {0}",
  "settings.profile.title": "Profil",
  "settings.profile.hintGlobal": "Diese Werte werden standardmäßig verwendet und auf allen Frequenzen vererbt.",
  "settings.profile.hintFreq": "Sie überschreiben das globale Profil, wenn du auf {0} bist. Wenn du hier nichts definierst, wird vom globalen geerbt.",
  "settings.profile.displayName": "Anzeigename",
  "settings.profile.displayNamePh.global": "(ohne Name — deine syphrax id wird angezeigt)",
  "settings.profile.displayNamePh.freq": "(erbt vom globalen)",
  "settings.profile.photo": "Profilbild",
  "settings.profile.changePhoto": "Foto ändern",
  "settings.profile.removePhoto": "Foto entfernen",
  "settings.profile.info": "Info / Status",
  "settings.profile.infoPh": "Hallo, ich benutze Syphrax",
  "settings.profile.removeOverride": "Override von {0} entfernen",
  "settings.profile.warn": "Änderungen werden automatisch an deine Kontakte gesendet, wenn du auf dieser Frequenz mit ihnen interagierst.",
  "settings.privacy.title": "Privatsphäre",
  "settings.privacy.hintGlobal": "Lege fest, wer deine Informationen standardmäßig sehen kann.",
  "settings.privacy.hintFreq": "Überschreibt diese Regeln nur, wenn du auf {0} bist.",
  "settings.privacy.showPhoto": "Wer sieht mein Foto",
  "settings.privacy.showInfo": "Wer sieht meine Info / Status",
  "settings.privacy.showLastSeen": "Wer sieht meinen zuletzt online",
  "settings.privacy.showOnline": "Wer sieht, ob ich online bin",
  "settings.privacy.whoAdds": "Wer kann mich zu Gruppen hinzufügen",
  "settings.privacy.readReceipts": "Lesebestätigungen",
  "settings.privacy.readReceiptsHint": "Wenn du es deaktivierst, werden keine blauen Häkchen gesendet, wenn du Nachrichten liest. Du siehst auch die der anderen nicht.",
  "settings.vis.all": "Alle",
  "settings.vis.contacts": "Meine Kontakte",
  "settings.vis.none": "Niemand",
  "settings.messages.title": "Nachrichten",
  "settings.messages.ttl": "Standardablauf",
  "settings.messages.ttlHint": "Die Nachrichten, die du sendest, werden nach dieser Zeit vom Server gelöscht.",
  "settings.blocked.title": "Blockiert",
  "settings.blocked.hint": "Blockierte Nutzer können dir keine Nachrichten senden. Du kannst ihnen auch keine senden.",
  "settings.blocked.placeholder": "Syphrax-ID zum Blockieren",
  "settings.blocked.btn": "Blockieren",
  "settings.blocked.unblock": "Entsperren",
  "settings.blocked.empty": "Du hast niemanden blockiert.",
  "settings.notif.title": "Benachrichtigungen",
  "settings.notif.sound": "Ton",
  "settings.notif.preview": "Nachrichtenvorschau anzeigen",
  "settings.notif.vibration": "Vibration (mobil)",
  "settings.notif.hint": "Browser-Push-Benachrichtigungen werden nur für Nachrichten auf der allgemeinen Frequenz gesendet.",
  "settings.session.title": "Sitzung",
  "settings.session.timeout": "Frequenz nach Inaktivität schließen",
  "settings.session.timeoutHint": "Wenn du diese Zeit ohne Nutzung der App verbringst, wird die aktive Frequenz automatisch deaktiviert.",
  "settings.session.remember": "Verwendete Frequenzen merken",
  "settings.session.rememberHint": "Wenn aktiviert, erscheinen die Frequenzen, auf die du dich einstellst, als Verknüpfungen in der Seitenleiste.",
  "settings.account.title": "Konto",
  "settings.account.idLabel": "Deine syphrax id",
  "settings.account.email": "Optionale E-Mail (nur für Wiederherstellung, nie veröffentlicht)",
  "settings.account.emailPh": "email@beispiel.com",
  "settings.account.changePassword": "Passwort ändern",
  "settings.account.currentPw": "Aktuelles Passwort",
  "settings.account.newPw": "Neues Passwort (min. 8)",
  "settings.account.confirmPw": "Wiederhole das neue",
  "settings.account.saving": "Speichere…",
  "settings.account.success": "Passwort aktualisiert.",
  "settings.account.errPwBad": "Das aktuelle Passwort ist nicht korrekt.",
  "settings.account.errPwShort": "Das neue Passwort muss mindestens 8 Zeichen haben.",
  "settings.account.errPwMismatch": "Die Passwörter stimmen nicht überein.",
  "settings.language.title": "Sprache",
  "settings.language.hint": "Wähle die Sprache der Oberfläche. Deine Einstellung wird auf diesem Gerät gespeichert.",
  "settings.about.title": "Über Syphrax",
  "settings.about.version": "MVP-Version in Entwicklung.",
  "settings.about.tech": "E2E-Verschlüsselung mit NaCl box (X25519). Frequenzen: Argon2id-Ableitung + deterministisches HMAC.",
  "modal.freq.title": "Frequenz einstellen",
  "modal.freq.hint": "Gib die geheime Zeichenkette der Frequenz ein.",
  "modal.freq.placeholder": "ALFA2025",
  "modal.freq.activate": "Aktivieren",
  "modal.freq.deriving": "Leite Schlüssel ab…",
  "modal.freq.warn": "Wenn du diese Zeichenkette vergisst, verlierst du den Zugriff auf die Konversationen dieser Frequenz.",
  "modal.freq.errShort": "Die Frequenz muss mindestens 8 Zeichen haben.",
  "modal.freq.errCommon": "Diese Zeichenkette ist zu häufig.",
  "modal.freq.errRepeat": "Verwende kein einzelnes wiederholtes Zeichen.",
  "modal.freq.errSeqNum": "Vermeide offensichtliche Zahlenfolgen.",
  "modal.freq.errSeqAlpha": "Vermeide alphabetische Folgen.",
  "modal.share.title": "Kontakt teilen",
  "modal.share.hint": "Wähle einen Kontakt aus der Liste oder gib eine syphrax id manuell ein.",
  "modal.share.filter": "Kontakte filtern…",
  "modal.share.empty": "Keine Kontakte auf dieser Frequenz",
  "modal.share.manual": "Oder eine manuelle syphrax id",
  "modal.share.btn": "Teilen",
  "modal.group.title": "Neue Gruppe",
  "modal.group.hint": "Wähle einen Namen und wähle Mitglieder aus deinen Kontakten auf dieser Frequenz.",
  "modal.group.namePh": "Gruppenname",
  "modal.group.selected": "{0} ausgewählt",
  "modal.group.create": "Gruppe erstellen",
  "modal.remember.title": "Dieses Gerät merken",
  "modal.remember.hint": "Deine Sitzung, Kontakte, Gruppen und Nachrichten werden auf diesem Gerät gespeichert, verschlüsselt mit einer PIN, die nur du kennst.",
  "modal.remember.pin": "PIN",
  "modal.remember.confirm": "Wiederhole die PIN",
  "modal.remember.warn": "Wenn du die PIN vergisst, können die gespeicherten Daten nicht wiederhergestellt werden.",
  "modal.remember.errShort": "Die PIN muss mindestens 4 Zeichen haben.",
  "modal.remember.errMismatch": "Die PINs stimmen nicht überein.",
  "stickers.faces": "Gesichter",
  "stickers.gestures": "Gesten",
  "stickers.hearts": "Herzen",
  "stickers.symbols": "Symbole",
  "stickers.animals": "Tiere",
  "stickers.food": "Essen",
  "ttl.1h": "1 Stunde",
  "ttl.1d": "1 Tag",
  "ttl.1w": "1 Woche",
  "ttl.1m": "1 Monat",
  "ttl.6m": "6 Monate",
  "ttl.12m": "12 Monate",
  "timeout.5min": "5 Min.",
  "timeout.15min": "15 Min.",
  "timeout.30min": "30 Min.",
  "timeout.never": "Nie",
  "toast.newMessage": "Neue Nachricht",
  "toast.group": "{0} (Gruppe)",
};

const nl: Catalog = {
  "common.cancel": "Annuleren",
  "common.save": "Opslaan",
  "common.confirm": "Bevestigen",
  "common.close": "Sluiten",
  "common.add": "Toevoegen",
  "common.back": "Terug",
  "common.tagline": "Zonder de frequentie bestaat het gesprek niet.",
  "auth.tagline": "Privéberichten op frequentie",
  "auth.loading": "Laden…",
  "auth.savedSession": "Er is een opgeslagen sessie op dit apparaat.",
  "auth.tab.login": "Inloggen",
  "auth.tab.register": "Account aanmaken",
  "auth.field.devicePin": "Apparaat-PIN",
  "auth.field.username": "Gebruiker",
  "auth.field.password": "Wachtwoord",
  "auth.btn.unlock": "Ontgrendelen",
  "auth.btn.unlocking": "Ontgrendelen…",
  "auth.btn.processing": "Verwerken…",
  "auth.btn.useOther": "Ander account gebruiken",
  "auth.btn.forget": "Dit apparaat vergeten",
  "auth.btn.backToUnlock": "Terug naar ontgrendelen",
  "auth.confirmForget": "Dit apparaat vergeten? De opgeslagen sessie en gecachte berichten worden verwijderd.",
  "auth.error.userExists": "Die gebruiker bestaat al. Kies een andere.",
  "auth.error.badCreds": "Verkeerde gebruikersnaam of wachtwoord.",
  "auth.error.userNotFound": "Gebruiker niet gevonden.",
  "auth.error.cantConnect": "Kon geen verbinding maken met de server.",
  "auth.error.badPin": "Verkeerde PIN.",
  "auth.footnote": "E2E-encryptie met NaCl box. Frequenties: Argon2id + deterministische HMAC.",
  "sidebar.general": "Algemene frequentie",
  "sidebar.freq": "Frequentie {0}",
  "sidebar.tune": "Frequentie afstemmen",
  "sidebar.exitFreq": "{0} verlaten",
  "sidebar.notifications": "Meldingen",
  "sidebar.remember": "Apparaat onthouden",
  "sidebar.forget": "Apparaat vergeten",
  "sidebar.addContact": "Contact toevoegen via Syphrax-ID",
  "sidebar.newGroup": "Nieuwe groep",
  "sidebar.settings": "Instellingen",
  "sidebar.logout": "Uitloggen",
  "sidebar.tooltip.logout": "Uitloggen en alles lokaal wissen",
  "sidebar.savedFreq.tooltip": "{0} afstemmen",
  "chat.empty": "Selecteer of voeg een contact toe",
  "welcome.title": "Welkom bij Syphrax",
  "welcome.concept": "Syphrax is privéberichten op basis van frequenties. Een frequentie is een geheime sleutel die jij en de persoon met wie je praat allebei kennen. Zonder die sleutel bestaat het gesprek niet — zelfs het platform kan het niet reconstrueren.",
  "welcome.step1": "Stem af op een frequentie die je deelt met de persoon of groep met wie je wilt praten.",
  "welcome.step2": "Voeg hun syphrax_id toe als contact, of vraag hen om de jouwe toe te voegen.",
  "welcome.step3": "Begin met schrijven. Alleen wie dezelfde frequentie deelt, kan de berichten lezen.",
  "welcome.multidevice": "Elk apparaat houdt zijn eigen frequenties en berichten apart. Als je inlogt vanaf een ander apparaat moet je de frequenties opnieuw afstemmen.",
  "welcome.btnFreq": "Frequentie afstemmen",
  "welcome.btnContacts": "Contact toevoegen",
  "push.btnOn": "Meldingen AAN",
  "push.btnOff": "Meldingen UIT",
  "push.btnEnable": "Meldingen uitgeschakeld. Klik om in te schakelen.",
  "push.btnDisable": "Meldingen ingeschakeld. Klik om uit te schakelen.",
  "push.introTitle": "Voordat je meldingen inschakelt",
  "push.introBody": "Voor privacy werken Syphrax-meldingen anders dan bij andere berichtenapps:",
  "push.introBullet1": "De inhoud van het bericht wordt niet meegestuurd.",
  "push.introBullet2": "Noch de naam noch de syphrax_id van de afzender wordt getoond.",
  "push.introBullet3": "Je krijgt alleen een melding \"nieuw bericht\" om de app te openen en het versleuteld op je apparaat te lezen.",
  "push.introConfirm": "Meldingen inschakelen",
  "chat.placeholder": "Schrijf een bericht…",
  "chat.editPlaceholder": "Bewerk je bericht…",
  "chat.replyingTo": "Antwoord op {0}",
  "chat.editing": "Bericht bewerken",
  "chat.confirmContact": "Aan contacten toevoegen",
  "chat.unconfirmedBanner": "Deze gebruiker heeft je geschreven maar staat niet in je contacten. Tot je hem toevoegt zijn je foto en info niet zichtbaar.",
  "chat.online": "online",
  "chat.lastSeen": "laatst hier {0}",
  "chat.tooltip.attach": "Bestand bijvoegen",
  "chat.tooltip.shareContact": "Contact delen",
  "chat.tooltip.paste": "Afbeelding plakken vanaf klembord",
  "chat.tooltip.stickers": "Stickers",
  "chat.tooltip.callAudio": "Spraakoproep",
  "chat.tooltip.callVideo": "Videogesprek",
  "chat.btn.send": "Versturen",
  "chat.uploading": "…",
  "preview.image": "📷 Afbeelding",
  "preview.video": "🎬 Video",
  "preview.audio": "🎙 Audio",
  "bubble.reply": "Antwoorden",
  "bubble.edit": "Bewerken",
  "bubble.edited": "bewerkt",
  "bubble.contact.label": "Syphrax-contact",
  "bubble.media.decrypting": "Ontsleutelen…",
  "bubble.media.failed": "Bestand kan niet worden ontsleuteld.",
  "call.calling": "Bellen…",
  "call.incoming.audio": "Inkomende oproep",
  "call.incoming.video": "Inkomend videogesprek",
  "call.connecting": "Verbinden…",
  "call.ending": "Beëindigen…",
  "call.accept": "Beantwoorden",
  "call.reject": "Weigeren",
  "call.hangup": "Ophangen",
  "call.mic": "Microfoon",
  "call.camera": "Camera",
  "call.audioOut": "Audio-uitgang",
  "call.audioOut.auto": "Auto",
  "call.error.notInFreq": "Om te bellen moet je afgestemd zijn op een frequentie.",
  "error.notFound": "Bron niet gevonden.",
  "error.notInFreq": "{0} heeft nog niet op deze frequentie afgestemd. Vraag hem via een ander kanaal om af te stemmen.",
  "error.push.iosTooOld": "Je iOS is ouder dan 16.4. Werk het bij om meldingen te ontvangen.",
  "error.push.iosNotStandalone": "Om meldingen op iPhone te ontvangen, installeer Syphrax op het beginscherm: tik op Delen → Zet op beginscherm.",
  "error.expired": "Sessie verlopen. Log opnieuw in.",
  "error.gone": "Het bestand is verlopen.",
  "error.invalid": "Ongeldige gegevens.",
  "error.server": "Serverfout. Probeer opnieuw.",
  "error.network": "Geen verbinding met de server.",
  "error.cantStartCall": "Oproep kon niet worden gestart: {0}",
  "error.cantAcceptCall": "Oproep kon niet worden beantwoord: {0}",
  "error.cantPaste": "Geen toegang tot het klembord. Gebruik de bijlageknop.",
  "error.noImageInClipboard": "Geen afbeelding op het klembord.",
  "error.clipboardUnsupported": "Je browser staat het lezen van het klembord niet toe. Gebruik Ctrl+V of de bijlageknop.",
  "error.selfContact": "Je kunt jezelf niet toevoegen.",
  "error.blocked": "Je hebt deze gebruiker geblokkeerd. Deblokkeer hem in Instellingen om weer te praten.",
  "settings.title": "Instellingen",
  "settings.close": "Sluiten",
  "settings.tab.profile": "👤 Profiel",
  "settings.tab.privacy": "🔒 Privacy",
  "settings.tab.messages": "✉ Berichten",
  "settings.tab.blocked": "🚫 Geblokkeerd",
  "settings.tab.notifications": "🔔 Meldingen",
  "settings.tab.session": "⏱ Sessie",
  "settings.tab.account": "🆔 Account",
  "settings.tab.language": "🌐 Taal",
  "settings.tab.about": "ℹ Over",
  "settings.scope.global": "Globaal (algemene frequentie)",
  "settings.scope.freq": "Alleen op {0}",
  "settings.profile.title": "Profiel",
  "settings.profile.hintGlobal": "Deze waarden worden standaard gebruikt en geërfd op alle frequenties.",
  "settings.profile.hintFreq": "Ze overschrijven het globale profiel wanneer je op {0} bent. Als je hier niets definieert, wordt het overgenomen van het globale.",
  "settings.profile.displayName": "Weergavenaam",
  "settings.profile.displayNamePh.global": "(geen naam — je syphrax id wordt getoond)",
  "settings.profile.displayNamePh.freq": "(neemt over van globaal)",
  "settings.profile.photo": "Profielfoto",
  "settings.profile.changePhoto": "Foto wijzigen",
  "settings.profile.removePhoto": "Foto verwijderen",
  "settings.profile.info": "Info / Status",
  "settings.profile.infoPh": "Hoi, ik gebruik Syphrax",
  "settings.profile.removeOverride": "Override van {0} verwijderen",
  "settings.profile.warn": "Wijzigingen worden automatisch naar je contacten gestuurd wanneer je op deze frequentie met hen omgaat.",
  "settings.privacy.title": "Privacy",
  "settings.privacy.hintGlobal": "Stel in wie elke informatie van jou standaard kan zien.",
  "settings.privacy.hintFreq": "Overschrijft deze regels alleen wanneer je op {0} bent.",
  "settings.privacy.showPhoto": "Wie ziet mijn foto",
  "settings.privacy.showInfo": "Wie ziet mijn info / status",
  "settings.privacy.showLastSeen": "Wie ziet mijn laatst gezien",
  "settings.privacy.showOnline": "Wie ziet of ik online ben",
  "settings.privacy.whoAdds": "Wie kan me aan groepen toevoegen",
  "settings.privacy.readReceipts": "Leesbevestigingen",
  "settings.privacy.readReceiptsHint": "Als je het uitschakelt, worden geen blauwe vinkjes verzonden wanneer je berichten leest. Je ziet ook die van anderen niet.",
  "settings.vis.all": "Iedereen",
  "settings.vis.contacts": "Mijn contacten",
  "settings.vis.none": "Niemand",
  "settings.messages.title": "Berichten",
  "settings.messages.ttl": "Standaard verloop",
  "settings.messages.ttlHint": "Berichten die je verstuurt worden na deze tijd van de server verwijderd.",
  "settings.blocked.title": "Geblokkeerd",
  "settings.blocked.hint": "Geblokkeerde gebruikers kunnen je geen berichten sturen. Je kunt ze ook geen berichten sturen.",
  "settings.blocked.placeholder": "Syphrax-ID om te blokkeren",
  "settings.blocked.btn": "Blokkeren",
  "settings.blocked.unblock": "Deblokkeren",
  "settings.blocked.empty": "Je hebt niemand geblokkeerd.",
  "settings.notif.title": "Meldingen",
  "settings.notif.sound": "Geluid",
  "settings.notif.preview": "Berichtvoorbeeld tonen",
  "settings.notif.vibration": "Trilling (mobiel)",
  "settings.notif.hint": "Browser push-meldingen worden alleen verzonden voor berichten op de algemene frequentie.",
  "settings.session.title": "Sessie",
  "settings.session.timeout": "Frequentie sluiten na inactiviteit",
  "settings.session.timeoutHint": "Als je deze tijd doorbrengt zonder de app aan te raken, wordt de actieve frequentie automatisch uitgeschakeld.",
  "settings.session.remember": "Gebruikte frequenties onthouden",
  "settings.session.rememberHint": "Indien ingeschakeld verschijnen de frequenties die je afstemt als snelkoppelingen in de zijbalk.",
  "settings.account.title": "Account",
  "settings.account.idLabel": "Jouw syphrax id",
  "settings.account.email": "Optionele e-mail (alleen voor herstel, nooit gepubliceerd)",
  "settings.account.emailPh": "email@voorbeeld.com",
  "settings.account.changePassword": "Wachtwoord wijzigen",
  "settings.account.currentPw": "Huidig wachtwoord",
  "settings.account.newPw": "Nieuw wachtwoord (min. 8)",
  "settings.account.confirmPw": "Herhaal de nieuwe",
  "settings.account.saving": "Opslaan…",
  "settings.account.success": "Wachtwoord bijgewerkt.",
  "settings.account.errPwBad": "Het huidige wachtwoord is niet juist.",
  "settings.account.errPwShort": "Het nieuwe wachtwoord moet minstens 8 tekens hebben.",
  "settings.account.errPwMismatch": "De wachtwoorden komen niet overeen.",
  "settings.language.title": "Taal",
  "settings.language.hint": "Kies de taal van de interface. Je voorkeur wordt op dit apparaat opgeslagen.",
  "settings.about.title": "Over Syphrax",
  "settings.about.version": "MVP-versie in ontwikkeling.",
  "settings.about.tech": "E2E-encryptie met NaCl box (X25519). Frequenties: Argon2id afleiding + deterministische HMAC.",
  "modal.freq.title": "Frequentie afstemmen",
  "modal.freq.hint": "Voer de geheime string van de frequentie in.",
  "modal.freq.placeholder": "ALFA2025",
  "modal.freq.activate": "Activeren",
  "modal.freq.deriving": "Sleutel afleiden…",
  "modal.freq.warn": "Als je deze string vergeet, verlies je toegang tot de gesprekken op deze frequentie.",
  "modal.freq.errShort": "De frequentie moet minstens 8 tekens hebben.",
  "modal.freq.errCommon": "Die string is te gewoon.",
  "modal.freq.errRepeat": "Gebruik geen enkel herhaald teken.",
  "modal.freq.errSeqNum": "Vermijd voor de hand liggende numerieke reeksen.",
  "modal.freq.errSeqAlpha": "Vermijd alfabetische reeksen.",
  "modal.share.title": "Contact delen",
  "modal.share.hint": "Kies een contact uit de lijst of voer handmatig een syphrax id in.",
  "modal.share.filter": "Contacten filteren…",
  "modal.share.empty": "Geen contacten op deze frequentie",
  "modal.share.manual": "Of een handmatige syphrax id",
  "modal.share.btn": "Delen",
  "modal.group.title": "Nieuwe groep",
  "modal.group.hint": "Kies een naam en selecteer leden uit je contacten op deze frequentie.",
  "modal.group.namePh": "Groepsnaam",
  "modal.group.selected": "{0} geselecteerd",
  "modal.group.create": "Groep maken",
  "modal.remember.title": "Dit apparaat onthouden",
  "modal.remember.hint": "Je sessie, contacten, groepen en berichten worden op dit apparaat opgeslagen, versleuteld met een PIN die alleen jij kent.",
  "modal.remember.pin": "PIN",
  "modal.remember.confirm": "Herhaal de PIN",
  "modal.remember.warn": "Als je de PIN vergeet kunnen de opgeslagen gegevens niet hersteld worden.",
  "modal.remember.errShort": "De PIN moet minstens 4 tekens hebben.",
  "modal.remember.errMismatch": "De PINs komen niet overeen.",
  "stickers.faces": "Gezichten",
  "stickers.gestures": "Gebaren",
  "stickers.hearts": "Harten",
  "stickers.symbols": "Symbolen",
  "stickers.animals": "Dieren",
  "stickers.food": "Eten",
  "ttl.1h": "1 uur",
  "ttl.1d": "1 dag",
  "ttl.1w": "1 week",
  "ttl.1m": "1 maand",
  "ttl.6m": "6 maanden",
  "ttl.12m": "12 maanden",
  "timeout.5min": "5 min",
  "timeout.15min": "15 min",
  "timeout.30min": "30 min",
  "timeout.never": "Nooit",
  "toast.newMessage": "Nieuw bericht",
  "toast.group": "{0} (groep)",
};

const pl: Catalog = {
  "common.cancel": "Anuluj",
  "common.save": "Zapisz",
  "common.confirm": "Potwierdź",
  "common.close": "Zamknij",
  "common.add": "Dodaj",
  "common.back": "Wstecz",
  "common.tagline": "Jeśli nie znasz częstotliwości, rozmowa nie istnieje.",
  "auth.tagline": "Prywatne wiadomości na częstotliwości",
  "auth.loading": "Wczytywanie…",
  "auth.savedSession": "Na tym urządzeniu jest zapisana sesja.",
  "auth.tab.login": "Wejdź",
  "auth.tab.register": "Utwórz konto",
  "auth.field.devicePin": "PIN urządzenia",
  "auth.field.username": "Użytkownik",
  "auth.field.password": "Hasło",
  "auth.btn.unlock": "Odblokuj",
  "auth.btn.unlocking": "Odblokowywanie…",
  "auth.btn.processing": "Przetwarzanie…",
  "auth.btn.useOther": "Użyj innego konta",
  "auth.btn.forget": "Zapomnij to urządzenie",
  "auth.btn.backToUnlock": "Powrót do odblokowania",
  "auth.confirmForget": "Zapomnieć to urządzenie? Zapisana sesja i wiadomości w pamięci podręcznej zostaną usunięte.",
  "auth.error.userExists": "Ten użytkownik już istnieje. Wybierz innego.",
  "auth.error.badCreds": "Nieprawidłowy użytkownik lub hasło.",
  "auth.error.userNotFound": "Nie znaleziono użytkownika.",
  "auth.error.cantConnect": "Nie można połączyć się z serwerem.",
  "auth.error.badPin": "Nieprawidłowy PIN.",
  "auth.footnote": "Szyfrowanie E2E z NaCl box. Częstotliwości: Argon2id + deterministyczny HMAC.",
  "sidebar.general": "Częstotliwość ogólna",
  "sidebar.freq": "Częstotliwość {0}",
  "sidebar.tune": "Nastrój częstotliwość",
  "sidebar.exitFreq": "Opuść {0}",
  "sidebar.notifications": "Powiadomienia",
  "sidebar.remember": "Zapamiętaj urządzenie",
  "sidebar.forget": "Zapomnij urządzenie",
  "sidebar.addContact": "Dodaj kontakt po Syphrax ID",
  "sidebar.newGroup": "Nowa grupa",
  "sidebar.settings": "Ustawienia",
  "sidebar.logout": "Wyloguj",
  "sidebar.tooltip.logout": "Wyloguj się i usuń wszystko lokalnie",
  "sidebar.savedFreq.tooltip": "Nastrój {0}",
  "chat.empty": "Wybierz lub dodaj kontakt",
  "welcome.title": "Witaj w Syphrax",
  "welcome.concept": "Syphrax to prywatne wiadomości oparte na częstotliwościach. Częstotliwość to tajny klucz, który znasz Ty i osoba, z którą rozmawiasz. Bez tego klucza rozmowa nie istnieje — nawet platforma nie może jej odtworzyć.",
  "welcome.step1": "Dostrój się do częstotliwości udostępnionej osobie lub grupie, z którą chcesz rozmawiać.",
  "welcome.step2": "Dodaj jej syphrax_id jako kontakt lub poproś ją, aby dodała Twój.",
  "welcome.step3": "Zacznij pisać. Tylko ci, którzy mają tę samą częstotliwość, mogą czytać wiadomości.",
  "welcome.multidevice": "Każde urządzenie przechowuje swoje częstotliwości i wiadomości niezależnie. Logując się z innego urządzenia, musisz ponownie dostroić częstotliwości.",
  "welcome.btnFreq": "Dostrój częstotliwość",
  "welcome.btnContacts": "Dodaj kontakt",
  "push.btnOn": "Powiadomienia WŁ",
  "push.btnOff": "Powiadomienia WYŁ",
  "push.btnEnable": "Powiadomienia wyłączone. Kliknij, aby włączyć.",
  "push.btnDisable": "Powiadomienia włączone. Kliknij, aby wyłączyć.",
  "push.introTitle": "Zanim włączysz powiadomienia",
  "push.introBody": "Ze względu na prywatność powiadomienia Syphrax działają inaczej niż w innych komunikatorach:",
  "push.introBullet1": "Treść wiadomości nie jest dołączana.",
  "push.introBullet2": "Nie pokazuje się ani imię, ani syphrax_id nadawcy.",
  "push.introBullet3": "Otrzymasz tylko alert \"nowa wiadomość\", aby otworzyć aplikację i przeczytać ją zaszyfrowaną na swoim urządzeniu.",
  "push.introConfirm": "Włącz powiadomienia",
  "chat.placeholder": "Napisz wiadomość…",
  "chat.editPlaceholder": "Edytuj wiadomość…",
  "chat.replyingTo": "Odpowiedź do {0}",
  "chat.editing": "Edycja wiadomości",
  "chat.confirmContact": "Dodaj do kontaktów",
  "chat.unconfirmedBanner": "Ten użytkownik napisał do Ciebie, ale nie ma go w Twoich kontaktach. Dopóki go nie dodasz, Twoje zdjęcie i informacje nie będą dla niego widoczne.",
  "chat.online": "online",
  "chat.lastSeen": "ostatnio tu {0}",
  "chat.tooltip.attach": "Załącz plik",
  "chat.tooltip.shareContact": "Udostępnij kontakt",
  "chat.tooltip.paste": "Wklej obraz ze schowka",
  "chat.tooltip.stickers": "Naklejki",
  "chat.tooltip.callAudio": "Połączenie głosowe",
  "chat.tooltip.callVideo": "Wideorozmowa",
  "chat.btn.send": "Wyślij",
  "chat.uploading": "…",
  "preview.image": "📷 Obraz",
  "preview.video": "🎬 Wideo",
  "preview.audio": "🎙 Audio",
  "bubble.reply": "Odpowiedz",
  "bubble.edit": "Edytuj",
  "bubble.edited": "edytowano",
  "bubble.contact.label": "Kontakt Syphrax",
  "bubble.media.decrypting": "Odszyfrowywanie…",
  "bubble.media.failed": "Nie można odszyfrować pliku.",
  "call.calling": "Dzwonię…",
  "call.incoming.audio": "Połączenie przychodzące",
  "call.incoming.video": "Wideorozmowa przychodząca",
  "call.connecting": "Łączenie…",
  "call.ending": "Kończenie…",
  "call.accept": "Odbierz",
  "call.reject": "Odrzuć",
  "call.hangup": "Rozłącz",
  "call.mic": "Mikrofon",
  "call.camera": "Kamera",
  "call.audioOut": "Wyjście audio",
  "call.audioOut.auto": "Auto",
  "call.error.notInFreq": "Aby zadzwonić musisz być nastrojony na częstotliwości.",
  "error.notFound": "Nie znaleziono zasobu.",
  "error.notInFreq": "{0} jeszcze nie nastroił się na tę częstotliwość. Poproś go innym kanałem, żeby się nastroił.",
  "error.push.iosTooOld": "Twój iOS jest starszy niż 16.4. Zaktualizuj go, aby otrzymywać powiadomienia.",
  "error.push.iosNotStandalone": "Aby otrzymywać powiadomienia na iPhonie, zainstaluj Syphrax na ekranie głównym: dotknij Udostępnij → Dodaj do ekranu głównego.",
  "error.expired": "Sesja wygasła. Zaloguj się ponownie.",
  "error.gone": "Plik wygasł.",
  "error.invalid": "Nieprawidłowe dane.",
  "error.server": "Błąd serwera. Spróbuj ponownie.",
  "error.network": "Brak połączenia z serwerem.",
  "error.cantStartCall": "Nie można rozpocząć połączenia: {0}",
  "error.cantAcceptCall": "Nie można odebrać połączenia: {0}",
  "error.cantPaste": "Brak dostępu do schowka. Użyj przycisku załącznika.",
  "error.noImageInClipboard": "Brak obrazu w schowku.",
  "error.clipboardUnsupported": "Twoja przeglądarka nie pozwala czytać schowka. Użyj Ctrl+V lub przycisku załącznika.",
  "error.selfContact": "Nie możesz dodać siebie.",
  "error.blocked": "Zablokowałeś tego użytkownika. Odblokuj go w Ustawieniach, aby znów rozmawiać.",
  "settings.title": "Ustawienia",
  "settings.close": "Zamknij",
  "settings.tab.profile": "👤 Profil",
  "settings.tab.privacy": "🔒 Prywatność",
  "settings.tab.messages": "✉ Wiadomości",
  "settings.tab.blocked": "🚫 Zablokowani",
  "settings.tab.notifications": "🔔 Powiadomienia",
  "settings.tab.session": "⏱ Sesja",
  "settings.tab.account": "🆔 Konto",
  "settings.tab.language": "🌐 Język",
  "settings.tab.about": "ℹ O programie",
  "settings.scope.global": "Globalnie (częstotliwość ogólna)",
  "settings.scope.freq": "Tylko na {0}",
  "settings.profile.title": "Profil",
  "settings.profile.hintGlobal": "Te wartości są używane domyślnie i dziedziczone we wszystkich częstotliwościach.",
  "settings.profile.hintFreq": "Nadpisują profil globalny gdy jesteś na {0}. Jeśli czegoś tu nie zdefiniujesz, dziedziczy z globalnego.",
  "settings.profile.displayName": "Nazwa wyświetlana",
  "settings.profile.displayNamePh.global": "(bez nazwy — pokaże się twoje syphrax id)",
  "settings.profile.displayNamePh.freq": "(dziedziczy z globalnego)",
  "settings.profile.photo": "Zdjęcie profilowe",
  "settings.profile.changePhoto": "Zmień zdjęcie",
  "settings.profile.removePhoto": "Usuń zdjęcie",
  "settings.profile.info": "Info / Status",
  "settings.profile.infoPh": "Cześć, używam Syphrax",
  "settings.profile.removeOverride": "Usuń override {0}",
  "settings.profile.warn": "Zmiany zostaną automatycznie wysłane do twoich kontaktów gdy będziesz z nimi interagował na tej częstotliwości.",
  "settings.privacy.title": "Prywatność",
  "settings.privacy.hintGlobal": "Skonfiguruj kto domyślnie może zobaczyć każdą z twoich informacji.",
  "settings.privacy.hintFreq": "Nadpisuje te zasady tylko gdy jesteś na {0}.",
  "settings.privacy.showPhoto": "Kto widzi moje zdjęcie",
  "settings.privacy.showInfo": "Kto widzi moje info / status",
  "settings.privacy.showLastSeen": "Kto widzi moją ostatnią aktywność",
  "settings.privacy.showOnline": "Kto widzi czy jestem online",
  "settings.privacy.whoAdds": "Kto może dodać mnie do grup",
  "settings.privacy.readReceipts": "Potwierdzenia odczytu",
  "settings.privacy.readReceiptsHint": "Jeśli to wyłączysz, nie będą wysyłane niebieskie znaczniki gdy czytasz wiadomości. Nie zobaczysz też cudzych.",
  "settings.vis.all": "Wszyscy",
  "settings.vis.contacts": "Moje kontakty",
  "settings.vis.none": "Nikt",
  "settings.messages.title": "Wiadomości",
  "settings.messages.ttl": "Domyślne wygaśnięcie",
  "settings.messages.ttlHint": "Wiadomości które wysyłasz zostaną usunięte z serwera po tym czasie.",
  "settings.blocked.title": "Zablokowani",
  "settings.blocked.hint": "Zablokowani użytkownicy nie mogą wysyłać ci wiadomości. Ty również nie możesz wysyłać do nich.",
  "settings.blocked.placeholder": "syphrax id do zablokowania",
  "settings.blocked.btn": "Zablokuj",
  "settings.blocked.unblock": "Odblokuj",
  "settings.blocked.empty": "Nie masz nikogo zablokowanego.",
  "settings.notif.title": "Powiadomienia",
  "settings.notif.sound": "Dźwięk",
  "settings.notif.preview": "Pokazuj podgląd wiadomości",
  "settings.notif.vibration": "Wibracja (mobilne)",
  "settings.notif.hint": "Powiadomienia push przeglądarki są wysyłane tylko dla wiadomości na częstotliwości ogólnej.",
  "settings.session.title": "Sesja",
  "settings.session.timeout": "Zamknij częstotliwość po nieaktywności",
  "settings.session.timeoutHint": "Jeśli przez ten czas nie dotkniesz aplikacji, aktywna częstotliwość zostanie automatycznie wyłączona.",
  "settings.session.remember": "Zapamiętuj używane częstotliwości",
  "settings.session.rememberHint": "Jeśli włączone, częstotliwości na które się stroisz pojawiają się jako skróty w pasku bocznym.",
  "settings.account.title": "Konto",
  "settings.account.idLabel": "Twój syphrax id",
  "settings.account.email": "Email opcjonalny (tylko do odzyskiwania, nigdy publikowany)",
  "settings.account.emailPh": "email@przyklad.com",
  "settings.account.changePassword": "Zmień hasło",
  "settings.account.currentPw": "Obecne hasło",
  "settings.account.newPw": "Nowe hasło (min. 8)",
  "settings.account.confirmPw": "Powtórz nowe",
  "settings.account.saving": "Zapisywanie…",
  "settings.account.success": "Hasło zaktualizowane.",
  "settings.account.errPwBad": "Obecne hasło jest nieprawidłowe.",
  "settings.account.errPwShort": "Nowe hasło musi mieć co najmniej 8 znaków.",
  "settings.account.errPwMismatch": "Hasła się nie zgadzają.",
  "settings.language.title": "Język",
  "settings.language.hint": "Wybierz język interfejsu. Twoje preferencje są zapisywane na tym urządzeniu.",
  "settings.about.title": "O Syphrax",
  "settings.about.version": "Wersja MVP w rozwoju.",
  "settings.about.tech": "Szyfrowanie E2E z NaCl box (X25519). Częstotliwości: derywacja Argon2id + deterministyczny HMAC.",
  "modal.freq.title": "Nastrój częstotliwość",
  "modal.freq.hint": "Wprowadź tajny ciąg częstotliwości.",
  "modal.freq.placeholder": "ALFA2025",
  "modal.freq.activate": "Aktywuj",
  "modal.freq.deriving": "Wyprowadzanie klucza…",
  "modal.freq.warn": "Jeśli zapomnisz ten ciąg, stracisz dostęp do rozmów tej częstotliwości.",
  "modal.freq.errShort": "Częstotliwość musi mieć co najmniej 8 znaków.",
  "modal.freq.errCommon": "Ten ciąg jest zbyt powszechny.",
  "modal.freq.errRepeat": "Nie używaj jednego powtórzonego znaku.",
  "modal.freq.errSeqNum": "Unikaj oczywistych sekwencji numerycznych.",
  "modal.freq.errSeqAlpha": "Unikaj sekwencji alfabetycznych.",
  "modal.share.title": "Udostępnij kontakt",
  "modal.share.hint": "Wybierz kontakt z listy lub wprowadź ręcznie syphrax id.",
  "modal.share.filter": "Filtruj kontakty…",
  "modal.share.empty": "Brak kontaktów na tej częstotliwości",
  "modal.share.manual": "Lub ręczny syphrax id",
  "modal.share.btn": "Udostępnij",
  "modal.group.title": "Nowa grupa",
  "modal.group.hint": "Wybierz nazwę i zaznacz członków spośród kontaktów na tej częstotliwości.",
  "modal.group.namePh": "Nazwa grupy",
  "modal.group.selected": "{0} wybranych",
  "modal.group.create": "Utwórz grupę",
  "modal.remember.title": "Zapamiętaj to urządzenie",
  "modal.remember.hint": "Twoja sesja, kontakty, grupy i wiadomości zostaną zapisane na tym urządzeniu, zaszyfrowane PIN-em który tylko ty znasz.",
  "modal.remember.pin": "PIN",
  "modal.remember.confirm": "Powtórz PIN",
  "modal.remember.warn": "Jeśli zapomnisz PIN, zapisanych danych nie da się odzyskać.",
  "modal.remember.errShort": "PIN musi mieć co najmniej 4 znaki.",
  "modal.remember.errMismatch": "PIN-y się nie zgadzają.",
  "stickers.faces": "Twarze",
  "stickers.gestures": "Gesty",
  "stickers.hearts": "Serca",
  "stickers.symbols": "Symbole",
  "stickers.animals": "Zwierzęta",
  "stickers.food": "Jedzenie",
  "ttl.1h": "1 godz.",
  "ttl.1d": "1 dzień",
  "ttl.1w": "1 tydzień",
  "ttl.1m": "1 miesiąc",
  "ttl.6m": "6 miesięcy",
  "ttl.12m": "12 miesięcy",
  "timeout.5min": "5 min",
  "timeout.15min": "15 min",
  "timeout.30min": "30 min",
  "timeout.never": "Nigdy",
  "toast.newMessage": "Nowa wiadomość",
  "toast.group": "{0} (grupa)",
};

const cs: Catalog = {
  "common.cancel": "Zrušit",
  "common.save": "Uložit",
  "common.confirm": "Potvrdit",
  "common.close": "Zavřít",
  "common.add": "Přidat",
  "common.back": "Zpět",
  "common.tagline": "Bez frekvence rozhovor neexistuje.",
  "auth.tagline": "Soukromé zprávy podle frekvence",
  "auth.loading": "Načítání…",
  "auth.savedSession": "Na tomto zařízení je uložena relace.",
  "auth.tab.login": "Přihlásit",
  "auth.tab.register": "Vytvořit účet",
  "auth.field.devicePin": "PIN zařízení",
  "auth.field.username": "Uživatel",
  "auth.field.password": "Heslo",
  "auth.btn.unlock": "Odemknout",
  "auth.btn.unlocking": "Odemykám…",
  "auth.btn.processing": "Zpracovávám…",
  "auth.btn.useOther": "Použít jiný účet",
  "auth.btn.forget": "Zapomenout toto zařízení",
  "auth.btn.backToUnlock": "Zpět na odemknutí",
  "auth.confirmForget": "Zapomenout toto zařízení? Uložená relace a mezipaměť zpráv budou smazány.",
  "auth.error.userExists": "Tento uživatel již existuje. Zvolte jiného.",
  "auth.error.badCreds": "Nesprávné uživatelské jméno nebo heslo.",
  "auth.error.userNotFound": "Uživatel nenalezen.",
  "auth.error.cantConnect": "Nelze se připojit k serveru.",
  "auth.error.badPin": "Nesprávný PIN.",
  "auth.footnote": "E2E šifrování s NaCl box. Frekvence: Argon2id + deterministický HMAC.",
  "sidebar.general": "Obecná frekvence",
  "sidebar.freq": "Frekvence {0}",
  "sidebar.tune": "Naladit frekvenci",
  "sidebar.exitFreq": "Opustit {0}",
  "sidebar.notifications": "Oznámení",
  "sidebar.remember": "Pamatovat zařízení",
  "sidebar.forget": "Zapomenout zařízení",
  "sidebar.addContact": "Přidat kontakt podle Syphrax ID",
  "sidebar.newGroup": "Nová skupina",
  "sidebar.settings": "Nastavení",
  "sidebar.logout": "Odhlásit",
  "sidebar.tooltip.logout": "Odhlásit a smazat vše lokálně",
  "sidebar.savedFreq.tooltip": "Naladit {0}",
  "chat.empty": "Vyberte nebo přidejte kontakt",
  "welcome.title": "Vítejte v Syphraxu",
  "welcome.concept": "Syphrax je soukromé zasílání zpráv založené na frekvencích. Frekvence je tajný klíč, který znáte vy i osoba, s níž mluvíte. Bez tohoto klíče konverzace neexistuje — ani platforma ji nedokáže obnovit.",
  "welcome.step1": "Nalaďte se na frekvenci sdílenou s osobou nebo skupinou, se kterou chcete mluvit.",
  "welcome.step2": "Přidejte její syphrax_id jako kontakt, nebo ji požádejte, aby přidala vaše.",
  "welcome.step3": "Začněte psát. Zprávy si přečtou pouze ti, kdo sdílejí stejnou frekvenci.",
  "welcome.multidevice": "Každé zařízení si uchovává své frekvence a zprávy nezávisle. Pokud se přihlásíte z jiného zařízení, budete muset frekvence znovu naladit.",
  "welcome.btnFreq": "Naladit frekvenci",
  "welcome.btnContacts": "Přidat kontakt",
  "push.btnOn": "Notifikace ZAP",
  "push.btnOff": "Notifikace VYP",
  "push.btnEnable": "Notifikace vypnuté. Kliknutím zapnete.",
  "push.btnDisable": "Notifikace zapnuté. Kliknutím vypnete.",
  "push.introTitle": "Než zapnete notifikace",
  "push.introBody": "Z důvodu soukromí fungují notifikace Syphraxu jinak než v jiných messengerech:",
  "push.introBullet1": "Obsah zprávy není zahrnut.",
  "push.introBullet2": "Nezobrazuje se ani jméno ani syphrax_id odesílatele.",
  "push.introBullet3": "Dostanete jen upozornění \"nová zpráva\", abyste otevřeli aplikaci a přečetli ji zašifrovanou ve svém zařízení.",
  "push.introConfirm": "Zapnout notifikace",
  "chat.placeholder": "Napište zprávu…",
  "chat.editPlaceholder": "Upravte zprávu…",
  "chat.replyingTo": "Odpověď uživateli {0}",
  "chat.editing": "Úprava zprávy",
  "chat.confirmContact": "Přidat do kontaktů",
  "chat.unconfirmedBanner": "Tento uživatel vám napsal, ale není ve vašich kontaktech. Dokud ho nepřidáte, vaše foto a info pro něj nebudou viditelné.",
  "chat.online": "online",
  "chat.lastSeen": "naposledy zde {0}",
  "chat.tooltip.attach": "Připojit soubor",
  "chat.tooltip.shareContact": "Sdílet kontakt",
  "chat.tooltip.paste": "Vložit obrázek ze schránky",
  "chat.tooltip.stickers": "Samolepky",
  "chat.tooltip.callAudio": "Hlasový hovor",
  "chat.tooltip.callVideo": "Videohovor",
  "chat.btn.send": "Odeslat",
  "chat.uploading": "…",
  "preview.image": "📷 Obrázek",
  "preview.video": "🎬 Video",
  "preview.audio": "🎙 Zvuk",
  "bubble.reply": "Odpovědět",
  "bubble.edit": "Upravit",
  "bubble.edited": "upraveno",
  "bubble.contact.label": "Kontakt Syphrax",
  "bubble.media.decrypting": "Dešifruji…",
  "bubble.media.failed": "Soubor se nepodařilo dešifrovat.",
  "call.calling": "Volám…",
  "call.incoming.audio": "Příchozí hovor",
  "call.incoming.video": "Příchozí videohovor",
  "call.connecting": "Spojuji…",
  "call.ending": "Ukončuji…",
  "call.accept": "Přijmout",
  "call.reject": "Odmítnout",
  "call.hangup": "Zavěsit",
  "call.mic": "Mikrofon",
  "call.camera": "Kamera",
  "call.audioOut": "Výstup zvuku",
  "call.audioOut.auto": "Auto",
  "call.error.notInFreq": "Pro hovor musíte být naladěni na frekvenci.",
  "error.notFound": "Zdroj nenalezen.",
  "error.notInFreq": "{0} se ještě nenaladil na tuto frekvenci. Požádejte ho jiným kanálem, ať se naladí.",
  "error.push.iosTooOld": "Tvůj iOS je starší než 16.4. Aktualizuj ho, aby ses dostal k oznámením.",
  "error.push.iosNotStandalone": "Pro příjem oznámení na iPhonu nainstaluj Syphrax na plochu: klepni na Sdílet → Přidat na plochu.",
  "error.expired": "Relace vypršela. Přihlaste se znovu.",
  "error.gone": "Soubor vypršel.",
  "error.invalid": "Neplatná data.",
  "error.server": "Chyba serveru. Zkuste to znovu.",
  "error.network": "Žádné připojení k serveru.",
  "error.cantStartCall": "Nelze zahájit hovor: {0}",
  "error.cantAcceptCall": "Nelze přijmout hovor: {0}",
  "error.cantPaste": "Nelze přistoupit ke schránce. Použijte tlačítko přílohy.",
  "error.noImageInClipboard": "Ve schránce není žádný obrázek.",
  "error.clipboardUnsupported": "Váš prohlížeč nedovoluje čtení schránky. Použijte Ctrl+V nebo tlačítko přílohy.",
  "error.selfContact": "Nemůžete přidat sami sebe.",
  "error.blocked": "Tohoto uživatele jste zablokovali. Odblokujte ho v Nastavení.",
  "settings.title": "Nastavení",
  "settings.close": "Zavřít",
  "settings.tab.profile": "👤 Profil",
  "settings.tab.privacy": "🔒 Soukromí",
  "settings.tab.messages": "✉ Zprávy",
  "settings.tab.blocked": "🚫 Zablokovaní",
  "settings.tab.notifications": "🔔 Oznámení",
  "settings.tab.session": "⏱ Relace",
  "settings.tab.account": "🆔 Účet",
  "settings.tab.language": "🌐 Jazyk",
  "settings.tab.about": "ℹ O aplikaci",
  "settings.scope.global": "Globální (obecná frekvence)",
  "settings.scope.freq": "Pouze na {0}",
  "settings.profile.title": "Profil",
  "settings.profile.hintGlobal": "Tyto hodnoty se používají ve výchozím nastavení a dědí se na všech frekvencích.",
  "settings.profile.hintFreq": "Přepisují globální profil, když jste na {0}. Pokud zde něco nedefinujete, dědí se z globálního.",
  "settings.profile.displayName": "Zobrazované jméno",
  "settings.profile.displayNamePh.global": "(bez jména — zobrazí se vaše syphrax id)",
  "settings.profile.displayNamePh.freq": "(dědí z globálního)",
  "settings.profile.photo": "Profilová fotka",
  "settings.profile.changePhoto": "Změnit fotku",
  "settings.profile.removePhoto": "Odstranit fotku",
  "settings.profile.info": "Info / Stav",
  "settings.profile.infoPh": "Ahoj, používám Syphrax",
  "settings.profile.removeOverride": "Odstranit override {0}",
  "settings.profile.warn": "Změny budou automaticky odeslány vašim kontaktům, když s nimi budete interagovat na této frekvenci.",
  "settings.privacy.title": "Soukromí",
  "settings.privacy.hintGlobal": "Nastavte, kdo ve výchozím nastavení vidí jednotlivé informace o vás.",
  "settings.privacy.hintFreq": "Přepisuje tato pravidla pouze když jste na {0}.",
  "settings.privacy.showPhoto": "Kdo vidí mou fotku",
  "settings.privacy.showInfo": "Kdo vidí mé info / stav",
  "settings.privacy.showLastSeen": "Kdo vidí naposledy online",
  "settings.privacy.showOnline": "Kdo vidí, zda jsem online",
  "settings.privacy.whoAdds": "Kdo mě může přidat do skupin",
  "settings.privacy.readReceipts": "Potvrzení o přečtení",
  "settings.privacy.readReceiptsHint": "Pokud to vypnete, neodesílají se modré fajfky, když čtete zprávy. Neuvidíte ani ty od ostatních.",
  "settings.vis.all": "Všichni",
  "settings.vis.contacts": "Mé kontakty",
  "settings.vis.none": "Nikdo",
  "settings.messages.title": "Zprávy",
  "settings.messages.ttl": "Výchozí expirace",
  "settings.messages.ttlHint": "Zprávy, které pošlete, budou ze serveru smazány po této době.",
  "settings.blocked.title": "Zablokovaní",
  "settings.blocked.hint": "Zablokovaní uživatelé vám nemohou posílat zprávy. Ani vy jim nemůžete posílat.",
  "settings.blocked.placeholder": "syphrax id k zablokování",
  "settings.blocked.btn": "Blokovat",
  "settings.blocked.unblock": "Odblokovat",
  "settings.blocked.empty": "Nikoho nemáte zablokovaného.",
  "settings.notif.title": "Oznámení",
  "settings.notif.sound": "Zvuk",
  "settings.notif.preview": "Zobrazit náhled zprávy",
  "settings.notif.vibration": "Vibrace (mobil)",
  "settings.notif.hint": "Push oznámení prohlížeče se vysílají pouze pro zprávy na obecné frekvenci.",
  "settings.session.title": "Relace",
  "settings.session.timeout": "Zavřít frekvenci po nečinnosti",
  "settings.session.timeoutHint": "Pokud strávíte tento čas bez doteku aplikace, aktivní frekvence se automaticky vypne.",
  "settings.session.remember": "Pamatovat použité frekvence",
  "settings.session.rememberHint": "Pokud zapnuto, frekvence, na které se ladíte, se zobrazují jako zkratky v postranním panelu.",
  "settings.account.title": "Účet",
  "settings.account.idLabel": "Vaše syphrax id",
  "settings.account.email": "Volitelný email (pouze pro obnovu, nikdy se nezveřejňuje)",
  "settings.account.emailPh": "email@priklad.com",
  "settings.account.changePassword": "Změnit heslo",
  "settings.account.currentPw": "Aktuální heslo",
  "settings.account.newPw": "Nové heslo (min. 8)",
  "settings.account.confirmPw": "Zopakujte nové",
  "settings.account.saving": "Ukládání…",
  "settings.account.success": "Heslo aktualizováno.",
  "settings.account.errPwBad": "Aktuální heslo není správné.",
  "settings.account.errPwShort": "Nové heslo musí mít alespoň 8 znaků.",
  "settings.account.errPwMismatch": "Hesla se neshodují.",
  "settings.language.title": "Jazyk",
  "settings.language.hint": "Vyberte jazyk rozhraní. Vaše preference se ukládá v tomto zařízení.",
  "settings.about.title": "O aplikaci Syphrax",
  "settings.about.version": "Verze MVP ve vývoji.",
  "settings.about.tech": "E2E šifrování s NaCl box (X25519). Frekvence: derivace Argon2id + deterministický HMAC.",
  "modal.freq.title": "Naladit frekvenci",
  "modal.freq.hint": "Zadejte tajný řetězec frekvence.",
  "modal.freq.placeholder": "ALFA2025",
  "modal.freq.activate": "Aktivovat",
  "modal.freq.deriving": "Odvozuji klíč…",
  "modal.freq.warn": "Pokud zapomenete tento řetězec, ztratíte přístup k rozhovorům této frekvence.",
  "modal.freq.errShort": "Frekvence musí mít alespoň 8 znaků.",
  "modal.freq.errCommon": "Tento řetězec je příliš běžný.",
  "modal.freq.errRepeat": "Nepoužívejte jeden opakovaný znak.",
  "modal.freq.errSeqNum": "Vyhněte se zřejmým číselným sekvencím.",
  "modal.freq.errSeqAlpha": "Vyhněte se abecedním sekvencím.",
  "modal.share.title": "Sdílet kontakt",
  "modal.share.hint": "Vyberte kontakt ze seznamu nebo zadejte syphrax id ručně.",
  "modal.share.filter": "Filtrovat kontakty…",
  "modal.share.empty": "Žádné kontakty na této frekvenci",
  "modal.share.manual": "Nebo ruční syphrax id",
  "modal.share.btn": "Sdílet",
  "modal.group.title": "Nová skupina",
  "modal.group.hint": "Vyberte název a zvolte členy z vašich kontaktů na této frekvenci.",
  "modal.group.namePh": "Název skupiny",
  "modal.group.selected": "{0} vybráno",
  "modal.group.create": "Vytvořit skupinu",
  "modal.remember.title": "Pamatovat toto zařízení",
  "modal.remember.hint": "Vaše relace, kontakty, skupiny a zprávy budou uloženy na tomto zařízení, zašifrovány PIN kódem, který znáte pouze vy.",
  "modal.remember.pin": "PIN",
  "modal.remember.confirm": "Zopakujte PIN",
  "modal.remember.warn": "Pokud zapomenete PIN, uložená data nelze obnovit.",
  "modal.remember.errShort": "PIN musí mít alespoň 4 znaky.",
  "modal.remember.errMismatch": "PIN kódy se neshodují.",
  "stickers.faces": "Obličeje",
  "stickers.gestures": "Gesta",
  "stickers.hearts": "Srdce",
  "stickers.symbols": "Symboly",
  "stickers.animals": "Zvířata",
  "stickers.food": "Jídlo",
  "ttl.1h": "1 hodina",
  "ttl.1d": "1 den",
  "ttl.1w": "1 týden",
  "ttl.1m": "1 měsíc",
  "ttl.6m": "6 měsíců",
  "ttl.12m": "12 měsíců",
  "timeout.5min": "5 min",
  "timeout.15min": "15 min",
  "timeout.30min": "30 min",
  "timeout.never": "Nikdy",
  "toast.newMessage": "Nová zpráva",
  "toast.group": "{0} (skupina)",
};

const hu: Catalog = {
  "common.cancel": "Mégse",
  "common.save": "Mentés",
  "common.confirm": "Megerősítés",
  "common.close": "Bezárás",
  "common.add": "Hozzáad",
  "common.back": "Vissza",
  "common.tagline": "A frekvencia nélkül a beszélgetés nem létezik.",
  "auth.tagline": "Privát üzenetek frekvencián",
  "auth.loading": "Betöltés…",
  "auth.savedSession": "Ezen az eszközön van elmentett munkamenet.",
  "auth.tab.login": "Belépés",
  "auth.tab.register": "Fiók létrehozása",
  "auth.field.devicePin": "Eszköz PIN",
  "auth.field.username": "Felhasználó",
  "auth.field.password": "Jelszó",
  "auth.btn.unlock": "Feloldás",
  "auth.btn.unlocking": "Feloldás…",
  "auth.btn.processing": "Feldolgozás…",
  "auth.btn.useOther": "Másik fiók",
  "auth.btn.forget": "Eszköz elfelejtése",
  "auth.btn.backToUnlock": "Vissza a feloldáshoz",
  "auth.confirmForget": "Elfelejti ezt az eszközt? A mentett munkamenet és a gyorsítótárazott üzenetek törlődnek.",
  "auth.error.userExists": "Ez a felhasználó már létezik. Válassz másikat.",
  "auth.error.badCreds": "Hibás felhasználónév vagy jelszó.",
  "auth.error.userNotFound": "Felhasználó nem található.",
  "auth.error.cantConnect": "Nem sikerült csatlakozni a szerverhez.",
  "auth.error.badPin": "Hibás PIN.",
  "auth.footnote": "E2E titkosítás NaCl box-szal. Frekvenciák: Argon2id + determinisztikus HMAC.",
  "sidebar.general": "Általános frekvencia",
  "sidebar.freq": "{0} frekvencia",
  "sidebar.tune": "Frekvencia hangolás",
  "sidebar.exitFreq": "{0} elhagyása",
  "sidebar.notifications": "Értesítések",
  "sidebar.remember": "Eszköz megjegyzése",
  "sidebar.forget": "Eszköz elfelejtése",
  "sidebar.addContact": "Kapcsolat hozzáadása Syphrax ID alapján",
  "sidebar.newGroup": "Új csoport",
  "sidebar.settings": "Beállítások",
  "sidebar.logout": "Kijelentkezés",
  "sidebar.tooltip.logout": "Kijelentkezés és helyi adatok törlése",
  "sidebar.savedFreq.tooltip": "{0} hangolás",
  "chat.empty": "Válassz vagy adj hozzá egy kapcsolatot",
  "welcome.title": "Üdvözöl a Syphrax",
  "welcome.concept": "A Syphrax egy frekvenciaalapú privát üzenetküldő. Egy frekvencia egy titkos kulcs, amelyet te és a beszélgetőpartnered ismertek. E kulcs nélkül a beszélgetés nem létezik — még a platform sem tudja helyreállítani.",
  "welcome.step1": "Hangolódj rá egy olyan frekvenciára, amelyet azzal a személlyel vagy csoporttal osztasz meg, akivel beszélni szeretnél.",
  "welcome.step2": "Add hozzá a syphrax_id-jét kapcsolatként, vagy kérd meg, hogy adja hozzá a tiédet.",
  "welcome.step3": "Kezdj el írni. Csak azok olvashatják az üzeneteket, akik ugyanazt a frekvenciát osztják meg.",
  "welcome.multidevice": "Minden eszköz külön tartja a frekvenciáit és üzeneteit. Ha másik eszközről jelentkezel be, újra rá kell hangolódnod a frekvenciákra.",
  "welcome.btnFreq": "Frekvenciára hangolás",
  "welcome.btnContacts": "Kapcsolat hozzáadása",
  "push.btnOn": "Értesítések BE",
  "push.btnOff": "Értesítések KI",
  "push.btnEnable": "Értesítések kikapcsolva. Kattints a bekapcsoláshoz.",
  "push.btnDisable": "Értesítések bekapcsolva. Kattints a kikapcsoláshoz.",
  "push.introTitle": "Mielőtt bekapcsolnád az értesítéseket",
  "push.introBody": "Az adatvédelem érdekében a Syphrax értesítései másképp működnek, mint más üzenetküldő alkalmazásoknál:",
  "push.introBullet1": "Az üzenet tartalma nem szerepel benne.",
  "push.introBullet2": "Sem a feladó neve, sem a syphrax_id-je nem jelenik meg.",
  "push.introBullet3": "Csak egy \"új üzenet\" értesítést kapsz, hogy megnyisd az appot és titkosítva olvasd el az eszközödön.",
  "push.introConfirm": "Értesítések bekapcsolása",
  "chat.placeholder": "Írj egy üzenetet…",
  "chat.editPlaceholder": "Üzenet szerkesztése…",
  "chat.replyingTo": "Válasz {0} részére",
  "chat.editing": "Üzenet szerkesztése",
  "chat.confirmContact": "Hozzáadás a kapcsolatokhoz",
  "chat.unconfirmedBanner": "Ez a felhasználó írt neked, de nincs a kapcsolataid között. Amíg nem adod hozzá, a fényképed és infód nem látható számára.",
  "chat.online": "online",
  "chat.lastSeen": "utoljára itt {0}",
  "chat.tooltip.attach": "Fájl csatolása",
  "chat.tooltip.shareContact": "Kapcsolat megosztása",
  "chat.tooltip.paste": "Kép beillesztése a vágólapról",
  "chat.tooltip.stickers": "Matricák",
  "chat.tooltip.callAudio": "Hanghívás",
  "chat.tooltip.callVideo": "Videohívás",
  "chat.btn.send": "Küldés",
  "chat.uploading": "…",
  "preview.image": "📷 Kép",
  "preview.video": "🎬 Videó",
  "preview.audio": "🎙 Hang",
  "bubble.reply": "Válasz",
  "bubble.edit": "Szerkesztés",
  "bubble.edited": "szerkesztve",
  "bubble.contact.label": "Syphrax kapcsolat",
  "bubble.media.decrypting": "Visszafejtés…",
  "bubble.media.failed": "A fájl nem fejthető vissza.",
  "call.calling": "Hívás…",
  "call.incoming.audio": "Bejövő hívás",
  "call.incoming.video": "Bejövő videohívás",
  "call.connecting": "Kapcsolódás…",
  "call.ending": "Befejezés…",
  "call.accept": "Fogadás",
  "call.reject": "Elutasítás",
  "call.hangup": "Megszakítás",
  "call.mic": "Mikrofon",
  "call.camera": "Kamera",
  "call.audioOut": "Hangkimenet",
  "call.audioOut.auto": "Auto",
  "call.error.notInFreq": "A híváshoz frekvenciára kell hangolódnod.",
  "error.notFound": "Erőforrás nem található.",
  "error.notInFreq": "{0} még nem hangolódott rá erre a frekvenciára. Kérd meg másik csatornán, hogy hangolódjon rá.",
  "error.push.iosTooOld": "Az iOS-ed régebbi mint 16.4. Frissítsd, hogy értesítéseket kapj.",
  "error.push.iosNotStandalone": "Hogy iPhone-on értesítéseket kapj, telepítsd a Syphraxot a kezdőképernyőre: érintsd meg a Megosztás → Hozzáadás a kezdőképernyőhöz.",
  "error.expired": "A munkamenet lejárt. Lépj be újra.",
  "error.gone": "A fájl lejárt.",
  "error.invalid": "Érvénytelen adatok.",
  "error.server": "Szerverhiba. Próbáld újra.",
  "error.network": "Nincs kapcsolat a szerverrel.",
  "error.cantStartCall": "Nem lehet hívást indítani: {0}",
  "error.cantAcceptCall": "Nem lehet hívást fogadni: {0}",
  "error.cantPaste": "Nem érhető el a vágólap. Használd a csatolás gombot.",
  "error.noImageInClipboard": "Nincs kép a vágólapon.",
  "error.clipboardUnsupported": "A böngésződ nem engedi a vágólap olvasását. Használd a Ctrl+V-t vagy a csatolás gombot.",
  "error.selfContact": "Nem adhatod hozzá magadat.",
  "error.blocked": "Letiltottad ezt a felhasználót. Oldd fel a Beállításokban.",
  "settings.title": "Beállítások",
  "settings.close": "Bezárás",
  "settings.tab.profile": "👤 Profil",
  "settings.tab.privacy": "🔒 Adatvédelem",
  "settings.tab.messages": "✉ Üzenetek",
  "settings.tab.blocked": "🚫 Letiltottak",
  "settings.tab.notifications": "🔔 Értesítések",
  "settings.tab.session": "⏱ Munkamenet",
  "settings.tab.account": "🆔 Fiók",
  "settings.tab.language": "🌐 Nyelv",
  "settings.tab.about": "ℹ Névjegy",
  "settings.scope.global": "Globális (általános frekvencia)",
  "settings.scope.freq": "Csak {0}-n",
  "settings.profile.title": "Profil",
  "settings.profile.hintGlobal": "Ezek az alapértelmezett értékek, minden frekvencián öröklődnek.",
  "settings.profile.hintFreq": "Felülírják a globális profilt amikor {0}-n vagy. Ha itt nem adsz meg valamit, a globálistól öröklődik.",
  "settings.profile.displayName": "Megjelenített név",
  "settings.profile.displayNamePh.global": "(név nélkül — a syphrax id-d jelenik meg)",
  "settings.profile.displayNamePh.freq": "(globálistól öröklődik)",
  "settings.profile.photo": "Profilkép",
  "settings.profile.changePhoto": "Fénykép módosítása",
  "settings.profile.removePhoto": "Fénykép eltávolítása",
  "settings.profile.info": "Info / Állapot",
  "settings.profile.infoPh": "Szia, Syphraxot használok",
  "settings.profile.removeOverride": "{0} felülírás törlése",
  "settings.profile.warn": "A változtatások automatikusan elküldésre kerülnek a kapcsolataidnak, amikor ezen a frekvencián kommunikálsz velük.",
  "settings.privacy.title": "Adatvédelem",
  "settings.privacy.hintGlobal": "Állítsd be, ki láthatja alapértelmezetten az egyes információidat.",
  "settings.privacy.hintFreq": "Csak akkor írja felül ezeket a szabályokat, amikor {0}-n vagy.",
  "settings.privacy.showPhoto": "Ki látja a fényképem",
  "settings.privacy.showInfo": "Ki látja az infóm / állapotom",
  "settings.privacy.showLastSeen": "Ki látja az utolsó belépésem",
  "settings.privacy.showOnline": "Ki látja ha online vagyok",
  "settings.privacy.whoAdds": "Ki adhat hozzá csoportokhoz",
  "settings.privacy.readReceipts": "Olvasási visszaigazolások",
  "settings.privacy.readReceiptsHint": "Ha kikapcsolod, nem küldődnek kék pipák amikor üzeneteket olvasol. A másokét sem látod.",
  "settings.vis.all": "Mindenki",
  "settings.vis.contacts": "Kapcsolataim",
  "settings.vis.none": "Senki",
  "settings.messages.title": "Üzenetek",
  "settings.messages.ttl": "Alapértelmezett lejárat",
  "settings.messages.ttlHint": "Az üzenetek amiket küldesz törölve lesznek a szerverről ezután az idő után.",
  "settings.blocked.title": "Letiltottak",
  "settings.blocked.hint": "A letiltott felhasználók nem küldhetnek üzenetet. Te sem küldhetsz nekik.",
  "settings.blocked.placeholder": "blokkolandó syphrax id",
  "settings.blocked.btn": "Letiltás",
  "settings.blocked.unblock": "Feloldás",
  "settings.blocked.empty": "Senki nincs letiltva.",
  "settings.notif.title": "Értesítések",
  "settings.notif.sound": "Hang",
  "settings.notif.preview": "Üzenet előnézet mutatása",
  "settings.notif.vibration": "Rezgés (mobil)",
  "settings.notif.hint": "A böngésző push értesítései csak az általános frekvencián érkező üzenetekről szólnak.",
  "settings.session.title": "Munkamenet",
  "settings.session.timeout": "Frekvencia bezárása inaktivitás után",
  "settings.session.timeoutHint": "Ha ennyi időt töltesz az app érintése nélkül, az aktív frekvencia automatikusan kikapcsolódik.",
  "settings.session.remember": "Használt frekvenciák megjegyzése",
  "settings.session.rememberHint": "Ha be van kapcsolva, a frekvenciák amelyekre hangolódsz parancsikonként jelennek meg az oldalsávon.",
  "settings.account.title": "Fiók",
  "settings.account.idLabel": "A syphrax id-d",
  "settings.account.email": "Opcionális email (csak helyreállításhoz, soha nem publikus)",
  "settings.account.emailPh": "email@pelda.com",
  "settings.account.changePassword": "Jelszó módosítása",
  "settings.account.currentPw": "Jelenlegi jelszó",
  "settings.account.newPw": "Új jelszó (min. 8)",
  "settings.account.confirmPw": "Ismételd meg az újat",
  "settings.account.saving": "Mentés…",
  "settings.account.success": "Jelszó frissítve.",
  "settings.account.errPwBad": "A jelenlegi jelszó nem helyes.",
  "settings.account.errPwShort": "Az új jelszónak legalább 8 karakteresnek kell lennie.",
  "settings.account.errPwMismatch": "A jelszavak nem egyeznek.",
  "settings.language.title": "Nyelv",
  "settings.language.hint": "Válaszd ki a felület nyelvét. A választásod ezen az eszközön mentve.",
  "settings.about.title": "A Syphraxról",
  "settings.about.version": "Fejlesztés alatt álló MVP verzió.",
  "settings.about.tech": "E2E titkosítás NaCl box-szal (X25519). Frekvenciák: Argon2id származtatás + determinisztikus HMAC.",
  "modal.freq.title": "Frekvencia hangolás",
  "modal.freq.hint": "Add meg a frekvencia titkos kódját.",
  "modal.freq.placeholder": "ALFA2025",
  "modal.freq.activate": "Aktiválás",
  "modal.freq.deriving": "Kulcs származtatása…",
  "modal.freq.warn": "Ha elfelejted ezt a kódot, elveszíted a hozzáférést a frekvencia beszélgetéseihez.",
  "modal.freq.errShort": "A frekvenciának legalább 8 karakteresnek kell lennie.",
  "modal.freq.errCommon": "Ez a kód túl gyakori.",
  "modal.freq.errRepeat": "Ne használj egyetlen ismétlődő karaktert.",
  "modal.freq.errSeqNum": "Kerüld a nyilvánvaló számsorozatokat.",
  "modal.freq.errSeqAlpha": "Kerüld az ábécé sorozatokat.",
  "modal.share.title": "Kapcsolat megosztása",
  "modal.share.hint": "Válassz egy kapcsolatot a listából vagy adj meg egy syphrax id-t kézzel.",
  "modal.share.filter": "Kapcsolatok szűrése…",
  "modal.share.empty": "Nincsenek kapcsolatok ezen a frekvencián",
  "modal.share.manual": "Vagy egy kézi syphrax id",
  "modal.share.btn": "Megosztás",
  "modal.group.title": "Új csoport",
  "modal.group.hint": "Válassz nevet és tagokat a kapcsolataid közül ezen a frekvencián.",
  "modal.group.namePh": "Csoport neve",
  "modal.group.selected": "{0} kiválasztva",
  "modal.group.create": "Csoport létrehozása",
  "modal.remember.title": "Eszköz megjegyzése",
  "modal.remember.hint": "A munkameneted, kapcsolataid, csoportjaid és üzeneteid mentve lesznek ezen az eszközön, csak általad ismert PIN-nel titkosítva.",
  "modal.remember.pin": "PIN",
  "modal.remember.confirm": "Ismételd meg a PIN-t",
  "modal.remember.warn": "Ha elfelejted a PIN-t, a mentett adatok nem helyreállíthatók.",
  "modal.remember.errShort": "A PIN-nek legalább 4 karakteresnek kell lennie.",
  "modal.remember.errMismatch": "A PIN-ek nem egyeznek.",
  "stickers.faces": "Arcok",
  "stickers.gestures": "Gesztusok",
  "stickers.hearts": "Szívek",
  "stickers.symbols": "Szimbólumok",
  "stickers.animals": "Állatok",
  "stickers.food": "Étel",
  "ttl.1h": "1 óra",
  "ttl.1d": "1 nap",
  "ttl.1w": "1 hét",
  "ttl.1m": "1 hónap",
  "ttl.6m": "6 hónap",
  "ttl.12m": "12 hónap",
  "timeout.5min": "5 perc",
  "timeout.15min": "15 perc",
  "timeout.30min": "30 perc",
  "timeout.never": "Soha",
  "toast.newMessage": "Új üzenet",
  "toast.group": "{0} (csoport)",
};

const ro: Catalog = {
  "common.cancel": "Anulează",
  "common.save": "Salvează",
  "common.confirm": "Confirmă",
  "common.close": "Închide",
  "common.add": "Adaugă",
  "common.back": "Înapoi",
  "common.tagline": "Fără frecvență, conversația nu există.",
  "auth.tagline": "Mesagerie privată pe frecvență",
  "auth.loading": "Se încarcă…",
  "auth.savedSession": "Există o sesiune salvată pe acest dispozitiv.",
  "auth.tab.login": "Intră",
  "auth.tab.register": "Creează cont",
  "auth.field.devicePin": "PIN dispozitiv",
  "auth.field.username": "Utilizator",
  "auth.field.password": "Parolă",
  "auth.btn.unlock": "Deblochează",
  "auth.btn.unlocking": "Se deblochează…",
  "auth.btn.processing": "Se procesează…",
  "auth.btn.useOther": "Folosește alt cont",
  "auth.btn.forget": "Uită acest dispozitiv",
  "auth.btn.backToUnlock": "Înapoi la deblocare",
  "auth.confirmForget": "Uitați acest dispozitiv? Sesiunea salvată și mesajele din cache vor fi șterse.",
  "auth.error.userExists": "Acest utilizator există deja. Alege altul.",
  "auth.error.badCreds": "Utilizator sau parolă incorecte.",
  "auth.error.userNotFound": "Utilizator negăsit.",
  "auth.error.cantConnect": "Nu s-a putut conecta la server.",
  "auth.error.badPin": "PIN incorect.",
  "auth.footnote": "Criptare E2E cu NaCl box. Frecvențe: Argon2id + HMAC determinist.",
  "sidebar.general": "Frecvență generală",
  "sidebar.freq": "Frecvența {0}",
  "sidebar.tune": "Reglează frecvența",
  "sidebar.exitFreq": "Părăsește {0}",
  "sidebar.notifications": "Notificări",
  "sidebar.remember": "Memorează dispozitivul",
  "sidebar.forget": "Uită dispozitivul",
  "sidebar.addContact": "Adaugă contact după Syphrax ID",
  "sidebar.newGroup": "Grup nou",
  "sidebar.settings": "Setări",
  "sidebar.logout": "Deconectare",
  "sidebar.tooltip.logout": "Deconectează și șterge tot local",
  "sidebar.savedFreq.tooltip": "Reglează {0}",
  "chat.empty": "Selectează sau adaugă un contact",
  "welcome.title": "Bun venit la Syphrax",
  "welcome.concept": "Syphrax este mesagerie privată bazată pe frecvențe. O frecvență este o cheie secretă pe care o cunoști și tu și persoana cu care vorbești. Fără acea cheie, conversația nu există — nici măcar platforma nu o poate reconstrui.",
  "welcome.step1": "Acordează-te pe o frecvență împărtășită cu persoana sau grupul cu care vrei să vorbești.",
  "welcome.step2": "Adaugă syphrax_id-ul lor ca persoană de contact, sau roagă-i să-l adauge pe al tău.",
  "welcome.step3": "Începe să scrii. Doar cei care împărtășesc aceeași frecvență pot citi mesajele.",
  "welcome.multidevice": "Fiecare dispozitiv își păstrează propriile frecvențe și mesaje independent. Dacă te conectezi de pe alt dispozitiv, va trebui să te acordezi din nou pe frecvențe.",
  "welcome.btnFreq": "Acordează frecvență",
  "welcome.btnContacts": "Adaugă contact",
  "push.btnOn": "Notificări ON",
  "push.btnOff": "Notificări OFF",
  "push.btnEnable": "Notificări dezactivate. Clic pentru a activa.",
  "push.btnDisable": "Notificări activate. Clic pentru a dezactiva.",
  "push.introTitle": "Înainte de a activa notificările",
  "push.introBody": "Pentru confidențialitate, notificările Syphrax funcționează diferit față de alte aplicații de mesagerie:",
  "push.introBullet1": "Conținutul mesajului nu este inclus.",
  "push.introBullet2": "Nici numele, nici syphrax_id-ul expeditorului nu sunt afișate.",
  "push.introBullet3": "Vei primi doar o alertă \"mesaj nou\" pentru a deschide aplicația și a-l citi criptat pe dispozitivul tău.",
  "push.introConfirm": "Activează notificările",
  "chat.placeholder": "Scrie un mesaj…",
  "chat.editPlaceholder": "Editează mesajul…",
  "chat.replyingTo": "Răspunzi lui {0}",
  "chat.editing": "Editare mesaj",
  "chat.confirmContact": "Adaugă în contacte",
  "chat.unconfirmedBanner": "Acest utilizator ți-a scris dar nu este în contacte. Până nu îl adaugi, fotografia și informațiile tale nu îi vor fi vizibile.",
  "chat.online": "online",
  "chat.lastSeen": "ultima oară aici {0}",
  "chat.tooltip.attach": "Atașează fișier",
  "chat.tooltip.shareContact": "Partajează contact",
  "chat.tooltip.paste": "Lipește imagine din clipboard",
  "chat.tooltip.stickers": "Stickere",
  "chat.tooltip.callAudio": "Apel vocal",
  "chat.tooltip.callVideo": "Apel video",
  "chat.btn.send": "Trimite",
  "chat.uploading": "…",
  "preview.image": "📷 Imagine",
  "preview.video": "🎬 Video",
  "preview.audio": "🎙 Audio",
  "bubble.reply": "Răspunde",
  "bubble.edit": "Editează",
  "bubble.edited": "editat",
  "bubble.contact.label": "Contact Syphrax",
  "bubble.media.decrypting": "Decriptare…",
  "bubble.media.failed": "Fișierul nu a putut fi decriptat.",
  "call.calling": "Apelez…",
  "call.incoming.audio": "Apel intrant",
  "call.incoming.video": "Apel video intrant",
  "call.connecting": "Se conectează…",
  "call.ending": "Se încheie…",
  "call.accept": "Acceptă",
  "call.reject": "Refuză",
  "call.hangup": "Închide",
  "call.mic": "Microfon",
  "call.camera": "Cameră",
  "call.audioOut": "Ieșire audio",
  "call.audioOut.auto": "Auto",
  "call.error.notInFreq": "Pentru a apela trebuie să fii reglat pe o frecvență.",
  "error.notFound": "Resursă negăsită.",
  "error.notInFreq": "{0} nu s-a reglat încă pe această frecvență. Cere-i pe alt canal să se regleze.",
  "error.push.iosTooOld": "iOS-ul tău este mai vechi decât 16.4. Actualizează-l pentru a primi notificări.",
  "error.push.iosNotStandalone": "Pentru a primi notificări pe iPhone, instalează Syphrax pe ecranul principal: apasă Distribuie → Adaugă pe ecranul principal.",
  "error.expired": "Sesiune expirată. Reconectează-te.",
  "error.gone": "Fișierul a expirat.",
  "error.invalid": "Date invalide.",
  "error.server": "Eroare server. Încearcă din nou.",
  "error.network": "Fără conexiune la server.",
  "error.cantStartCall": "Apelul nu a putut fi inițiat: {0}",
  "error.cantAcceptCall": "Apelul nu a putut fi acceptat: {0}",
  "error.cantPaste": "Nu se poate accesa clipboardul. Folosește butonul de atașare.",
  "error.noImageInClipboard": "Nicio imagine în clipboard.",
  "error.clipboardUnsupported": "Browserul nu permite citirea clipboardului. Folosește Ctrl+V sau butonul de atașare.",
  "error.selfContact": "Nu te poți adăuga pe tine.",
  "error.blocked": "Ai blocat acest utilizator. Deblochează-l în Setări.",
  "settings.title": "Setări",
  "settings.close": "Închide",
  "settings.tab.profile": "👤 Profil",
  "settings.tab.privacy": "🔒 Confidențialitate",
  "settings.tab.messages": "✉ Mesaje",
  "settings.tab.blocked": "🚫 Blocați",
  "settings.tab.notifications": "🔔 Notificări",
  "settings.tab.session": "⏱ Sesiune",
  "settings.tab.account": "🆔 Cont",
  "settings.tab.language": "🌐 Limbă",
  "settings.tab.about": "ℹ Despre",
  "settings.scope.global": "Global (frecvență generală)",
  "settings.scope.freq": "Doar pe {0}",
  "settings.profile.title": "Profil",
  "settings.profile.hintGlobal": "Aceste valori sunt folosite implicit și moștenite pe toate frecvențele.",
  "settings.profile.hintFreq": "Suprascriu profilul global când ești pe {0}. Dacă nu definești ceva aici, se moștenește din global.",
  "settings.profile.displayName": "Nume afișat",
  "settings.profile.displayNamePh.global": "(fără nume — se va afișa syphrax id-ul tău)",
  "settings.profile.displayNamePh.freq": "(moștenește din global)",
  "settings.profile.photo": "Fotografie de profil",
  "settings.profile.changePhoto": "Schimbă fotografia",
  "settings.profile.removePhoto": "Elimină fotografia",
  "settings.profile.info": "Info / Stare",
  "settings.profile.infoPh": "Salut, folosesc Syphrax",
  "settings.profile.removeOverride": "Elimină override-ul {0}",
  "settings.profile.warn": "Modificările vor fi trimise contactelor tale automat când interacționezi cu ele pe această frecvență.",
  "settings.privacy.title": "Confidențialitate",
  "settings.privacy.hintGlobal": "Configurează cine poate vedea fiecare informație despre tine implicit.",
  "settings.privacy.hintFreq": "Suprascrie aceste reguli doar când ești pe {0}.",
  "settings.privacy.showPhoto": "Cine îmi vede fotografia",
  "settings.privacy.showInfo": "Cine îmi vede info / starea",
  "settings.privacy.showLastSeen": "Cine îmi vede ultima conexiune",
  "settings.privacy.showOnline": "Cine vede dacă sunt online",
  "settings.privacy.whoAdds": "Cine mă poate adăuga în grupuri",
  "settings.privacy.readReceipts": "Confirmări de citire",
  "settings.privacy.readReceiptsHint": "Dacă îl dezactivezi, nu se trimit bifele albastre când citești mesajele. Nici nu vei vedea pe ale altora.",
  "settings.vis.all": "Toți",
  "settings.vis.contacts": "Contactele mele",
  "settings.vis.none": "Nimeni",
  "settings.messages.title": "Mesaje",
  "settings.messages.ttl": "Expirare implicită",
  "settings.messages.ttlHint": "Mesajele pe care le trimiți vor fi șterse de pe server după acest timp.",
  "settings.blocked.title": "Blocați",
  "settings.blocked.hint": "Utilizatorii blocați nu îți pot trimite mesaje. Nici tu nu le poți trimite.",
  "settings.blocked.placeholder": "syphrax id de blocat",
  "settings.blocked.btn": "Blochează",
  "settings.blocked.unblock": "Deblochează",
  "settings.blocked.empty": "Nu ai pe nimeni blocat.",
  "settings.notif.title": "Notificări",
  "settings.notif.sound": "Sunet",
  "settings.notif.preview": "Afișează previzualizarea mesajului",
  "settings.notif.vibration": "Vibrație (mobil)",
  "settings.notif.hint": "Notificările push ale browserului sunt emise doar pentru mesajele pe frecvența generală.",
  "settings.session.title": "Sesiune",
  "settings.session.timeout": "Închide frecvența după inactivitate",
  "settings.session.timeoutHint": "Dacă petreci acest timp fără să atingi aplicația, frecvența activă se dezactivează automat.",
  "settings.session.remember": "Memorează frecvențele folosite",
  "settings.session.rememberHint": "Dacă este activat, frecvențele pe care le reglezi apar ca scurtături în bara laterală.",
  "settings.account.title": "Cont",
  "settings.account.idLabel": "Syphrax id-ul tău",
  "settings.account.email": "Email opțional (doar pentru recuperare, niciodată publicat)",
  "settings.account.emailPh": "email@exemplu.com",
  "settings.account.changePassword": "Schimbă parola",
  "settings.account.currentPw": "Parola actuală",
  "settings.account.newPw": "Parolă nouă (min. 8)",
  "settings.account.confirmPw": "Repetă noua",
  "settings.account.saving": "Se salvează…",
  "settings.account.success": "Parolă actualizată.",
  "settings.account.errPwBad": "Parola actuală nu este corectă.",
  "settings.account.errPwShort": "Parola nouă trebuie să aibă cel puțin 8 caractere.",
  "settings.account.errPwMismatch": "Parolele nu coincid.",
  "settings.language.title": "Limbă",
  "settings.language.hint": "Alege limba interfeței. Preferința se salvează pe acest dispozitiv.",
  "settings.about.title": "Despre Syphrax",
  "settings.about.version": "Versiune MVP în dezvoltare.",
  "settings.about.tech": "Criptare E2E cu NaCl box (X25519). Frecvențe: derivare Argon2id + HMAC determinist.",
  "modal.freq.title": "Reglează frecvența",
  "modal.freq.hint": "Introdu șirul secret al frecvenței.",
  "modal.freq.placeholder": "ALFA2025",
  "modal.freq.activate": "Activează",
  "modal.freq.deriving": "Se derivă cheia…",
  "modal.freq.warn": "Dacă uiți acest șir, vei pierde accesul la conversațiile acestei frecvențe.",
  "modal.freq.errShort": "Frecvența trebuie să aibă cel puțin 8 caractere.",
  "modal.freq.errCommon": "Acest șir este prea comun.",
  "modal.freq.errRepeat": "Nu folosi un singur caracter repetat.",
  "modal.freq.errSeqNum": "Evită secvențe numerice evidente.",
  "modal.freq.errSeqAlpha": "Evită secvențe alfabetice.",
  "modal.share.title": "Partajează contact",
  "modal.share.hint": "Alege un contact din listă sau introdu un syphrax id manual.",
  "modal.share.filter": "Filtrează contacte…",
  "modal.share.empty": "Niciun contact pe această frecvență",
  "modal.share.manual": "Sau un syphrax id manual",
  "modal.share.btn": "Partajează",
  "modal.group.title": "Grup nou",
  "modal.group.hint": "Alege un nume și selectează membri din contactele tale pe această frecvență.",
  "modal.group.namePh": "Numele grupului",
  "modal.group.selected": "{0} selectați",
  "modal.group.create": "Creează grup",
  "modal.remember.title": "Memorează acest dispozitiv",
  "modal.remember.hint": "Sesiunea ta, contactele, grupurile și mesajele vor fi salvate pe acest dispozitiv, criptate cu un PIN cunoscut doar de tine.",
  "modal.remember.pin": "PIN",
  "modal.remember.confirm": "Repetă PIN-ul",
  "modal.remember.warn": "Dacă uiți PIN-ul, datele salvate nu pot fi recuperate.",
  "modal.remember.errShort": "PIN-ul trebuie să aibă cel puțin 4 caractere.",
  "modal.remember.errMismatch": "PIN-urile nu coincid.",
  "stickers.faces": "Fețe",
  "stickers.gestures": "Gesturi",
  "stickers.hearts": "Inimi",
  "stickers.symbols": "Simboluri",
  "stickers.animals": "Animale",
  "stickers.food": "Mâncare",
  "ttl.1h": "1 oră",
  "ttl.1d": "1 zi",
  "ttl.1w": "1 săptămână",
  "ttl.1m": "1 lună",
  "ttl.6m": "6 luni",
  "ttl.12m": "12 luni",
  "timeout.5min": "5 min",
  "timeout.15min": "15 min",
  "timeout.30min": "30 min",
  "timeout.never": "Niciodată",
  "toast.newMessage": "Mesaj nou",
  "toast.group": "{0} (grup)",
};

const el: Catalog = {
  "common.cancel": "Άκυρο",
  "common.save": "Αποθήκευση",
  "common.confirm": "Επιβεβαίωση",
  "common.close": "Κλείσιμο",
  "common.add": "Προσθήκη",
  "common.back": "Πίσω",
  "common.tagline": "Χωρίς τη συχνότητα, η συνομιλία δεν υπάρχει.",
  "auth.tagline": "Ιδιωτικά μηνύματα ανά συχνότητα",
  "auth.loading": "Φόρτωση…",
  "auth.savedSession": "Υπάρχει αποθηκευμένη συνεδρία σε αυτή τη συσκευή.",
  "auth.tab.login": "Είσοδος",
  "auth.tab.register": "Δημιουργία λογαριασμού",
  "auth.field.devicePin": "PIN συσκευής",
  "auth.field.username": "Χρήστης",
  "auth.field.password": "Κωδικός",
  "auth.btn.unlock": "Ξεκλείδωμα",
  "auth.btn.unlocking": "Ξεκλείδωμα…",
  "auth.btn.processing": "Επεξεργασία…",
  "auth.btn.useOther": "Άλλος λογαριασμός",
  "auth.btn.forget": "Ξεχάστε αυτή τη συσκευή",
  "auth.btn.backToUnlock": "Επιστροφή στο ξεκλείδωμα",
  "auth.confirmForget": "Ξεχάστε αυτή τη συσκευή; Η αποθηκευμένη συνεδρία και τα μηνύματα cache θα διαγραφούν.",
  "auth.error.userExists": "Αυτός ο χρήστης υπάρχει ήδη. Επιλέξτε άλλον.",
  "auth.error.badCreds": "Λάθος όνομα χρήστη ή κωδικός.",
  "auth.error.userNotFound": "Ο χρήστης δεν βρέθηκε.",
  "auth.error.cantConnect": "Αδύνατη η σύνδεση με τον διακομιστή.",
  "auth.error.badPin": "Λάθος PIN.",
  "auth.footnote": "E2E κρυπτογράφηση με NaCl box. Συχνότητες: Argon2id + ντετερμινιστικό HMAC.",
  "sidebar.general": "Γενική συχνότητα",
  "sidebar.freq": "Συχνότητα {0}",
  "sidebar.tune": "Συντονισμός συχνότητας",
  "sidebar.exitFreq": "Έξοδος από {0}",
  "sidebar.notifications": "Ειδοποιήσεις",
  "sidebar.remember": "Αποθήκευση συσκευής",
  "sidebar.forget": "Ξεχάστε συσκευή",
  "sidebar.addContact": "Προσθήκη επαφής με Syphrax ID",
  "sidebar.newGroup": "Νέα ομάδα",
  "sidebar.settings": "Ρυθμίσεις",
  "sidebar.logout": "Έξοδος",
  "sidebar.tooltip.logout": "Αποσύνδεση και διαγραφή τοπικών δεδομένων",
  "sidebar.savedFreq.tooltip": "Συντονισμός {0}",
  "chat.empty": "Επιλέξτε ή προσθέστε επαφή",
  "welcome.title": "Καλώς ήρθες στο Syphrax",
  "welcome.concept": "Το Syphrax είναι ιδιωτικά μηνύματα βασισμένα σε συχνότητες. Μια συχνότητα είναι ένα μυστικό κλειδί που γνωρίζετε εσύ και το άτομο με το οποίο μιλάς. Χωρίς αυτό το κλειδί η συνομιλία δεν υπάρχει — ούτε η ίδια η πλατφόρμα μπορεί να την ανακατασκευάσει.",
  "welcome.step1": "Συντονίσου σε μια συχνότητα κοινή με το άτομο ή την ομάδα με την οποία θέλεις να μιλήσεις.",
  "welcome.step2": "Πρόσθεσε το syphrax_id τους ως επαφή, ή ζήτησέ τους να προσθέσουν το δικό σου.",
  "welcome.step3": "Άρχισε να γράφεις. Μόνο όσοι μοιράζονται την ίδια συχνότητα μπορούν να διαβάσουν τα μηνύματα.",
  "welcome.multidevice": "Κάθε συσκευή κρατά τις συχνότητες και τα μηνύματά της ανεξάρτητα. Αν συνδεθείς από άλλη συσκευή, θα χρειαστεί να συντονιστείς ξανά στις συχνότητες.",
  "welcome.btnFreq": "Συντονισμός συχνότητας",
  "welcome.btnContacts": "Προσθήκη επαφής",
  "push.btnOn": "Ειδοποιήσεις ON",
  "push.btnOff": "Ειδοποιήσεις OFF",
  "push.btnEnable": "Ειδοποιήσεις απενεργοποιημένες. Κάνε κλικ για ενεργοποίηση.",
  "push.btnDisable": "Ειδοποιήσεις ενεργοποιημένες. Κάνε κλικ για απενεργοποίηση.",
  "push.introTitle": "Πριν ενεργοποιήσεις τις ειδοποιήσεις",
  "push.introBody": "Για λόγους ιδιωτικότητας, οι ειδοποιήσεις του Syphrax λειτουργούν διαφορετικά από τις άλλες εφαρμογές μηνυμάτων:",
  "push.introBullet1": "Το περιεχόμενο του μηνύματος δεν περιλαμβάνεται.",
  "push.introBullet2": "Δεν εμφανίζεται ούτε το όνομα ούτε το syphrax_id του αποστολέα.",
  "push.introBullet3": "Θα λάβεις μόνο μια ειδοποίηση \"νέο μήνυμα\" για να ανοίξεις την εφαρμογή και να το διαβάσεις κρυπτογραφημένο στη συσκευή σου.",
  "push.introConfirm": "Ενεργοποίηση ειδοποιήσεων",
  "chat.placeholder": "Γράψτε μήνυμα…",
  "chat.editPlaceholder": "Επεξεργασία μηνύματος…",
  "chat.replyingTo": "Απάντηση στον/ην {0}",
  "chat.editing": "Επεξεργασία μηνύματος",
  "chat.confirmContact": "Προσθήκη στις επαφές",
  "chat.unconfirmedBanner": "Αυτός ο χρήστης σας έγραψε αλλά δεν είναι στις επαφές σας. Μέχρι να τον προσθέσετε, η φωτογραφία και οι πληροφορίες σας δεν θα είναι ορατές.",
  "chat.online": "συνδεδεμένος",
  "chat.lastSeen": "τελευταία εδώ {0}",
  "chat.tooltip.attach": "Επισύναψη αρχείου",
  "chat.tooltip.shareContact": "Κοινή χρήση επαφής",
  "chat.tooltip.paste": "Επικόλληση εικόνας",
  "chat.tooltip.stickers": "Αυτοκόλλητα",
  "chat.tooltip.callAudio": "Φωνητική κλήση",
  "chat.tooltip.callVideo": "Βιντεοκλήση",
  "chat.btn.send": "Αποστολή",
  "chat.uploading": "…",
  "preview.image": "📷 Εικόνα",
  "preview.video": "🎬 Βίντεο",
  "preview.audio": "🎙 Ήχος",
  "bubble.reply": "Απάντηση",
  "bubble.edit": "Επεξεργασία",
  "bubble.edited": "επεξεργασμένο",
  "bubble.contact.label": "Επαφή Syphrax",
  "bubble.media.decrypting": "Αποκρυπτογράφηση…",
  "bubble.media.failed": "Δεν ήταν δυνατή η αποκρυπτογράφηση.",
  "call.calling": "Καλώντας…",
  "call.incoming.audio": "Εισερχόμενη κλήση",
  "call.incoming.video": "Εισερχόμενη βιντεοκλήση",
  "call.connecting": "Σύνδεση…",
  "call.ending": "Τερματισμός…",
  "call.accept": "Αποδοχή",
  "call.reject": "Απόρριψη",
  "call.hangup": "Τερματισμός",
  "call.mic": "Μικρόφωνο",
  "call.camera": "Κάμερα",
  "call.audioOut": "Έξοδος ήχου",
  "call.audioOut.auto": "Αυτόματο",
  "call.error.notInFreq": "Για κλήση πρέπει να είστε συντονισμένοι σε μια συχνότητα.",
  "error.notFound": "Ο πόρος δεν βρέθηκε.",
  "error.notInFreq": "Ο/Η {0} δεν έχει συντονιστεί ακόμα σε αυτή τη συχνότητα. Ζητήστε του από άλλο κανάλι να συντονιστεί.",
  "error.push.iosTooOld": "Το iOS σου είναι παλαιότερο από 16.4. Ενημέρωσέ το για να λαμβάνεις ειδοποιήσεις.",
  "error.push.iosNotStandalone": "Για να λαμβάνεις ειδοποιήσεις στο iPhone, εγκατέστησε το Syphrax στην οθόνη αφετηρίας: πάτα Κοινοποίηση → Προσθήκη στην οθόνη αφετηρίας.",
  "error.expired": "Η σύνδεση έληξε. Συνδεθείτε ξανά.",
  "error.gone": "Το αρχείο έληξε.",
  "error.invalid": "Μη έγκυρα δεδομένα.",
  "error.server": "Σφάλμα διακομιστή. Δοκιμάστε ξανά.",
  "error.network": "Καμία σύνδεση με τον διακομιστή.",
  "error.cantStartCall": "Αδύνατη η έναρξη κλήσης: {0}",
  "error.cantAcceptCall": "Αδύνατη η αποδοχή κλήσης: {0}",
  "error.cantPaste": "Δεν ήταν δυνατή η πρόσβαση στο πρόχειρο.",
  "error.noImageInClipboard": "Καμία εικόνα στο πρόχειρο.",
  "error.clipboardUnsupported": "Ο περιηγητής δεν επιτρέπει την ανάγνωση του πρόχειρου.",
  "error.selfContact": "Δεν μπορείτε να προσθέσετε τον εαυτό σας.",
  "error.blocked": "Έχετε αποκλείσει αυτό τον χρήστη.",
  "settings.title": "Ρυθμίσεις",
  "settings.close": "Κλείσιμο",
  "settings.tab.profile": "👤 Προφίλ",
  "settings.tab.privacy": "🔒 Απόρρητο",
  "settings.tab.messages": "✉ Μηνύματα",
  "settings.tab.blocked": "🚫 Αποκλεισμένοι",
  "settings.tab.notifications": "🔔 Ειδοποιήσεις",
  "settings.tab.session": "⏱ Συνεδρία",
  "settings.tab.account": "🆔 Λογαριασμός",
  "settings.tab.language": "🌐 Γλώσσα",
  "settings.tab.about": "ℹ Σχετικά",
  "settings.scope.global": "Καθολικά (γενική συχνότητα)",
  "settings.scope.freq": "Μόνο σε {0}",
  "settings.profile.title": "Προφίλ",
  "settings.profile.hintGlobal": "Αυτές οι τιμές χρησιμοποιούνται από προεπιλογή και κληρονομούνται σε όλες τις συχνότητες.",
  "settings.profile.hintFreq": "Παρακάμπτουν το καθολικό προφίλ όταν είστε σε {0}. Αν δεν ορίσετε κάτι εδώ, κληρονομείται από το καθολικό.",
  "settings.profile.displayName": "Εμφανιζόμενο όνομα",
  "settings.profile.displayNamePh.global": "(χωρίς όνομα — θα εμφανιστεί το syphrax id σας)",
  "settings.profile.displayNamePh.freq": "(κληρονομεί από καθολικό)",
  "settings.profile.photo": "Φωτογραφία προφίλ",
  "settings.profile.changePhoto": "Αλλαγή φωτογραφίας",
  "settings.profile.removePhoto": "Αφαίρεση φωτογραφίας",
  "settings.profile.info": "Πληροφορίες / Κατάσταση",
  "settings.profile.infoPh": "Γεια, χρησιμοποιώ Syphrax",
  "settings.profile.removeOverride": "Αφαίρεση override του {0}",
  "settings.profile.warn": "Οι αλλαγές θα σταλούν αυτόματα στις επαφές σας όταν αλληλεπιδράσετε με αυτές σε αυτή τη συχνότητα.",
  "settings.privacy.title": "Απόρρητο",
  "settings.privacy.hintGlobal": "Ρυθμίστε ποιος μπορεί να δει κάθε πληροφορία σας από προεπιλογή.",
  "settings.privacy.hintFreq": "Παρακάμπτει αυτούς τους κανόνες μόνο όταν είστε σε {0}.",
  "settings.privacy.showPhoto": "Ποιος βλέπει τη φωτογραφία μου",
  "settings.privacy.showInfo": "Ποιος βλέπει το info / κατάσταση",
  "settings.privacy.showLastSeen": "Ποιος βλέπει την τελευταία σύνδεση",
  "settings.privacy.showOnline": "Ποιος βλέπει αν είμαι online",
  "settings.privacy.whoAdds": "Ποιος μπορεί να με προσθέσει σε ομάδες",
  "settings.privacy.readReceipts": "Ειδοποιήσεις ανάγνωσης",
  "settings.privacy.readReceiptsHint": "Αν το απενεργοποιήσετε, δεν αποστέλλονται μπλε τικ όταν διαβάζετε μηνύματα. Δεν θα βλέπετε ούτε των άλλων.",
  "settings.vis.all": "Όλοι",
  "settings.vis.contacts": "Οι επαφές μου",
  "settings.vis.none": "Κανείς",
  "settings.messages.title": "Μηνύματα",
  "settings.messages.ttl": "Προεπιλεγμένη λήξη",
  "settings.messages.ttlHint": "Τα μηνύματα που στέλνετε θα διαγραφούν από τον διακομιστή μετά από αυτό τον χρόνο.",
  "settings.blocked.title": "Αποκλεισμένοι",
  "settings.blocked.hint": "Οι αποκλεισμένοι χρήστες δεν μπορούν να σας στείλουν μηνύματα.",
  "settings.blocked.placeholder": "syphrax id για αποκλεισμό",
  "settings.blocked.btn": "Αποκλεισμός",
  "settings.blocked.unblock": "Άρση αποκλεισμού",
  "settings.blocked.empty": "Δεν έχετε κανέναν αποκλεισμένο.",
  "settings.notif.title": "Ειδοποιήσεις",
  "settings.notif.sound": "Ήχος",
  "settings.notif.preview": "Εμφάνιση προεπισκόπησης μηνύματος",
  "settings.notif.vibration": "Δόνηση (κινητό)",
  "settings.notif.hint": "Οι ειδοποιήσεις push του περιηγητή εκπέμπονται μόνο για μηνύματα στη γενική συχνότητα.",
  "settings.session.title": "Συνεδρία",
  "settings.session.timeout": "Κλείσιμο συχνότητας μετά από αδράνεια",
  "settings.session.timeoutHint": "Αν περάσετε αυτό το χρόνο χωρίς να αγγίξετε την εφαρμογή, η ενεργή συχνότητα απενεργοποιείται αυτόματα.",
  "settings.session.remember": "Αποθήκευση χρησιμοποιημένων συχνοτήτων",
  "settings.session.rememberHint": "Εάν ενεργοποιηθεί, οι συχνότητες που συντονίζετε εμφανίζονται ως συντομεύσεις στην πλαϊνή μπάρα.",
  "settings.account.title": "Λογαριασμός",
  "settings.account.idLabel": "Το syphrax id σας",
  "settings.account.email": "Προαιρετικό email (μόνο για ανάκτηση, ποτέ δημόσιο)",
  "settings.account.emailPh": "email@παραδειγμα.com",
  "settings.account.changePassword": "Αλλαγή κωδικού",
  "settings.account.currentPw": "Τρέχων κωδικός",
  "settings.account.newPw": "Νέος κωδικός (ελάχ. 8)",
  "settings.account.confirmPw": "Επανάληψη νέου",
  "settings.account.saving": "Αποθήκευση…",
  "settings.account.success": "Ο κωδικός ενημερώθηκε.",
  "settings.account.errPwBad": "Ο τρέχων κωδικός δεν είναι σωστός.",
  "settings.account.errPwShort": "Ο νέος κωδικός πρέπει να έχει τουλάχιστον 8 χαρακτήρες.",
  "settings.account.errPwMismatch": "Οι κωδικοί δεν ταιριάζουν.",
  "settings.language.title": "Γλώσσα",
  "settings.language.hint": "Επιλέξτε τη γλώσσα της διεπαφής. Η προτίμηση αποθηκεύεται σε αυτή τη συσκευή.",
  "settings.about.title": "Σχετικά με το Syphrax",
  "settings.about.version": "Έκδοση MVP υπό ανάπτυξη.",
  "settings.about.tech": "E2E κρυπτογράφηση με NaCl box (X25519). Συχνότητες: παραγωγή Argon2id + ντετερμινιστικό HMAC.",
  "modal.freq.title": "Συντονισμός συχνότητας",
  "modal.freq.hint": "Εισάγετε τη μυστική συμβολοσειρά της συχνότητας.",
  "modal.freq.placeholder": "ALFA2025",
  "modal.freq.activate": "Ενεργοποίηση",
  "modal.freq.deriving": "Παραγωγή κλειδιού…",
  "modal.freq.warn": "Αν ξεχάσετε αυτή τη συμβολοσειρά, θα χάσετε την πρόσβαση στις συνομιλίες αυτής της συχνότητας.",
  "modal.freq.errShort": "Η συχνότητα πρέπει να έχει τουλάχιστον 8 χαρακτήρες.",
  "modal.freq.errCommon": "Αυτή η συμβολοσειρά είναι πολύ κοινή.",
  "modal.freq.errRepeat": "Μη χρησιμοποιείτε έναν επαναλαμβανόμενο χαρακτήρα.",
  "modal.freq.errSeqNum": "Αποφύγετε προφανείς αριθμητικές ακολουθίες.",
  "modal.freq.errSeqAlpha": "Αποφύγετε αλφαβητικές ακολουθίες.",
  "modal.share.title": "Κοινή χρήση επαφής",
  "modal.share.hint": "Επιλέξτε επαφή από τη λίστα ή εισάγετε syphrax id χειροκίνητα.",
  "modal.share.filter": "Φιλτράρισμα επαφών…",
  "modal.share.empty": "Καμία επαφή σε αυτή τη συχνότητα",
  "modal.share.manual": "Ή syphrax id χειροκίνητα",
  "modal.share.btn": "Κοινή χρήση",
  "modal.group.title": "Νέα ομάδα",
  "modal.group.hint": "Επιλέξτε όνομα και μέλη από τις επαφές σας σε αυτή τη συχνότητα.",
  "modal.group.namePh": "Όνομα ομάδας",
  "modal.group.selected": "{0} επιλεγμένα",
  "modal.group.create": "Δημιουργία ομάδας",
  "modal.remember.title": "Αποθήκευση αυτής της συσκευής",
  "modal.remember.hint": "Η συνεδρία, οι επαφές, οι ομάδες και τα μηνύματα σας θα αποθηκευτούν σε αυτή τη συσκευή, κρυπτογραφημένα με PIN που γνωρίζετε μόνο εσείς.",
  "modal.remember.pin": "PIN",
  "modal.remember.confirm": "Επανάληψη PIN",
  "modal.remember.warn": "Αν ξεχάσετε το PIN, τα αποθηκευμένα δεδομένα δεν μπορούν να ανακτηθούν.",
  "modal.remember.errShort": "Το PIN πρέπει να έχει τουλάχιστον 4 χαρακτήρες.",
  "modal.remember.errMismatch": "Τα PIN δεν ταιριάζουν.",
  "stickers.faces": "Πρόσωπα",
  "stickers.gestures": "Χειρονομίες",
  "stickers.hearts": "Καρδιές",
  "stickers.symbols": "Σύμβολα",
  "stickers.animals": "Ζώα",
  "stickers.food": "Φαγητό",
  "ttl.1h": "1 ώρα",
  "ttl.1d": "1 ημέρα",
  "ttl.1w": "1 εβδομάδα",
  "ttl.1m": "1 μήνας",
  "ttl.6m": "6 μήνες",
  "ttl.12m": "12 μήνες",
  "timeout.5min": "5 λεπτά",
  "timeout.15min": "15 λεπτά",
  "timeout.30min": "30 λεπτά",
  "timeout.never": "Ποτέ",
  "toast.newMessage": "Νέο μήνυμα",
  "toast.group": "{0} (ομάδα)",
};

const ru: Catalog = {
  "common.cancel": "Отмена",
  "common.save": "Сохранить",
  "common.confirm": "Подтвердить",
  "common.close": "Закрыть",
  "common.add": "Добавить",
  "common.back": "Назад",
  "common.tagline": "Без частоты разговор не существует.",
  "auth.tagline": "Приватные сообщения по частоте",
  "auth.loading": "Загрузка…",
  "auth.savedSession": "На этом устройстве есть сохранённая сессия.",
  "auth.tab.login": "Войти",
  "auth.tab.register": "Создать аккаунт",
  "auth.field.devicePin": "PIN устройства",
  "auth.field.username": "Пользователь",
  "auth.field.password": "Пароль",
  "auth.btn.unlock": "Разблокировать",
  "auth.btn.unlocking": "Разблокировка…",
  "auth.btn.processing": "Обработка…",
  "auth.btn.useOther": "Другой аккаунт",
  "auth.btn.forget": "Забыть это устройство",
  "auth.btn.backToUnlock": "К разблокировке",
  "auth.confirmForget": "Забыть это устройство? Сохранённая сессия и кэшированные сообщения будут удалены.",
  "auth.error.userExists": "Такой пользователь уже существует. Выберите другого.",
  "auth.error.badCreds": "Неверный пользователь или пароль.",
  "auth.error.userNotFound": "Пользователь не найден.",
  "auth.error.cantConnect": "Не удалось подключиться к серверу.",
  "auth.error.badPin": "Неверный PIN.",
  "auth.footnote": "E2E шифрование с NaCl box. Частоты: Argon2id + детерминистический HMAC.",
  "sidebar.general": "Общая частота",
  "sidebar.freq": "Частота {0}",
  "sidebar.tune": "Настроить частоту",
  "sidebar.exitFreq": "Покинуть {0}",
  "sidebar.notifications": "Уведомления",
  "sidebar.remember": "Запомнить устройство",
  "sidebar.forget": "Забыть устройство",
  "sidebar.addContact": "Добавить контакт по Syphrax ID",
  "sidebar.newGroup": "Новая группа",
  "sidebar.settings": "Настройки",
  "sidebar.logout": "Выйти",
  "sidebar.tooltip.logout": "Выйти и стереть все локальные данные",
  "sidebar.savedFreq.tooltip": "Настроить {0}",
  "chat.empty": "Выберите или добавьте контакт",
  "welcome.title": "Добро пожаловать в Syphrax",
  "welcome.concept": "Syphrax — это приватный мессенджер на основе частот. Частота — это секретный ключ, который знаете вы и человек, с которым вы общаетесь. Без этого ключа разговор не существует — даже платформа не может его восстановить.",
  "welcome.step1": "Настройтесь на частоту, общую с человеком или группой, с которыми хотите поговорить.",
  "welcome.step2": "Добавьте их syphrax_id как контакт, или попросите их добавить ваш.",
  "welcome.step3": "Начните писать. Сообщения могут читать только те, кто разделяет ту же частоту.",
  "welcome.multidevice": "Каждое устройство хранит свои частоты и сообщения независимо. При входе с другого устройства вам потребуется снова настроиться на частоты.",
  "welcome.btnFreq": "Настроить частоту",
  "welcome.btnContacts": "Добавить контакт",
  "push.btnOn": "Уведомления ВКЛ",
  "push.btnOff": "Уведомления ВЫКЛ",
  "push.btnEnable": "Уведомления выключены. Нажмите, чтобы включить.",
  "push.btnDisable": "Уведомления включены. Нажмите, чтобы выключить.",
  "push.introTitle": "Прежде чем включить уведомления",
  "push.introBody": "В целях конфиденциальности уведомления Syphrax работают иначе, чем в других мессенджерах:",
  "push.introBullet1": "Содержимое сообщения не включается.",
  "push.introBullet2": "Ни имя, ни syphrax_id отправителя не отображаются.",
  "push.introBullet3": "Вы получите только уведомление \"новое сообщение\", чтобы открыть приложение и прочитать его в зашифрованном виде на вашем устройстве.",
  "push.introConfirm": "Включить уведомления",
  "chat.placeholder": "Напишите сообщение…",
  "chat.editPlaceholder": "Редактировать сообщение…",
  "chat.replyingTo": "Ответ {0}",
  "chat.editing": "Редактирование сообщения",
  "chat.confirmContact": "Добавить в контакты",
  "chat.unconfirmedBanner": "Этот пользователь написал вам, но его нет в ваших контактах. Пока вы его не добавите, ваше фото и информация ему не видны.",
  "chat.online": "в сети",
  "chat.lastSeen": "последний раз здесь {0}",
  "chat.tooltip.attach": "Прикрепить файл",
  "chat.tooltip.shareContact": "Поделиться контактом",
  "chat.tooltip.paste": "Вставить изображение из буфера",
  "chat.tooltip.stickers": "Стикеры",
  "chat.tooltip.callAudio": "Голосовой вызов",
  "chat.tooltip.callVideo": "Видеовызов",
  "chat.btn.send": "Отправить",
  "chat.uploading": "…",
  "preview.image": "📷 Изображение",
  "preview.video": "🎬 Видео",
  "preview.audio": "🎙 Аудио",
  "bubble.reply": "Ответить",
  "bubble.edit": "Изменить",
  "bubble.edited": "изменено",
  "bubble.contact.label": "Контакт Syphrax",
  "bubble.media.decrypting": "Расшифровка…",
  "bubble.media.failed": "Не удалось расшифровать файл.",
  "call.calling": "Вызов…",
  "call.incoming.audio": "Входящий вызов",
  "call.incoming.video": "Входящий видеовызов",
  "call.connecting": "Подключение…",
  "call.ending": "Завершение…",
  "call.accept": "Принять",
  "call.reject": "Отклонить",
  "call.hangup": "Завершить",
  "call.mic": "Микрофон",
  "call.camera": "Камера",
  "call.audioOut": "Выход звука",
  "call.audioOut.auto": "Авто",
  "call.error.notInFreq": "Для вызова нужно быть настроенным на частоту.",
  "error.notFound": "Ресурс не найден.",
  "error.notInFreq": "{0} ещё не настроился на эту частоту. Попросите по другому каналу настроиться.",
  "error.push.iosTooOld": "Твоя iOS старше 16.4. Обнови, чтобы получать уведомления.",
  "error.push.iosNotStandalone": "Чтобы получать уведомления на iPhone, установи Syphrax на главный экран: нажми Поделиться → На экран «Домой».",
  "error.expired": "Сессия истекла. Войдите снова.",
  "error.gone": "Файл истёк.",
  "error.invalid": "Неверные данные.",
  "error.server": "Ошибка сервера. Попробуйте снова.",
  "error.network": "Нет соединения с сервером.",
  "error.cantStartCall": "Не удалось начать вызов: {0}",
  "error.cantAcceptCall": "Не удалось принять вызов: {0}",
  "error.cantPaste": "Нет доступа к буферу обмена.",
  "error.noImageInClipboard": "В буфере нет изображения.",
  "error.clipboardUnsupported": "Браузер не позволяет читать буфер. Используйте Ctrl+V.",
  "error.selfContact": "Нельзя добавить самого себя.",
  "error.blocked": "Вы заблокировали этого пользователя.",
  "settings.title": "Настройки",
  "settings.close": "Закрыть",
  "settings.tab.profile": "👤 Профиль",
  "settings.tab.privacy": "🔒 Приватность",
  "settings.tab.messages": "✉ Сообщения",
  "settings.tab.blocked": "🚫 Заблокированные",
  "settings.tab.notifications": "🔔 Уведомления",
  "settings.tab.session": "⏱ Сессия",
  "settings.tab.account": "🆔 Аккаунт",
  "settings.tab.language": "🌐 Язык",
  "settings.tab.about": "ℹ О приложении",
  "settings.scope.global": "Глобально (общая частота)",
  "settings.scope.freq": "Только на {0}",
  "settings.profile.title": "Профиль",
  "settings.profile.hintGlobal": "Эти значения используются по умолчанию и наследуются во всех частотах.",
  "settings.profile.hintFreq": "Они переопределяют глобальный профиль когда вы на {0}. Если что-то не задано здесь, наследуется из глобального.",
  "settings.profile.displayName": "Отображаемое имя",
  "settings.profile.displayNamePh.global": "(без имени — будет показан ваш syphrax id)",
  "settings.profile.displayNamePh.freq": "(наследует от глобального)",
  "settings.profile.photo": "Фото профиля",
  "settings.profile.changePhoto": "Сменить фото",
  "settings.profile.removePhoto": "Удалить фото",
  "settings.profile.info": "Инфо / Статус",
  "settings.profile.infoPh": "Привет, я использую Syphrax",
  "settings.profile.removeOverride": "Удалить переопределение {0}",
  "settings.profile.warn": "Изменения будут автоматически отправлены вашим контактам когда вы взаимодействуете с ними на этой частоте.",
  "settings.privacy.title": "Приватность",
  "settings.privacy.hintGlobal": "Настройте, кто может видеть каждую вашу информацию по умолчанию.",
  "settings.privacy.hintFreq": "Переопределяет эти правила только когда вы на {0}.",
  "settings.privacy.showPhoto": "Кто видит моё фото",
  "settings.privacy.showInfo": "Кто видит мою инфо / статус",
  "settings.privacy.showLastSeen": "Кто видит последний визит",
  "settings.privacy.showOnline": "Кто видит онлайн ли я",
  "settings.privacy.whoAdds": "Кто может добавить меня в группы",
  "settings.privacy.readReceipts": "Уведомления о прочтении",
  "settings.privacy.readReceiptsHint": "Если отключите, синие галочки не отправляются при прочтении сообщений. Вы также не увидите чужие.",
  "settings.vis.all": "Все",
  "settings.vis.contacts": "Мои контакты",
  "settings.vis.none": "Никто",
  "settings.messages.title": "Сообщения",
  "settings.messages.ttl": "Срок по умолчанию",
  "settings.messages.ttlHint": "Сообщения, которые вы отправляете, будут удалены с сервера через это время.",
  "settings.blocked.title": "Заблокированные",
  "settings.blocked.hint": "Заблокированные пользователи не могут отправлять вам сообщения.",
  "settings.blocked.placeholder": "syphrax id для блокировки",
  "settings.blocked.btn": "Заблокировать",
  "settings.blocked.unblock": "Разблокировать",
  "settings.blocked.empty": "У вас никого не заблокировано.",
  "settings.notif.title": "Уведомления",
  "settings.notif.sound": "Звук",
  "settings.notif.preview": "Показывать предпросмотр сообщения",
  "settings.notif.vibration": "Вибрация (мобильный)",
  "settings.notif.hint": "Push-уведомления браузера отправляются только для сообщений на общей частоте.",
  "settings.session.title": "Сессия",
  "settings.session.timeout": "Закрыть частоту после бездействия",
  "settings.session.timeoutHint": "Если проведёте это время без использования приложения, активная частота автоматически отключится.",
  "settings.session.remember": "Запоминать использованные частоты",
  "settings.session.rememberHint": "Если включено, частоты на которые вы настраиваетесь появляются как ярлыки в боковой панели.",
  "settings.account.title": "Аккаунт",
  "settings.account.idLabel": "Ваш syphrax id",
  "settings.account.email": "Email опционально (только для восстановления, никогда не публикуется)",
  "settings.account.emailPh": "email@пример.com",
  "settings.account.changePassword": "Сменить пароль",
  "settings.account.currentPw": "Текущий пароль",
  "settings.account.newPw": "Новый пароль (мин. 8)",
  "settings.account.confirmPw": "Повторите новый",
  "settings.account.saving": "Сохранение…",
  "settings.account.success": "Пароль обновлён.",
  "settings.account.errPwBad": "Текущий пароль неверный.",
  "settings.account.errPwShort": "Новый пароль должен содержать минимум 8 символов.",
  "settings.account.errPwMismatch": "Пароли не совпадают.",
  "settings.language.title": "Язык",
  "settings.language.hint": "Выберите язык интерфейса. Настройка сохраняется на этом устройстве.",
  "settings.about.title": "О Syphrax",
  "settings.about.version": "Версия MVP в разработке.",
  "settings.about.tech": "E2E шифрование с NaCl box (X25519). Частоты: вывод Argon2id + детерминистический HMAC.",
  "modal.freq.title": "Настроить частоту",
  "modal.freq.hint": "Введите секретную строку частоты.",
  "modal.freq.placeholder": "ALFA2025",
  "modal.freq.activate": "Активировать",
  "modal.freq.deriving": "Вывод ключа…",
  "modal.freq.warn": "Если забудете эту строку, потеряете доступ к разговорам этой частоты.",
  "modal.freq.errShort": "Частота должна содержать минимум 8 символов.",
  "modal.freq.errCommon": "Эта строка слишком распространённая.",
  "modal.freq.errRepeat": "Не используйте один повторяющийся символ.",
  "modal.freq.errSeqNum": "Избегайте очевидных числовых последовательностей.",
  "modal.freq.errSeqAlpha": "Избегайте алфавитных последовательностей.",
  "modal.share.title": "Поделиться контактом",
  "modal.share.hint": "Выберите контакт из списка или введите syphrax id вручную.",
  "modal.share.filter": "Фильтр контактов…",
  "modal.share.empty": "Нет контактов на этой частоте",
  "modal.share.manual": "Или syphrax id вручную",
  "modal.share.btn": "Поделиться",
  "modal.group.title": "Новая группа",
  "modal.group.hint": "Выберите имя и участников из ваших контактов на этой частоте.",
  "modal.group.namePh": "Название группы",
  "modal.group.selected": "Выбрано: {0}",
  "modal.group.create": "Создать группу",
  "modal.remember.title": "Запомнить это устройство",
  "modal.remember.hint": "Ваша сессия, контакты, группы и сообщения будут сохранены на этом устройстве, зашифрованные PIN-кодом, известным только вам.",
  "modal.remember.pin": "PIN",
  "modal.remember.confirm": "Повторите PIN",
  "modal.remember.warn": "Если забудете PIN, сохранённые данные не получится восстановить.",
  "modal.remember.errShort": "PIN должен содержать минимум 4 символа.",
  "modal.remember.errMismatch": "PIN-коды не совпадают.",
  "stickers.faces": "Лица",
  "stickers.gestures": "Жесты",
  "stickers.hearts": "Сердца",
  "stickers.symbols": "Символы",
  "stickers.animals": "Животные",
  "stickers.food": "Еда",
  "ttl.1h": "1 час",
  "ttl.1d": "1 день",
  "ttl.1w": "1 неделя",
  "ttl.1m": "1 месяц",
  "ttl.6m": "6 месяцев",
  "ttl.12m": "12 месяцев",
  "timeout.5min": "5 мин",
  "timeout.15min": "15 мин",
  "timeout.30min": "30 мин",
  "timeout.never": "Никогда",
  "toast.newMessage": "Новое сообщение",
  "toast.group": "{0} (группа)",
};

const uk: Catalog = {
  "common.cancel": "Скасувати",
  "common.save": "Зберегти",
  "common.confirm": "Підтвердити",
  "common.close": "Закрити",
  "common.add": "Додати",
  "common.back": "Назад",
  "common.tagline": "Без частоти розмова не існує.",
  "auth.tagline": "Приватні повідомлення за частотою",
  "auth.loading": "Завантаження…",
  "auth.savedSession": "На цьому пристрої збережена сесія.",
  "auth.tab.login": "Увійти",
  "auth.tab.register": "Створити обліковий запис",
  "auth.field.devicePin": "PIN пристрою",
  "auth.field.username": "Користувач",
  "auth.field.password": "Пароль",
  "auth.btn.unlock": "Розблокувати",
  "auth.btn.unlocking": "Розблокування…",
  "auth.btn.processing": "Обробка…",
  "auth.btn.useOther": "Інший обліковий запис",
  "auth.btn.forget": "Забути цей пристрій",
  "auth.btn.backToUnlock": "До розблокування",
  "auth.confirmForget": "Забути цей пристрій? Збережена сесія та кешовані повідомлення будуть видалені.",
  "auth.error.userExists": "Такий користувач вже існує. Виберіть іншого.",
  "auth.error.badCreds": "Неправильний користувач або пароль.",
  "auth.error.userNotFound": "Користувача не знайдено.",
  "auth.error.cantConnect": "Не вдалося підключитися до сервера.",
  "auth.error.badPin": "Неправильний PIN.",
  "auth.footnote": "E2E шифрування з NaCl box. Частоти: Argon2id + детермінований HMAC.",
  "sidebar.general": "Загальна частота",
  "sidebar.freq": "Частота {0}",
  "sidebar.tune": "Налаштувати частоту",
  "sidebar.exitFreq": "Вийти з {0}",
  "sidebar.notifications": "Сповіщення",
  "sidebar.remember": "Запам'ятати пристрій",
  "sidebar.forget": "Забути пристрій",
  "sidebar.addContact": "Додати контакт за Syphrax ID",
  "sidebar.newGroup": "Нова група",
  "sidebar.settings": "Налаштування",
  "sidebar.logout": "Вийти",
  "sidebar.tooltip.logout": "Вийти і видалити локальні дані",
  "sidebar.savedFreq.tooltip": "Налаштувати {0}",
  "chat.empty": "Виберіть або додайте контакт",
  "welcome.title": "Ласкаво просимо до Syphrax",
  "welcome.concept": "Syphrax — це приватний обмін повідомленнями на основі частот. Частота — це секретний ключ, який знаєте ви та людина, з якою ви спілкуєтесь. Без цього ключа розмова не існує — навіть платформа не може її відновити.",
  "welcome.step1": "Налаштуйтесь на частоту, спільну з людиною або групою, з якими хочете поговорити.",
  "welcome.step2": "Додайте її syphrax_id як контакт, або попросіть її додати ваш.",
  "welcome.step3": "Почніть писати. Повідомлення можуть читати лише ті, хто має ту саму частоту.",
  "welcome.multidevice": "Кожен пристрій зберігає свої частоти та повідомлення окремо. Якщо ви входите з іншого пристрою, потрібно знову налаштуватися на частоти.",
  "welcome.btnFreq": "Налаштувати частоту",
  "welcome.btnContacts": "Додати контакт",
  "push.btnOn": "Сповіщення УВІМК",
  "push.btnOff": "Сповіщення ВИМК",
  "push.btnEnable": "Сповіщення вимкнені. Натисніть, щоб увімкнути.",
  "push.btnDisable": "Сповіщення увімкнені. Натисніть, щоб вимкнути.",
  "push.introTitle": "Перш ніж увімкнути сповіщення",
  "push.introBody": "З міркувань конфіденційності сповіщення Syphrax працюють інакше, ніж в інших месенджерах:",
  "push.introBullet1": "Вміст повідомлення не включається.",
  "push.introBullet2": "Ні ім'я, ні syphrax_id відправника не показуються.",
  "push.introBullet3": "Ви отримаєте лише сповіщення \"нове повідомлення\", щоб відкрити додаток і прочитати його зашифрованим на вашому пристрої.",
  "push.introConfirm": "Увімкнути сповіщення",
  "chat.placeholder": "Напишіть повідомлення…",
  "chat.editPlaceholder": "Редагувати повідомлення…",
  "chat.replyingTo": "Відповідь {0}",
  "chat.editing": "Редагування повідомлення",
  "chat.confirmContact": "Додати в контакти",
  "chat.unconfirmedBanner": "Цей користувач написав вам, але його немає у ваших контактах. Поки ви не додасте його, ваше фото й інформація не будуть йому видні.",
  "chat.online": "у мережі",
  "chat.lastSeen": "востаннє тут {0}",
  "chat.tooltip.attach": "Прикріпити файл",
  "chat.tooltip.shareContact": "Поділитися контактом",
  "chat.tooltip.paste": "Вставити зображення з буфера",
  "chat.tooltip.stickers": "Стікери",
  "chat.tooltip.callAudio": "Голосовий виклик",
  "chat.tooltip.callVideo": "Відеовиклик",
  "chat.btn.send": "Надіслати",
  "chat.uploading": "…",
  "preview.image": "📷 Зображення",
  "preview.video": "🎬 Відео",
  "preview.audio": "🎙 Аудіо",
  "bubble.reply": "Відповісти",
  "bubble.edit": "Редагувати",
  "bubble.edited": "відредаговано",
  "bubble.contact.label": "Контакт Syphrax",
  "bubble.media.decrypting": "Розшифрування…",
  "bubble.media.failed": "Не вдалося розшифрувати файл.",
  "call.calling": "Виклик…",
  "call.incoming.audio": "Вхідний виклик",
  "call.incoming.video": "Вхідний відеовиклик",
  "call.connecting": "З'єднання…",
  "call.ending": "Завершення…",
  "call.accept": "Прийняти",
  "call.reject": "Відхилити",
  "call.hangup": "Завершити",
  "call.mic": "Мікрофон",
  "call.camera": "Камера",
  "call.audioOut": "Вихід звуку",
  "call.audioOut.auto": "Авто",
  "call.error.notInFreq": "Для виклику потрібно бути на частоті.",
  "error.notFound": "Ресурс не знайдено.",
  "error.notInFreq": "{0} ще не налаштувався на цю частоту. Попросіть іншим каналом налаштуватися.",
  "error.push.iosTooOld": "Твоя iOS старіша за 16.4. Онови, щоб отримувати сповіщення.",
  "error.push.iosNotStandalone": "Щоб отримувати сповіщення на iPhone, встанови Syphrax на головний екран: натисни Поділитися → На екран «Початок».",
  "error.expired": "Сесія закінчилася.",
  "error.gone": "Файл застарів.",
  "error.invalid": "Недійсні дані.",
  "error.server": "Помилка сервера. Спробуйте знову.",
  "error.network": "Немає з'єднання з сервером.",
  "error.cantStartCall": "Не вдалося розпочати виклик: {0}",
  "error.cantAcceptCall": "Не вдалося прийняти виклик: {0}",
  "error.cantPaste": "Немає доступу до буфера обміну.",
  "error.noImageInClipboard": "У буфері немає зображення.",
  "error.clipboardUnsupported": "Браузер не дозволяє читати буфер.",
  "error.selfContact": "Не можна додати себе.",
  "error.blocked": "Ви заблокували цього користувача.",
  "settings.title": "Налаштування",
  "settings.close": "Закрити",
  "settings.tab.profile": "👤 Профіль",
  "settings.tab.privacy": "🔒 Приватність",
  "settings.tab.messages": "✉ Повідомлення",
  "settings.tab.blocked": "🚫 Заблоковані",
  "settings.tab.notifications": "🔔 Сповіщення",
  "settings.tab.session": "⏱ Сесія",
  "settings.tab.account": "🆔 Обліковий запис",
  "settings.tab.language": "🌐 Мова",
  "settings.tab.about": "ℹ Про програму",
  "settings.scope.global": "Глобально (загальна частота)",
  "settings.scope.freq": "Тільки на {0}",
  "settings.profile.title": "Профіль",
  "settings.profile.hintGlobal": "Ці значення використовуються за замовчуванням і успадковуються на всіх частотах.",
  "settings.profile.hintFreq": "Вони перезаписують глобальний профіль коли ви на {0}. Якщо щось не задано тут, успадковується з глобального.",
  "settings.profile.displayName": "Відображуване ім'я",
  "settings.profile.displayNamePh.global": "(без імені — буде показано ваш syphrax id)",
  "settings.profile.displayNamePh.freq": "(успадковує з глобального)",
  "settings.profile.photo": "Фото профілю",
  "settings.profile.changePhoto": "Змінити фото",
  "settings.profile.removePhoto": "Видалити фото",
  "settings.profile.info": "Інфо / Статус",
  "settings.profile.infoPh": "Привіт, я використовую Syphrax",
  "settings.profile.removeOverride": "Видалити перевизначення {0}",
  "settings.profile.warn": "Зміни автоматично надішлються вашим контактам коли ви взаємодієте з ними на цій частоті.",
  "settings.privacy.title": "Приватність",
  "settings.privacy.hintGlobal": "Налаштуйте хто може бачити кожну вашу інформацію за замовчуванням.",
  "settings.privacy.hintFreq": "Перезаписує ці правила тільки коли ви на {0}.",
  "settings.privacy.showPhoto": "Хто бачить моє фото",
  "settings.privacy.showInfo": "Хто бачить моє інфо / статус",
  "settings.privacy.showLastSeen": "Хто бачить останнє відвідування",
  "settings.privacy.showOnline": "Хто бачить чи я онлайн",
  "settings.privacy.whoAdds": "Хто може додати мене в групи",
  "settings.privacy.readReceipts": "Сповіщення про прочитання",
  "settings.privacy.readReceiptsHint": "Якщо вимкнете, не надсилаються сині галочки при прочитанні повідомлень. Ви також не побачите чужі.",
  "settings.vis.all": "Всі",
  "settings.vis.contacts": "Мої контакти",
  "settings.vis.none": "Ніхто",
  "settings.messages.title": "Повідомлення",
  "settings.messages.ttl": "Термін за замовчуванням",
  "settings.messages.ttlHint": "Повідомлення які ви надсилаєте будуть видалені з сервера через цей час.",
  "settings.blocked.title": "Заблоковані",
  "settings.blocked.hint": "Заблоковані користувачі не можуть надсилати вам повідомлення.",
  "settings.blocked.placeholder": "syphrax id для блокування",
  "settings.blocked.btn": "Заблокувати",
  "settings.blocked.unblock": "Розблокувати",
  "settings.blocked.empty": "У вас нікого не заблоковано.",
  "settings.notif.title": "Сповіщення",
  "settings.notif.sound": "Звук",
  "settings.notif.preview": "Показувати попередній перегляд повідомлення",
  "settings.notif.vibration": "Вібрація (мобільний)",
  "settings.notif.hint": "Push-сповіщення браузера надсилаються тільки для повідомлень на загальній частоті.",
  "settings.session.title": "Сесія",
  "settings.session.timeout": "Закрити частоту після бездіяльності",
  "settings.session.timeoutHint": "Якщо проведете цей час без використання застосунку, активна частота автоматично вимкнеться.",
  "settings.session.remember": "Запам'ятовувати використані частоти",
  "settings.session.rememberHint": "Якщо увімкнено, частоти на які ви налаштовуєтеся з'являються як ярлики в бічній панелі.",
  "settings.account.title": "Обліковий запис",
  "settings.account.idLabel": "Ваш syphrax id",
  "settings.account.email": "Email опціонально (тільки для відновлення, ніколи не публікується)",
  "settings.account.emailPh": "email@приклад.com",
  "settings.account.changePassword": "Змінити пароль",
  "settings.account.currentPw": "Поточний пароль",
  "settings.account.newPw": "Новий пароль (мін. 8)",
  "settings.account.confirmPw": "Повторіть новий",
  "settings.account.saving": "Збереження…",
  "settings.account.success": "Пароль оновлено.",
  "settings.account.errPwBad": "Поточний пароль неправильний.",
  "settings.account.errPwShort": "Новий пароль повинен містити щонайменше 8 символів.",
  "settings.account.errPwMismatch": "Паролі не співпадають.",
  "settings.language.title": "Мова",
  "settings.language.hint": "Виберіть мову інтерфейсу. Налаштування зберігається на цьому пристрої.",
  "settings.about.title": "Про Syphrax",
  "settings.about.version": "Версія MVP у розробці.",
  "settings.about.tech": "E2E шифрування з NaCl box (X25519). Частоти: виведення Argon2id + детермінований HMAC.",
  "modal.freq.title": "Налаштувати частоту",
  "modal.freq.hint": "Введіть таємний рядок частоти.",
  "modal.freq.placeholder": "ALFA2025",
  "modal.freq.activate": "Активувати",
  "modal.freq.deriving": "Виведення ключа…",
  "modal.freq.warn": "Якщо забудете цей рядок, втратите доступ до розмов цієї частоти.",
  "modal.freq.errShort": "Частота повинна містити щонайменше 8 символів.",
  "modal.freq.errCommon": "Цей рядок надто поширений.",
  "modal.freq.errRepeat": "Не використовуйте один повторюваний символ.",
  "modal.freq.errSeqNum": "Уникайте очевидних числових послідовностей.",
  "modal.freq.errSeqAlpha": "Уникайте алфавітних послідовностей.",
  "modal.share.title": "Поділитися контактом",
  "modal.share.hint": "Виберіть контакт зі списку або введіть syphrax id вручну.",
  "modal.share.filter": "Фільтр контактів…",
  "modal.share.empty": "Немає контактів на цій частоті",
  "modal.share.manual": "Або syphrax id вручну",
  "modal.share.btn": "Поділитися",
  "modal.group.title": "Нова група",
  "modal.group.hint": "Виберіть ім'я та учасників з ваших контактів на цій частоті.",
  "modal.group.namePh": "Назва групи",
  "modal.group.selected": "Вибрано: {0}",
  "modal.group.create": "Створити групу",
  "modal.remember.title": "Запам'ятати цей пристрій",
  "modal.remember.hint": "Ваша сесія, контакти, групи та повідомлення будуть збережені на цьому пристрої, зашифровані PIN-кодом, відомим тільки вам.",
  "modal.remember.pin": "PIN",
  "modal.remember.confirm": "Повторіть PIN",
  "modal.remember.warn": "Якщо забудете PIN, збережені дані не вдасться відновити.",
  "modal.remember.errShort": "PIN повинен містити щонайменше 4 символи.",
  "modal.remember.errMismatch": "PIN-коди не співпадають.",
  "stickers.faces": "Обличчя",
  "stickers.gestures": "Жести",
  "stickers.hearts": "Серця",
  "stickers.symbols": "Символи",
  "stickers.animals": "Тварини",
  "stickers.food": "Їжа",
  "ttl.1h": "1 година",
  "ttl.1d": "1 день",
  "ttl.1w": "1 тиждень",
  "ttl.1m": "1 місяць",
  "ttl.6m": "6 місяців",
  "ttl.12m": "12 місяців",
  "timeout.5min": "5 хв",
  "timeout.15min": "15 хв",
  "timeout.30min": "30 хв",
  "timeout.never": "Ніколи",
  "toast.newMessage": "Нове повідомлення",
  "toast.group": "{0} (група)",
};

const catalogs: Record<Locale, Catalog> = { es, en, pt, fr, it, de, nl, pl, cs, hu, ro, el, ru, uk };

const STORAGE_KEY = 'syphrax_locale';
let currentLocale: Locale = detectLocale();
const listeners = new Set<() => void>();

function detectLocale(): Locale {
  try {
    const saved = localStorage.getItem(STORAGE_KEY) as Locale | null;
    if (saved && saved in catalogs) return saved;
  } catch (_e) { /* ignore */ }
  const browser = (navigator.language || 'es').toLowerCase().slice(0, 2);
  if (browser in catalogs) return browser as Locale;
  return 'es';
}

export function getLocale(): Locale {
  return currentLocale;
}

export function setLocale(loc: Locale): void {
  if (!(loc in catalogs)) return;
  currentLocale = loc;
  try { localStorage.setItem(STORAGE_KEY, loc); } catch (_e) { /* ignore */ }
  for (const l of listeners) {
    try { l(); } catch (_e) { /* ignore */ }
  }
}

export function onLocaleChange(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function t(key: string, ...args: Array<string | number>): string {
  const cat = catalogs[currentLocale] || es;
  let msg = cat[key] || es[key] || key;
  if (args.length) {
    for (let i = 0; i < args.length; i++) {
      msg = msg.replace('{' + i + '}', String(args[i]));
    }
  }
  return msg;
}

import { useEffect, useState } from 'react';

export function useTranslation() {
  const [, force] = useState(0);
  useEffect(() => onLocaleChange(() => force((x) => x + 1)), []);
  return { t, locale: currentLocale, setLocale, locales: LOCALES };
}
